import { AppLanguage } from './i18n.types';

export const APP_TRANSLATIONS: Record<AppLanguage, Record<string, string>> = {
  en: {
    'basicInfo.contact': 'Contact',
    'basicInfo.timeZoneLanguage': 'Time Zone & Language',
    'basicInfo.dateTime': 'Date & Time',
    'basicInfo.fullName': 'Full Name',
    'basicInfo.fullNamePlaceholder': 'Enter your full name',
    'basicInfo.email': 'Email',
    'basicInfo.emailPlaceholder': 'Enter your email',
    'basicInfo.mobileNumber': 'Mobile Number',
    'basicInfo.mobileNumberPlaceholder': 'Enter your mobile number',
    'basicInfo.continentOrCountry': 'Continent or Country',
    'basicInfo.cityOrZone': 'City or Zone',
    'basicInfo.language': 'Language',
    'basicInfo.dateFormat': 'Date Format',
    'basicInfo.timeFormat': 'Time Format',
    'basicInfo.firstDayOfWeek': 'First Day of Week',
    'basicInfo.timeFormat12': '12 Hour | 5:14 PM',
    'basicInfo.timeFormat24': '24 Hour | 17:14',
    'basicInfo.sunday': 'Sunday',
    'basicInfo.monday': 'Monday',
    'basicInfo.save': 'Save',
    'basicInfo.saving': 'Saving...',
    'basicInfo.requestDeletion': 'Request full profile deletion',
    'basicInfo.validationTitle': 'Validation Error',
    'basicInfo.validationFullName': 'Please enter a valid full name (min 2 characters, letters only).',
    'basicInfo.validationEmail': 'Please enter a valid email address.',
    'basicInfo.validationMobile': 'Please enter a valid mobile number (8-15 digits).',
    'basicInfo.successTitle': 'Success',
    'basicInfo.successMessage': 'Profile updated successfully!',
    'basicInfo.countryLoadFailed': 'Country list load failed.',
    'basicInfo.cityLoadFailed': 'City list load failed.',
    'basicInfo.profileLoadFailed': 'User profile load failed.',
    'basicInfo.profileUpdateFailed': 'Profile update failed.',
    'select.placeholder.continent': 'Select Continent or Country',
    'select.placeholder.city': 'Select City or Zone',
    'select.placeholder.code': 'Code',
    'select.searchPlaceholder': 'Search options...',
    'select.noOptions': 'No options found',
    'select.loading': 'Loading options...',
    'select.addNewInputPlaceholder': 'Enter new option name',
    'select.add': 'Add',
    'select.cancel': 'Cancel',
    'select.invalidNewOption': 'Option name must be at least 3 characters long and contain only valid characters.',
    'language.en': 'English',
    'language.id': 'Indonesia',
    'language.es': 'Spanish',

    'common.user': 'User',
    'common.thisItem': 'this item',
    'breadcrumb.home': 'Home',
    'breadcrumb.accountSettings': 'Account Settings',

    'nav.welcome': 'Welcome',
    'nav.inventory': 'Inventory',
    'nav.inventory.manage': 'Manage',
    'nav.inventory.bookings': 'Bookings',
    'nav.inventory.performance': 'Performance',
    'nav.inventory.availability': 'Availability',
    'nav.inventory.pricing': 'Pricing',
    'nav.inventory.audience': 'Audience',
    'nav.campaign': 'Campaign',

    'menu.notifications.title': 'Notifications',
    'menu.notifications.clear': 'Clear',
    'menu.notifications.empty': 'No notifications yet',
    'menu.notifications.soundOn': 'Turn on sound',
    'menu.notifications.soundOff': 'Turn off sound',
    'menu.profile': 'Profile',
    'menu.subscription': 'Subscription',
    'menu.inventory': 'Inventory',
    'menu.campaign': 'Campaign',
    'menu.video-editor': 'Video Editor',
    'menu.wallet': 'Wallet',
    'menu.docs': 'Documentation',
    'menu.docs.accessDenied': 'You do not have access to documentation.',
    'menu.docs.accessFailed': 'Documentation access token was not returned.',
    'menu.logout': 'Logout',
    'menu.users': 'Users',
    'menu.upload.completed.title': 'Upload Completed',
    'menu.upload.completed.message': 'All files processed. Completed: {{completed}}',
    'menu.upload.issues.title': 'Upload Issues',
    'menu.upload.status.title': 'Upload Status',
    'menu.upload.status.loadFailed': 'Failed to load upload queue status.',

    'header.logoAlt': 'Company Logo',
    'header.clientLogoAlt': 'Client Dashboard Logo',

    'footer.rightsReserved': 'All Rights Reserved.',
    'footer.scrollTop': 'Scroll to top',

    'welcome.startCampaign': 'Start Campaign',
    'welcome.addMediaSpot': 'Add Media Spot',
    'welcome.growTitle': 'Grow Your Business with Us',
    'welcome.startCampaign.desc': 'Adding more campaigns increases your visibility to potential audiences.',
    'welcome.addMediaSpot.desc': 'Add a new media spot to increase your visibility.',
    'welcome.illustrationAlt': 'Digital Media Illustration',
    'welcome.card1.title': 'Looking for Digital Screens but Not Sure Where to Start?',
    'welcome.card1.desc': 'We can help provide affordable, easy-to-set-up, and ready-to-go solutions—no technical skills needed.',
    'welcome.card1.cta': 'Shop Now',
    'welcome.card2.imageAlt': 'Manual Documentation',
    'welcome.card2.title': 'Need Help? We’ve Got You Covered!',
    'welcome.card2.desc': 'Explore our documentation or FAQs to get the most out of our platform.',
    'welcome.card2.cta': 'Get Help',
    'welcome.card3.imageAlt': 'Support',
    'welcome.card3.title': 'Watch Our Step-by-Step Video Tutorials',
    'welcome.card3.desc': 'The easiest way to get started and master our platform.',
    'welcome.card3.cta': 'Watch Video',

    'common.yes': 'Yes',
    'common.no': 'No',
    'common.edit': 'Edit',
    'common.delete': 'Delete',
    'common.review': 'Review',
    'common.cancel': 'Cancel',
    'common.confirm': 'Confirm',
    'common.error': 'Error',
    'common.success': 'Success',
    'common.turnOn': 'Turn On',
    'common.save': 'Save',
    'common.na': 'N/A',
    'common.retry': 'Retry',
    'common.detail': 'Detail',
    'common.replace': 'Replace',
    'common.accept': 'Accept',
    'common.decline': 'Decline',
    'common.play': 'Play',
    'common.pause': 'Pause',
    'common.mute': 'Mute',
    'common.unmute': 'Unmute',
    'common.restart': 'Restart',
    'common.upload': 'Upload',
    'common.change': 'Change',
    'common.back': 'Back',
    'common.saving': 'Saving...',
    'common.validationError': 'Validation Error',
    'common.confirmDelete.title': 'Confirm Delete',
    'common.confirmDelete.message': 'Delete \"{{name}}\"?',
    'common.unauthorized': 'Unauthorized: token is missing or invalid.',
    'common.unexpectedError': 'An unexpected error occurred.',
    'layout.layout': 'Layout',
    'layout.selectTemplate': 'Select Layout Template',
    'layout.selectTemplateHint': 'Select a template on the left, then click Continue to configure content.',
    'layout.setLayout': 'Set Layout',
    'layout.continue': 'Continue',
    'layout.confirm': 'Confirm',
    'layout.editContent': 'Edit Widget Content',
    'layout.editContentHint': 'Configure content for non-creative areas in this template.',
    'layout.widget': 'Widget',
    'layout.runningText': 'Running Text',
    'layout.widgetUrl': 'Widget URL',
    'layout.runningTextContent': 'Running Text Content',
    'layout.runningTextPlaceholder': 'Enter text to display...',
    'layout.assignedSuccess': 'Layout assigned successfully.',
    'layout.assignFailed': 'Failed to assign layout.',
    'layout.backToScreens': '← Back to Screens',
    'layout.setLayoutFor': 'Set Layout for',
    'layout.saveLayout': 'Save Layout',
    'layout.preview': 'Preview',
    'layout.confirmTitle': 'Confirm Layout Change',
    'layout.confirmMessage': 'You will set this layout. Are you sure?',
    'layout.templateDifferentWarning': 'This is a different template from the one currently in use. Once confirmed, the change will take effect starting tomorrow at 00:00.',
    'layout.apply': 'Apply',
    'layout.successTitle': 'Layout Applied Successfully',
    'layout.successMessage': 'The new layout has been successfully set to screens.',
    'layout.selectType': 'Type',
    'layout.chooseType': '-- Select Type --',
    'layout.noConfigRequired': 'No additional configuration is required for this template.',

    'status.pending': 'Pending',
    'status.confirmed': 'Confirmed',
    'status.active': 'Active',
    'status.inactive': 'Inactive',
    'status.available': 'Available',
    'status.unavailable': 'Unavailable',
    'status.unknown': 'Unknown',

    'table.actions': 'Actions',
    'table.loading': 'Loading...',
    'table.selectedCount': '{{count}} item(s) selected',
    'table.deleteSelected': 'Delete Selected',
    'table.clearSelection': 'Clear Selection',
    'table.moreActions': 'More actions',
    'table.sort.asc': 'Sort ascending',
    'table.sort.desc': 'Sort descending',
    'table.sort.remove': 'Remove sort',
    'table.filter.filter': 'Filter {{column}}',
    'table.filter.select': 'Select {{column}}',
    'table.filter.all': 'All',
    'table.filter.from': 'From',
    'table.filter.to': 'to',
    'table.filter.toField': 'To',
    'table.filter.clear': 'Clear filter',
    'table.operator.contains': 'Contains',
    'table.operator.equals': 'Equals',
    'table.operator.startsWith': 'Starts with',
    'table.operator.endsWith': 'Ends with',
    'table.operator.greaterThan': 'Greater than',
    'table.operator.lessThan': 'Less than',
    'table.operator.between': 'Between',
    'table.operator.after': 'After',
    'table.operator.before': 'Before',
    'table.bulkDelete.noneSelected': 'No items selected.',
    'table.bulkDelete.invalidSelection': 'Selected items are not valid for deletion.',

    'pagination.itemsPerPage': 'Items per page:',
    'pagination.range': '{{start}}-{{end}} of {{total}} items',
    'pagination.first': 'First page',
    'pagination.prev': 'Previous page',
    'pagination.next': 'Next page',
    'pagination.last': 'Last page',
    'pagination.goToPage': 'Go to page {{page}}',

    'campaign.summary.total': 'Total Campaign',
    'campaign.summary.draft': 'Draft',
    'campaign.summary.active': 'Active',
    'campaign.summary.pending': 'Pending',
    'campaign.summary.paused': 'Paused',
    'campaign.summary.failed': 'Failed',
    'campaign.action.newCampaign': '+ New Campaign',
    'campaign.balance.accountBalance': 'Account Balance',
    'campaign.balance.campaignWallet': 'Campaign Wallet',
    'campaign.balance.allocated': 'Allocated Budget',
    'campaign.balance.remaining': 'Remaining Budget',
    'campaign.balance.spent': 'Spent Budget',
    'campaign.balance.avgSpending': 'Avg. Budget Spending',
    'campaign.balance.perDay': '/day',
    'campaign.table.title': 'Campaigns',
    'campaign.table.column.campaignName': 'Campaign Name',
    'campaign.table.column.spot': 'Spot',
    'campaign.table.column.venue': 'Venue',
    'campaign.table.column.budget': 'Budget',
    'campaign.table.column.period': 'Period',
    'campaign.table.column.status': 'Status',
    'campaign.status.draft': 'Draft',
    'campaign.status.active': 'Active',
    'campaign.status.pending': 'Pending',
    'campaign.status.paused': 'Paused',
    'campaign.status.failed': 'Failed',
    'campaign.spots.title': 'Spots Catalog',
    'campaign.spots.viewAll': 'View All',
    'campaign.error.summaryLoadFailed': 'Campaign summary load failed.',
    'campaign.error.listLoadFailed': 'Campaign list load failed.',

    'spots.retry': 'Try Again',
    'spots.openDetail': 'Open spot detail',
    'spots.imageAlt': 'Spot Image',
    'spots.screensCount': 'Screens count',
    'spots.alreadyInCampaign': 'Already in Campaign',
    'spots.addToCampaign': 'Add to Campaign',
    'spots.processing': 'Processing...',
    'spots.cancel': 'Cancel',
    'spots.empty.title': 'No spots available',
    'spots.empty.subtitle': 'Please try again or adjust the filters.',
    'spots.pagination.showing': 'Showing {{start}}–{{end}} of {{total}}',
    'spots.pagination.prev': 'Prev',
    'spots.pagination.next': 'Next',
    'spots.pagination.pageOf': 'Page {{page}} of {{total}}',
    'spots.error.loadFailed': 'Spot catalog load failed. Please try again.',

    'inventory.card.mediaSpot': 'Media Spot',
    'inventory.card.screen': 'Screen',
    'inventory.card.needUnlockScreenLimit': 'Need to unlock screen limit?',
    'inventory.card.upgradePackage': 'Upgrade Package',
    'inventory.chart.bookedVsAvailable': 'Booked vs Available',
    'inventory.chart.booked': 'Booked',
    'inventory.chart.available': 'Available',
    'inventory.chart.onlineVsOffline': 'Online vs Offline Screen',
    'inventory.chart.online': 'Online',
    'inventory.chart.offline': 'Offline',
    'inventory.ads.inHouseAds': 'In-house Ads',
    'inventory.ads.commercialAds': 'Commercial Ads',
    'inventory.revenue.todayRevenue': 'Today Revenue',
    'inventory.revenue.viewReport': 'View Report',
    'inventory.revenue.optimize': 'Optimize Revenue',
    'inventory.balance.totalBalance': 'Total Balance',
    'inventory.balance.autoWithdrawal.active': 'Auto-withdrawal is active.',
    'inventory.balance.autoWithdrawal.payouts': 'Payouts follow your schedule',
    'inventory.balance.autoWithdrawal.every': 'every {{schedule}}',
    'inventory.balance.autoWithdrawal.basedOnSettings': 'based on your payout settings.',
    'inventory.balance.changeSchedule': 'Change Schedule',
    'inventory.balance.requestWithdrawal': 'Request Withdrawal',
    'inventory.balance.autoWithdrawal': 'Auto-Withdrawal',
    'inventory.table.title.inventoryManagement': 'Inventory Management',
    'inventory.table.title.mediaSpotManagement': 'Media Spot Management',
    'inventory.action.add': 'Add',
    'inventory.action.addMediaSpot': 'Add Media Spot',
    'inventory.player.downloadTitle': 'Download Player',
    'inventory.player.downloadDesc': 'Download and install our player on your screen to get connected.',
    'inventory.player.learnMore': 'Learn more',
    'inventory.platform.alt': '{{name}} Platform',
    'inventory.upgrade.title': 'Upgrade Package',
    'inventory.upgrade.message': 'Upgrading your package currently requires assistance from our team. Reach out to us (email: {{email}}) and we\'ll help you switch plans smoothly.',

    'inventory.nav.manage': 'Media Spot',
    'inventory.nav.bookings': 'Bookings',
    'inventory.nav.performance': 'Performance',
    'inventory.nav.pricing': 'Pricing',
    'inventory.nav.audience': 'Audience',

    'inventory.manage.title': 'Media Spot Management',
    'inventory.manage.linkedHint': 'Screens in this spot play together',
    'inventory.manage.confirmedScreens': 'Confirmed Screens',
    'inventory.manage.pendingScreens': 'Pending Screens',
    'inventory.manage.offScreens': 'Screens Off',
    'inventory.manage.invalidSpotGroup': 'Invalid spot group.',
    'inventory.manage.confirmDelete.title': 'Confirm Delete',
    'inventory.manage.confirmDelete.message': 'Delete \"{{name}}\"?',
    'inventory.manage.deleteFailed': 'Spot delete failed.',
    'inventory.manage.deleteError': 'An error occurred while deleting the data.',
    'inventory.manage.action.addScreen': 'Add Screen',
    'inventory.manage.action.toggle': 'Toggle Status',
    'inventory.manage.detail.empty': 'No details available',
    'inventory.manage.toggle.title': 'Turn Off Media Spot',
    'inventory.manage.toggle.titleOn': 'Turn On Media Spot',
    'inventory.manage.toggle.warning.title': 'Warning',
    'inventory.manage.toggle.warning.description': 'The screen is currently delivering active campaign. Turning off the screen will immediately stop playback for:',
    'inventory.manage.toggle.warning.checkbox': 'I understand and agree that campaign interruption may result in penalties according to the applicable terms.',
    'inventory.manage.toggle.reasonLabel': 'Reason for powering off (shared with affected advertisers):',
    'inventory.manage.toggle.reasonPlaceholder': 'Please describe why you are turning off this media spot...',
    'inventory.manage.toggle.keepScreenOn': 'Keep Screen On',
    'inventory.manage.toggle.turnOffAnyway': 'Turn Off Anyway',
    'inventory.manage.toggle.turnOn.title': 'Turn On Media Spot',
    'inventory.manage.toggle.turnOn.description': 'This will turn on all screens under this media spot. The screens will resume normal operation.',
    'inventory.manage.toggle.turnOn.checkbox': 'I confirm that I want to turn on this media spot and all its screens.',
    'inventory.manage.toggle.turnOnAnyway': 'Turn On',
    'inventory.manage.toggle.confirm.title': 'Are you sure you want to power off the following screen(s)?',
    'inventory.manage.toggle.confirm.description': 'The following screen(s) will be powered off and stop all campaign playback.',
    'inventory.manage.toggle.confirm.table.screenName': 'Screen Name',
    'inventory.manage.toggle.confirm.table.spot': 'Spot',
    'inventory.manage.toggle.confirm.table.group': 'Group',
    'inventory.manage.toggle.confirm.yes': 'Yes',
    'inventory.manage.toggle.confirm.titleOn': 'Confirm Turn On',
    'inventory.manage.toggle.confirm.messageOn': 'Are you sure you want to turn on \"{{name}}\"?',
    'inventory.manage.toggle.success.title': 'Success',
    'inventory.manage.toggle.success.messageOff': 'Screen(s) powered off successfully.',
    'inventory.manage.toggle.success.messageOn': 'Screen(s) powered on successfully.',
    'inventory.manage.toggle.success.ok': 'OK',
    'inventory.manage.toggle.failed': 'Failed to toggle spot status.',

    'inventory.detail.screenName': 'Screen Name',
    'inventory.detail.serialNo': 'Serial No.',
    'inventory.detail.brand': 'Brand',
    'inventory.detail.model': 'Model',
    'inventory.detail.os': 'OS',
    'inventory.detail.player': 'Player',
    'inventory.detail.status': 'Status',
    'inventory.detail.screenStatus': 'Screen Status',
    'inventory.screen.column.deviceId': 'Device ID',
    'inventory.screen.column.orientation': 'Orientation',
    'inventory.orientation.landscape': 'Landscape',
    'inventory.orientation.portrait': 'Portrait',
    'inventory.screen.invalid': 'Invalid screen.',
    'inventory.screen.delete.success': 'Screen deleted successfully.',
    'inventory.screen.delete.failed': 'Failed to delete screen.',
    'inventory.screen.delete.httpFailed': 'Screen delete failed.',
    'inventory.screen.toggle.confirm.messageOn': 'Are you sure you want to turn on screen "{{name}}"?',
    'inventory.screen.action.turnOff': 'Turn Off',

    'inventory.bookings.title': 'Bookings Management',
    'inventory.bookings.column.bookingId': 'Booking ID',
    'inventory.bookings.column.advertiser': 'Advertiser',
    'inventory.bookings.column.campaign': 'Campaign',
    'inventory.bookings.column.mediaSpot': 'Media Spot',
    'inventory.bookings.column.period': 'Period',
    'inventory.bookings.column.autoCancel': 'Auto Cancel',
    'inventory.bookings.periodWithStart': '{{days}} days, start {{start}}',

    'inventory.availability.title': 'Availability Management',
    'inventory.performance.title': 'Performance Analytics',
    'inventory.pricing.title': 'Pricing Management',
    'inventory.audience.title': 'Audience Analytics',

    'inventory.column.spotName': 'Spot Name',
    'inventory.column.id': 'ID',
    'inventory.column.category': 'Category',
    'inventory.column.mediaType': 'Media Type',
    'inventory.column.office': 'Office',
    'inventory.column.pairedScreen': 'Paired Screen',
    'inventory.column.groupName': 'Group Name',
    'inventory.column.venueType': 'Venue Type',
    'inventory.column.group': 'Group',
    'inventory.column.status': 'Status',
    'inventory.column.syncStatus': 'Sync Status',
    'inventory.column.createdTime': 'Created Time',
    'inventory.column.updatedTime': 'Updated Time',
    'inventory.column.deletedTime': 'Deleted Time',
    'inventory.column.spotGroup': 'Spot Group',
    'inventory.column.screenLabel': 'Screen Label',
    'inventory.column.occupancy': 'Occupancy',
    'inventory.column.revenue': 'Revenue',
    'inventory.column.totalScreens': 'Total Screens',
    'inventory.column.thirdPartySlot': '3rd Party Slot',
    'inventory.column.value': 'Value',
    'inventory.column.promotion': 'Promotion',
    'inventory.column.specialOffer': 'Special Offer',
    'inventory.column.audienceType': 'Audience Type',
    'inventory.column.approxDailyFootfall': 'Approximate Daily Footfall',

    'inventory.mediaType.digitalSignage': 'Digital Signage',
    'inventory.mediaType.ledDisplay': 'LED Display',
    'inventory.mediaType.lcdMonitor': 'LCD Monitor',

    'inventory.empty.availability': 'No availability data',
    'inventory.empty.bookings': 'No bookings data',
    'inventory.empty.performance': 'No performance data at this time',
    'inventory.empty.pricing': 'No pricing data available',
    'inventory.empty.audience': 'No audience data found',

    'account.title': 'Account',
    'account.breadcrumb.main': 'Main',
    'account.license.title': 'License',
    'account.license.section.subscription.title': 'Subscription',
    'account.license.subscription.accountSubscription.title': 'Account Subscription',
    'account.license.subscription.accountSubscription.subtitle': 'Upgrade your subscription',
    'account.license.subscription.accountSubscription.badge': 'Free Basic - 1 Screen License',
    'account.license.subscription.addLicenses.title': 'Add Licenses',
    'account.license.subscription.addLicenses.subtitle': 'Add more licenses to better capture the imagination of your viewers',
    'account.license.subscription.changePlan.title': 'Change Plan',
    'account.license.subscription.changePlan.subtitle': 'Upgrade to Premium or Enterprise for more features.',
    'account.license.subscription.changePlan.badge': 'Upgrade to Premium',
    'account.license.section.users.title': 'Users',
    'account.license.users.usersCard.title': 'Users',
    'account.license.users.usersCard.subtitle': 'Add Users to your Account with different levels of access.',
    'account.license.users.usersCard.badge': '1 User',
    'account.license.users.groups.title': 'Groups',
    'account.license.users.groups.subtitle': 'Organize your users into Groups and assign roles on their primary or any other workspace.',
    'account.license.users.groups.badge': '0 Groups',
    'account.license.users.securityPolicies.title': 'Security Policies',
    'account.license.users.securityPolicies.subtitle': 'Apply password and session policies to your users. Set an IP Address Whitelist.',
    'account.license.users.sso.title': 'SSO (Single Sign On)',
    'account.license.users.sso.subtitle': 'Set up Single Sign On with your SAML Identity Provider.',
    'account.license.section.player.title': 'Player',
    'account.license.player.bootLogo.title': 'Player Boot Logo',
    'account.license.player.bootLogo.subtitle': 'Show your custom image or logo when your Players boot.',
    'account.license.section.advanced.title': 'Advanced Settings',
    'account.license.advanced.apiTokens.title': 'API Tokens',
    'account.license.advanced.apiTokens.subtitle': 'Use API tokens as secure keys to authenticate and authorise access to external applications and services.',
    'account.license.advanced.apiTokens.badge': 'Tokens',
    'account.license.advanced.auditLog.title': 'Audit Log',
    'account.license.advanced.auditLog.subtitle': 'Detailed records of activity for all Users within your Account.',
    'account.license.badge.disabled': 'Disabled',
    'account.license.badge.default': 'Default',
    'account.userManagement.title': 'User Management',
    'account.userManagement.members.title': 'Members',
    'account.userManagement.members.inviteUser': 'Invite User',
    'account.userManagement.members.column.fullName': 'Full Name',
    'account.userManagement.members.column.email': 'Email',
    'account.userManagement.members.column.groupOrder': 'Group',
    'account.userManagement.members.column.role': 'Role',
    'account.userManagement.members.column.lastActive': 'Last Active',
    'account.userManagement.members.column.invitedOn': 'Invited On',
    'account.userManagement.members.loadFailed': 'Failed to load member data.',
    'account.userManagement.groups.title': 'User Groups',
    'account.userManagement.groups.addGroup': 'Add Group',
    'account.userManagement.groups.column.groupName': 'Group Name',
    'account.userManagement.groups.column.members': 'Members',
    'account.userManagement.groups.column.dateCreated': 'Date Created',
    'account.userManagement.groups.loadFailed': 'Failed to load user groups.',
    'account.userManagement.groups.deleteSuccess': 'Group deleted.',
    'account.userManagement.groups.deleteFailed': 'Failed to delete group.',

    'account.menu.settings': 'Settings',
    'account.menu.business': 'Business',
    'account.menu.preference': 'Preference',
    'account.menu.favorite': 'Favorite',
    'account.menu.collaboard': 'CollaBoard',

    'account.settings.basicInfo': 'Basic Info',
    'account.settings.security': 'Security',
    'account.settings.notification': 'Notification',
    'account.settings.company': 'Company',
    'account.settings.payout': 'Payout',
    'account.settings.shared': 'Shared',
    'account.settings.invitation': 'Invitation',

    'account.inventoryMenu.mediaSpot.title': 'Media Spot',
    'account.inventoryMenu.spotGroup.title': 'Spot Group',
    'account.inventoryMenu.spotGroup.addGroup': 'Add Group',
    'account.inventoryMenu.spotGroup.column.groupName': 'Group Name',
    'account.inventoryMenu.spotGroup.column.excludeOffers': 'Exclude Offers',
    'account.inventoryMenu.spotGroup.invalidGroup': 'Invalid spot group.',
    'account.inventoryMenu.spotGroup.deleteFailed': 'An error occurred while deleting the data.',
    'account.inventoryMenu.spotGroup.bulkDeleteSuccess': 'Spot group deleted successfully.',
    'account.inventoryMenu.screens.title': 'Screens',

    'account.inventoryMenu.bookings.pending.title': 'Pending Bookings',
    'account.inventoryMenu.bookings.pending.empty': 'No pending bookings',
    'account.inventoryMenu.bookings.accepted.title': 'Accepted Bookings',
    'account.inventoryMenu.bookings.accepted.empty': 'No accepted bookings',
    'account.inventoryMenu.bookings.declined.title': 'Declined Bookings',
    'account.inventoryMenu.bookings.declined.empty': 'No declined bookings',
    'account.inventoryMenu.bookings.canceled.title': 'Canceled Bookings',
    'account.inventoryMenu.bookings.canceled.empty': 'No canceled bookings',
    'account.inventoryMenu.bookings.title': 'Bookings',
    'account.inventoryMenu.bookings.tab.pending': 'Pending',
    'account.inventoryMenu.bookings.tab.accepted': 'Accepted',
    'account.inventoryMenu.bookings.tab.declined': 'Declined',
    'account.inventoryMenu.bookings.tab.canceled': 'Canceled',
    'account.inventoryMenu.bookings.column.date': 'Date',
    'account.inventoryMenu.bookings.column.canceledBy': 'Canceled By',

    'account.inventoryMenu.screens.edit.title': 'Edit Screen',
    'account.inventoryMenu.screens.edit.section.screenInfo': 'Screen Information',
    'account.inventoryMenu.screens.edit.label.deviceId': 'Device ID',
    'account.inventoryMenu.screens.edit.label.brand': 'Brand',
    'account.inventoryMenu.screens.edit.label.model': 'Model',
    'account.inventoryMenu.screens.edit.label.osVersion': 'OS Version',
    'account.inventoryMenu.screens.edit.label.sdkVersion': 'SDK Version',
    'account.inventoryMenu.screens.edit.label.firmwareVersion': 'Firmware Version',
    'account.inventoryMenu.screens.edit.label.playerVersion': 'Player Version',
    'account.inventoryMenu.screens.edit.label.screenResolution': 'Screen Resolution',
    'account.inventoryMenu.screens.edit.label.spotName': 'Spot Name',
    'account.inventoryMenu.screens.edit.label.screenName': 'Screen Name',
    'account.inventoryMenu.screens.edit.label.orientation': 'Screen Orientation',
    'account.inventoryMenu.screens.edit.screenName.placeholder': 'Enter screen name',
    'account.inventoryMenu.screens.edit.select.spot.placeholder': 'Select spot',
    'account.inventoryMenu.screens.edit.select.spot.searchPlaceholder': 'Search spot...',
    'account.inventoryMenu.screens.edit.select.orientation.placeholder': 'Select orientation',
    'account.inventoryMenu.screens.edit.select.orientation.searchPlaceholder': 'Search orientation...',
    'account.inventoryMenu.screens.edit.validation.missingRequired': 'Missing required fields.',
    'account.inventoryMenu.screens.edit.validation.screenNameInvalid': 'Screen Name must be at least 3 characters long and contain only valid characters.',
    'account.inventoryMenu.screens.edit.updateSuccess': 'Data updated successfully.',
    'account.inventoryMenu.screens.edit.updateFailed': 'Update failed.',
    'account.inventoryMenu.screens.edit.unauthorized': 'Authentication failed: No valid credentials provided.',
    'account.inventoryMenu.screens.edit.invalidScreenId': 'Invalid screen ID.',
    'account.inventoryMenu.screens.edit.serverError': 'An error occurred while updating the data.',

    'account.campaignWallet.balance.label': 'Wallet Balance',
    'account.campaignWallet.action.addFunds': 'Add Funds',
    'account.campaignWallet.stats.budgetAllocationThisMonth': 'Budget Allocation (This Month)',
    'account.campaignWallet.stats.mtdSpend': 'MTD Spend',
    'account.campaignWallet.stats.mtdCostPerPlay': 'MTD Cost per Play',
    'account.campaignWallet.transactions.title': 'Wallet Transaction History',
    'account.campaignWallet.table.column.date': 'Date',
    'account.campaignWallet.table.column.paymentMethod': 'Payment Method',
    'account.campaignWallet.table.column.amount': 'Amount',
    'account.campaignWallet.table.column.status': 'Status',

    'account.inventoryMenu.bookingReview.title': 'Booking Review',
    'account.inventoryMenu.bookingReview.subtitle': 'Review the submitted ad to ensure it meets your standard',
    'account.inventoryMenu.bookingReview.label.advertiser': 'Advertiser',
    'account.inventoryMenu.bookingReview.label.durationResolution': 'Duration & Resolution',
    'account.inventoryMenu.bookingReview.label.campaignName': 'Campaign Name',
    'account.inventoryMenu.bookingReview.label.campaignSchedule': 'Campaign Schedule',
    'account.inventoryMenu.bookingReview.label.mediaSpot': 'Media Spot',
    'account.inventoryMenu.bookingReview.viewSpot': 'View Spot',
    'account.inventoryMenu.bookingReview.durationSeconds': '{{seconds}} seconds',
    'account.inventoryMenu.bookingReview.resolutionPixels': '{{width}} × {{height}} pixels',
    'account.inventoryMenu.bookingReview.durationResolution': '{{duration}}, {{resolution}}',
    'account.inventoryMenu.bookingReview.spotNotFound': 'Spot details not found.',
    'account.inventoryMenu.bookingReview.loadSpotFailed': 'Failed to load spot details.',
    'account.inventoryMenu.bookingReview.accepted': 'Accepted successfully.',
    'account.inventoryMenu.bookingReview.acceptFailed': 'Failed to accept booking.',
    'account.inventoryMenu.bookingReview.declined': 'Declined successfully.',
    'account.inventoryMenu.bookingReview.declineFailed': 'Failed to decline booking.',

    'account.subscription.activePlan.title': 'Active Plan',
    'account.subscription.activePlan.loading': 'Loading plan details...',
    'account.subscription.activePlan.loadFailed': 'Failed to load subscription plan. Please try again later.',
    'account.subscription.activePlan.unlimited': 'Unlimited',
    'account.subscription.activePlan.noCreditCard': 'No credit card, no hidden cost, no time limit, no pressure.',
    'account.subscription.activePlan.renewalDate': 'Renewal Date',
    'account.subscription.activePlan.billingCycle': 'Billing Cycle',
    'account.subscription.activePlan.activeSince': 'Active Since',
    'account.subscription.activePlan.features': 'Features and Benefits',
    'account.subscription.activePlan.noFeatures': 'No features available',

    'account.subscription.upgradePlan.title': 'Upgrade Plan',
    'account.subscription.upgradePlan.month': 'Month',
    'account.subscription.upgradePlan.orderSummary': 'Order Summary',
    'account.subscription.upgradePlan.tax': 'Tax',
    'account.subscription.upgradePlan.total': 'Total',
    'account.subscription.upgradePlan.voucherCode': 'Voucher Code',
    'account.subscription.upgradePlan.voucherPlaceholder': 'Enter voucher code',
    'account.subscription.upgradePlan.applyVoucher': 'Apply',
    'account.subscription.upgradePlan.checkout': 'Checkout',
    'account.subscription.upgradePlan.loadFailed': 'Failed to load upgrade plans',
    'account.subscription.upgradePlan.cartEmpty.title': 'Cart Empty',
    'account.subscription.upgradePlan.cartEmpty.message': 'No features selected. Please select features and set quantity/duration before checkout.',
    'account.subscription.upgradePlan.paymentInitiated.title': 'Payment Initiated',
    'account.subscription.upgradePlan.paymentInitiated.message': 'Your subscription payment has been initiated successfully. Please complete the payment using the provided Virtual Account.',
    'account.subscription.upgradePlan.paymentInitiated.button': 'View Orders',
    'account.subscription.upgradePlan.checkoutFailed': 'Checkout failed to create',
    'account.subscription.upgradePlan.previewFailed': 'Failed to calculate preview',

    'account.subscription.orders.title': 'My Orders',
    'account.subscription.orders.subtitle': 'Manage your order history and status',
    'account.subscription.orders.items.title': 'Order Items',
    'account.subscription.orders.column.date': 'Date',
    'account.subscription.orders.column.description': 'Description',
    'account.subscription.orders.column.price': 'Price',
    'account.subscription.orders.moreItems': ' +{{count}} more',
    'account.subscription.orders.orderId': 'Order {{id}}',
    'account.subscription.orders.loadFailed': 'Failed to load subscription history.',
    'account.subscription.orders.paymentDetailFailed': 'Failed to load payment details.',
    'account.subscription.orders.items.column.item': 'Item',
    'account.subscription.orders.items.column.unit': 'Unit',
    'account.subscription.orders.items.column.qty': 'Qty',
    'account.subscription.orders.items.column.duration': 'Duration',
    'account.subscription.orders.items.column.pricePerUnit': 'Price/Unit',
    'account.subscription.orders.items.column.subtotal': 'Subtotal',

    'account.campaignWallet.title': 'Campaign Wallet',
    'account.campaign.menu.create': 'Create',
    'account.campaign.menu.drafts': 'Drafts',
    'account.campaign.menu.pending': 'Pending',
    'account.campaign.menu.running': 'Running',
    'account.campaign.menu.paused': 'Paused',
    'account.campaign.menu.failed': 'Failed',
    'account.campaign.menu.completed': 'Completed',
    'account.campaign.menu.edit': 'Edit',
    'account.campaign.menu.drafts.summary': '{{ready}} ready \u2022 {{incomplete}} incomplete',
    'account.campaign.menu.summary.campaignsSpots': '{{campaigns}} campaigns \u2022 {{spots}} spots',
    'account.campaign.menu.confirmSwitch.message': 'Switch menu and reset edit data?',
    'account.campaign.menu.confirmSwitch.confirm': 'Switch',

    'account.campaign.create.campaignName': 'Campaign Name',
    'account.campaign.create.campaignName.placeholder': 'Insert here',
    'account.campaign.create.dateStart': 'Date Started',
    'account.campaign.create.dateEnd': 'Date Ended',
    'account.campaign.create.timeRange': 'Time Range',
    'account.campaign.create.fullDay': 'Full Day',
    'account.campaign.create.customTime': 'Custom Time',
    'account.campaign.create.customTime.item': 'Custom Time {{index}}',
    'account.campaign.create.customTime.add': 'Add Custom Time',
    'account.campaign.create.customTime.cancel': 'Cancel Custom Time',
    'account.campaign.create.saveDraft': 'Save as Draft',
    'account.campaign.create.timeRange.earlyMorning': 'Early Morning',
    'account.campaign.create.timeRange.morning': 'Morning',
    'account.campaign.create.timeRange.midday': 'Midday',
    'account.campaign.create.timeRange.afternoon': 'Afternoon',
    'account.campaign.create.timeRange.evening': 'Evening',
    'account.campaign.create.timeRange.lateNight': 'Late Night',
    'account.campaign.create.mediaSpot.column.badges': 'Badges',
    'account.campaign.create.mediaSpot.column.availability': 'Availability',
    'account.campaign.create.mediaSpot.empty': 'No media spot selected',
    'account.campaign.edit.backToDrafts': 'Back to Drafts',
    'account.campaign.edit.validation.startDateBeforeToday': 'Start date cannot be before today.',
    'account.campaign.edit.validation.endDateBeforeStart': 'End date cannot be before start date.',
    'account.campaign.edit.validation.customTimeRequired': 'Please add at least one custom time.',
    'account.campaign.edit.validation.timeRangeRequired': 'Please select at least one time range.',
    'account.campaign.edit.estimatedAllocation': 'Est. Allocation',
    'account.campaign.edit.budgetAllocation': 'Budget Allocation',
    'account.campaign.edit.noFixedBudgetHint': 'No fixed budget at the moment. Let Mataloka calculate the budget based on chosen location and flight dates.',
    'account.campaign.edit.availabilityCalculated': 'Availability is calculated based on the date {{start}} until {{end}}.',
    'account.campaign.edit.unavailableSpots.title': 'Some Media Spots cannot be booked',
    'account.campaign.edit.unavailableSpots.body': 'One or more selected Media Spots are unavailable (inactive or fully booked) for the selected dates. Please remove or replace the unavailable spots before submitting a booking request.',
    'account.campaign.edit.addMoreSpot': 'Add More Spot',
    'account.campaign.edit.mediaSpotSelected': 'Media Spot selected',
    'account.campaign.edit.mediaSpotNotSelected': 'Media Spot not yet selected',
    'account.campaign.edit.mediaSpotNotSelected.desc': 'You haven\'t selected a media spot yet. Choosing a media spot ensures your content reaches the right destination.',
    'account.campaign.edit.selectMediaSpot': 'Select Media Spot',
    'account.campaign.edit.creativeAsset': 'Creative Asset',
    'account.campaign.edit.groupHeader.oneScreen': 'One screen',
    'account.campaign.edit.groupHeader.twoSyncedScreens': 'Two Synced Screens',
    'account.campaign.edit.groupHeader.syncedScreens': '{{count}} Synced Screens',
    'account.campaign.edit.groupHeader.mediaSpot.single': '{{count}} Media Spot',
    'account.campaign.edit.groupHeader.mediaSpot.plural': '{{count}} Media Spots',
    'account.campaign.edit.assetPreviewAlt': 'Asset preview',
    'account.campaign.edit.video': 'Video',
    'account.campaign.edit.groupMeta.totalResolution': 'Total resolution {{resolution}} - max. {{size}} per file',
    'account.campaign.edit.groupMeta.master': 'Master: Panel {{panel}}, duration {{duration}}',
    'account.campaign.edit.groupMeta.status': 'Status',
    'account.campaign.edit.action.saveChanges': 'Save Changes',
    'account.campaign.edit.action.requestBooking': 'Request Booking',
    'account.campaign.create.validation.invalidFormat': 'Invalid format. Please fill all required fields.',
    'account.campaign.create.validation.nameTooShort': 'Campaign name must be at least 3 characters long.',
    'account.campaign.create.validation.startBeforeToday': 'Date Started cannot be before today.',
    'account.campaign.create.validation.endBeforeStart': 'Date Ended cannot be before Date Started.',
    'account.campaign.create.validation.timeRangeRequired': 'Please select at least one time range.',
    'account.campaign.create.validation.customTimeRequired': 'Please add at least one custom time.',
    'account.campaign.create.validation.zeroScreens': 'A selected Media Spot has zero screens. Please remove it.',
    'account.campaign.create.createFailed': 'Failed to create campaign.',
    'account.campaign.create.upload.invalidFile': 'Only MP4 video files are allowed.',
    'account.campaign.create.upload.durationInconsistent': 'Allowed Ad Duration is inconsistent for selected spots in this group.',
    'account.campaign.create.upload.durationExceededDetailed': 'Video duration must be \u2264 {{allowed}} seconds. Uploaded video duration: {{actual}} seconds.',

    'account.campaign.completedDetail.loadFailed': 'Failed to load completed campaign details.',
    'account.campaign.completedDetail.deliveryRate': '{{rate}}% Delivered',
    'account.campaign.completedDetail.spotsCount': '{{count}} Spots',
    'account.campaign.completedDetail.screensCount': '{{count}} Screens',
    'account.campaign.completedDetail.hoursCount': '{{hours}} Hours',
    'account.campaign.completedDetail.creativeGroup': 'Creative Group',
    'account.campaign.completedDetail.asset': 'Asset',
    'account.campaign.completedDetail.status.completed': 'Completed',
    'account.campaign.completedDetail.section.creativeAsset': 'Creative Asset',
    'account.campaign.completedDetail.summary.booking': 'Booking',
    'account.campaign.completedDetail.summary.bookingId': 'ID: {{id}}',
    'account.campaign.completedDetail.summary.totalSpent': 'Total Spent',
    'account.campaign.completedDetail.summary.totalPlays': 'Total Plays',
    'account.campaign.completedDetail.summary.flightDates': 'Flight Dates',
    'account.campaign.completedDetail.summary.totalMedia': 'Total Media',
    'account.campaign.completedDetail.summary.totalExposure': 'Total Exposure',
    'account.campaign.completedDetail.table.totalSpent': 'Total Spent',
    'account.campaign.completedDetail.table.playCount': 'Play Count',
    'account.campaign.completedDetail.table.footfall': 'Approx. Footfall',

    'account.campaign.edit.upload.processing': 'Processing upload...',
    'account.campaign.edit.upload.placeholder': 'Drag here or click upload',
    'account.campaign.edit.panel': 'Panel {{index}}',
    'account.campaign.edit.upload.timeout.title': 'Upload Timeout',
    'account.campaign.edit.upload.timeout.message': 'Upload status timed out.',
    'account.campaign.edit.upload.failed.title': 'Upload Failed',
    'account.campaign.edit.upload.failed.message': 'Upload failed.',
    'account.campaign.edit.upload.statusCheckFailed': 'Failed to check upload status.',

    'account.campaign.completed.title': 'Completed Campaigns',
    'account.campaign.completed.column.spots': 'Spots',
    'account.campaign.completed.column.flightDates': 'Flight Dates',
    'account.campaign.completed.action.playLog': 'Play Log',
    'account.campaign.completed.action.duplicate': 'Duplicate',
    'account.campaign.completed.empty': 'No completed campaigns found',
    'account.campaign.completed.loadFailed': 'Completed campaign load failed.',
    'account.campaign.completed.playLog.title': 'Play Log',
    'account.campaign.completed.playLog.invalidId': 'Invalid campaign ID for download.',
    'account.campaign.completed.playLog.downloadFailed': 'Failed to download Play Log. Please try again.',
    'account.campaign.completed.playLog.downloadError': 'Failed to download campaign Play Log.',
    'account.campaign.completed.duplicate.title': 'Duplicate Campaign',
    'account.campaign.completed.duplicate.invalidId': 'Invalid campaign ID for duplication.',
    'account.campaign.completed.spot.single': '{{count}} Spot',
    'account.campaign.completed.spot.plural': '{{count}} Spots',

    'account.settings.company.section.companyInfo': 'Company Information',
    'account.settings.company.companyName': 'Company Name',
    'account.settings.company.companyName.placeholder': 'Enter company name',
    'account.settings.company.businessCategory': 'Business Category',
    'account.settings.company.businessCategory.placeholder': 'Select Business Category',
    'account.settings.company.mobileWhatsapp': 'Mobile No. (for WhatsApp)',
    'account.settings.company.mobile.placeholder': 'Enter mobile number',
    'account.settings.company.businessEmail': 'Business Email',
    'account.settings.company.businessEmail.placeholder': 'Enter business email',
    'account.settings.company.contactPerson': 'Contact Person',
    'account.settings.company.contactPerson.placeholder': 'Enter contact person name',
    'account.settings.company.dashboardLogo': 'Dashboard Logo',
    'account.settings.company.chooseFile': 'Choose file',
    'account.settings.company.logoHelp': 'Format allowed: PNG, JPG, GIF, WEBP. If not uploaded, logo will be empty.',
    'account.settings.company.uploadLogo': 'Upload Logo',
    'account.settings.company.removeLogo': 'Remove Logo',
    'account.settings.company.businessCategory.loadFailed': 'Business category load failed.',
    'account.settings.company.validation.companyNameInvalid': 'Company Name must be at least 3 characters long.',
    'account.settings.company.validation.phoneInvalid': 'Invalid Phone Number format (8-15 digits).',
    'account.settings.company.validation.emailInvalid': 'Invalid Email format.',
    'account.settings.company.validation.contactPersonInvalid': 'Contact Person Name must be at least 3 characters long.',
    'account.settings.company.validation.businessCategoryRequired': 'Please select a Business Category.',
    'account.settings.company.validation.imageOnly': 'Please select an image file.',
    'account.settings.company.validation.dashboardLogoFormatInvalid': 'Dashboard logo format must be PNG/JPG/GIF/WEBP.',
    'account.settings.company.validation.dashboardLogoRequired': 'Please select a logo file first.',
    'account.settings.company.updateSuccess': 'Company data updated successfully.',
    'account.settings.company.updateFailed': 'Company data update failed.',
    'account.settings.company.dashboardLogo.uploadSuccess': 'Dashboard logo successfully uploaded.',
    'account.settings.company.dashboardLogo.uploadFailed': 'Dashboard logo upload failed.',
    'account.settings.company.dashboardLogo.deleteSuccess': 'Dashboard logo successfully deleted.',
    'account.settings.company.dashboardLogo.deleteFailed': 'Dashboard logo deletion failed.',

    'account.settings.payout.section.withdrawal': 'Withdrawal',
    'account.settings.payout.section.currency': 'Currency',
    'account.settings.payout.section.bankAccount': 'Payout Bank Account',
    'account.settings.payout.autoWithdrawal': 'Auto Withdrawal',
    'account.settings.payout.minimumThreshold': 'Minimum Withdrawal Threshold',
    'account.settings.payout.schedule': 'Schedule',
    'account.settings.payout.preferredCurrency': 'Preferred Currency',
    'account.settings.payout.bankName': 'Bank Name',
    'account.settings.payout.accountHolderName': 'Account Holder Name',
    'account.settings.payout.accountHolderName.placeholder': 'e.g., John Smith',
    'account.settings.payout.accountNumber': 'Account Number',
    'account.settings.payout.accountNumber.placeholder': 'e.g., 122230918756',
    'account.settings.payout.currency.placeholder': 'Select Preferred Currency',
    'account.settings.payout.bank.placeholder': 'Select Bank',
    'account.settings.payout.schedule.placeholder': 'Select Schedule',
    'account.settings.payout.loadFailed': 'Failed to load payout settings.',
    'account.settings.payout.updateSuccess': 'Payout settings updated successfully.',
    'account.settings.payout.updateFailed': 'Failed to update payout settings.',
    'account.settings.payout.bank.loadFailed': 'Failed to load bank data.',
    'account.settings.payout.schedule.loadFailed': 'Failed to load payment schedules.',
    'account.settings.payout.currency.loadFailed': 'Failed to load currencies.',
    'account.settings.payout.validation.bankRequired': 'Please select a bank.',
    'account.settings.payout.validation.accountNumberInvalid': 'Invalid account number (5–20 digits).',
    'account.settings.payout.validation.accountHolderInvalid': 'Account holder name must be at least 3 characters.',
    'account.settings.payout.validation.scheduleRequired': 'Please select a payment schedule for auto-withdrawal.',
    'account.settings.payout.validation.currencyRequired': 'Please select a currency for auto-withdrawal.',

    'account.settings.notification.section.screen': 'Screen',
    'account.settings.notification.section.bookings': 'Bookings',
    'account.settings.notification.screen.offline': 'Send me an email when a screen goes offline',
    'account.settings.notification.screen.online': 'Send me an email when a screen goes back online',
    'account.settings.notification.bookings.slotBooked': 'Send me an email when a slot is booked',
    'account.settings.notification.bookings.expires': 'Send me an email when a booking expires',
    'account.settings.notification.section.invitations': 'Invitations',
    'account.settings.notification.invitations.guest': 'Send me an email when I receive a guest invitation',
    'account.settings.notification.invitations.response': 'Send me an email when a guest invitation is responded to',
    'account.settings.notification.loadFailed': 'Failed to load notification settings.',
    'account.settings.notification.updateSuccess': 'Notification settings updated successfully.',
    'account.settings.notification.updateFailed': 'Failed to update notification settings.',

    'account.settings.security.section.password': 'Password',
    'account.settings.security.section.alert': 'Alert',
    'account.settings.security.newPassword': 'New Password',
    'account.settings.security.newPassword.placeholder': 'Enter new password',
    'account.settings.security.verifyPassword': 'Verify New Password',
    'account.settings.security.verifyPassword.placeholder': 'Confirm new password',
    'account.settings.security.password.hint.match': 'Both passwords must match',
    'account.settings.security.alert.newLocation': 'Send me an email when someone logs in from a new location',
    'account.settings.security.password.strength.weak': 'Weak',
    'account.settings.security.password.strength.medium': 'Medium',
    'account.settings.security.password.strength.strong': 'Strong',
    'account.settings.security.password.requirement.min8': 'At least 8 characters',
    'account.settings.security.password.requirement.lowercase': 'Contains lowercase letter',
    'account.settings.security.password.requirement.uppercase': 'Contains uppercase letter',
    'account.settings.security.password.requirement.number': 'Contains number',
    'account.settings.security.password.requirement.special': 'Contains special character',
    'account.settings.security.password.error.fillAll': 'Please fill in all fields',
    'account.settings.security.password.error.notMatch': 'Passwords do not match',
    'account.settings.security.password.error.tooWeak': 'Password is too weak. Please choose a stronger password.',
    'account.settings.security.password.updated': 'Password successfully updated.',
    'account.settings.security.password.updateFailed': 'Password update failed.',

    'account.settings.shared.title': 'Shared Dashboards',
    'account.settings.shared.subtitle': 'Manage shared dashboard access and permissions',
    'account.settings.shared.column.dashboard': 'Dashboard',
    'account.settings.shared.column.invited': 'Invited',
    'account.settings.shared.column.invitedOn': 'Invited On',
    'account.settings.shared.column.invitedBy': 'Invited By',
    'account.settings.shared.column.lastActive': 'Last Active',

    'account.settings.invitation.title': 'Invitation Management',
    'account.settings.invitation.subtitle': 'Manage dashboard invitations sent to users',

    'account.settings.favorite.title': 'Favorite Advertisers',
    'account.settings.favorite.subtitle': 'Manage your favorite advertisers and track their performance',
    'account.settings.favorite.column.approvedBooking': 'Approved Booking',
    'account.settings.favorite.column.lastBooking': 'Last Booking',
    'account.settings.favorite.column.totalRevenue': 'Total Revenue',
    'account.settings.favorite.column.since': 'Since',

    'account.settings.preference.section.content': 'Content',
    'account.settings.preference.section.advertiser': 'Advertiser',
    'account.settings.preference.section.player': 'Player',
    'account.settings.preference.section.advanced': 'Advanced',
    'account.settings.preference.content.title': 'Content Preference',
    'account.settings.preference.advertiser.title': 'Advertiser Preference',
    'account.settings.preference.playerBootLogo.title': 'Player Boot Logo',
    'account.settings.preference.feature.apiTokens': 'API Tokens',
    'account.settings.preference.feature.playLog': 'Play Log',
    'account.settings.preference.feature.auditLog': 'Audit Log',
    'account.settings.preference.action.setPreference': 'Set Preference',
    'account.settings.preference.action.changeBootLogo': 'Change Boot Logo',
    'account.settings.preference.action.enabled': 'Enabled',
    'account.settings.preference.value.preferredContent': 'Your Preferred Content',
    'account.settings.preference.value.preferredAdvertiser': 'Your Preferred Advertiser',
    'account.settings.preference.value.default': 'Default',
    'account.settings.preference.status.disabled': 'Disabled',

    'inventory.needAttention.title': 'Need Attention',
    'inventory.needAttention.column.screens': 'Screens',
    'inventory.needAttention.column.needsAttention': 'Needs Attention',
    'inventory.needAttention.column.firstDetected': 'First Detected',
    'inventory.needAttention.empty': 'No spots need attention at this time',
    'inventory.needAttention.detail.column.property': 'Property',
    'inventory.needAttention.detail.column.value': 'Value',
    'inventory.needAttention.detail.spotName': 'Spot Name',
    'inventory.needAttention.detail.detectedAt': 'Detected At',
    'inventory.needAttention.detail.status': 'Status',
    'inventory.needAttention.detail.lastHeartbeat': 'Last Heartbeat',
    'inventory.needAttention.detail.recommendation': 'Recommendation',
    'inventory.needAttention.detail.storageLeft': 'Storage Left',
    'inventory.needAttention.detail.failedAttempts': 'Failed Attempts',
    'inventory.needAttention.detail.errorCode': 'Error Code',
    'inventory.needAttention.detail.lastMaintenance': 'Last Maintenance',
    'inventory.needAttention.detail.currentVersion': 'Current Version',
    'inventory.needAttention.detail.newVersion': 'New Version',
    'inventory.needAttention.type.offline': 'Offline',
    'inventory.needAttention.type.low-storage': 'Low Storage',
    'inventory.needAttention.type.connection-issue': 'Connection Issue',
    'inventory.needAttention.type.maintenance': 'Maintenance Required',
    'inventory.needAttention.type.update-needed': 'Update Needed',
    'inventory.needAttention.value.minutesAgo': '{{minutes}} minutes ago',
    'inventory.needAttention.value.hoursAgo': '{{hours}} hours ago',
    'inventory.needAttention.value.daysAgo': '{{days}} days ago',
    'inventory.needAttention.value.weeksAgo': '{{weeks}} weeks ago',
    'inventory.needAttention.group.shoppingMalls': 'Shopping Malls',
    'inventory.needAttention.group.transportation': 'Transportation',
    'inventory.needAttention.group.hospitality': 'Hospitality',
    'inventory.needAttention.group.corporate': 'Corporate',
    'inventory.needAttention.group.foodAndBeverage': 'Food & Beverage',
    'inventory.needAttention.group.retail': 'Retail',
    'inventory.needAttention.group.education': 'Education',
    'inventory.needAttention.group.healthcare': 'Healthcare',
    'inventory.needAttention.group.entertainment': 'Entertainment',
    'inventory.needAttention.group.financial': 'Financial',
    'inventory.needAttention.recommendation.offline': 'Check power and network connection.',
    'inventory.needAttention.recommendation.lowStorage': 'Delete unnecessary files.',
    'inventory.needAttention.recommendation.connectionIssue': 'Restart the sync service or check logs.',
    'inventory.needAttention.recommendation.maintenanceRequired': 'Schedule maintenance soon.',
    'inventory.needAttention.recommendation.updateNeeded': 'Schedule software update.',

    'auth.login.title': 'Login',
    'auth.login.emailAddress': 'Email Address',
    'auth.login.emailPlaceholder': 'Email',
    'auth.login.password': 'Password',
    'auth.login.passwordPlaceholder': 'Password',
    'auth.login.forgotPassword': 'Forgot password?',
    'auth.login.submit': 'Login',
    'auth.login.loggingIn': 'Logging in...',
    'auth.login.or': 'or',
    'auth.login.noAccount': 'Don\'t have an account?',
    'auth.login.signUp': 'Sign up',
    'auth.login.illustrationAlt': 'Login Illustration',
    'auth.login.sessionExpired': 'Your session has expired. Please login again.',
    'auth.login.loggedOut': 'You have logged out. Please login again.',
    'auth.login.googleFailed': 'Google login failed. Please try again.',

    'auth.shell.logoAlt': '{{appName}} Logo',

    'auth.forgot.title': 'Forgot Your Password?',
    'auth.forgot.subtitle': 'Enter your email below to receive password reset instructions.',
    'auth.forgot.illustrationAlt': 'Forgot Password Illustration',
    'auth.forgot.emailAddress': 'Email Address',
    'auth.forgot.emailPlaceholder': 'Email',
    'auth.forgot.submit': 'Send',
    'auth.forgot.sending': 'Sending...',
    'auth.forgot.remember': 'Remember password?',
    'auth.forgot.login': 'Log in',
    'auth.forgot.errorTitle': 'Error',
    'auth.forgot.successTitle': 'Success',
    'auth.forgot.emailRequired': 'Please enter a valid email address.',
    'auth.forgot.emailInvalid': 'Invalid email format.',
    'auth.forgot.successMessage': 'Password reset link has been sent to your email.',
    'auth.forgot.errorMessage': 'An error occurred while sending the password reset email. Please try again.',

    'auth.reset.title': 'Reset Password',
    'auth.reset.subtitle': 'Your new password should be different from previously used passwords.',
    'auth.reset.illustrationAlt': 'Reset Password Illustration',
    'auth.reset.newPassword': 'New Password',
    'auth.reset.confirmPassword': 'New Password Confirmation',
    'auth.reset.passwordPlaceholder': 'Password',
    'auth.reset.hint': 'Use a combination of lowercase, uppercase, number, and symbol.',
    'auth.reset.combination': 'Current combination: {{combo}}',
    'auth.reset.matchHint': 'Both passwords must match',
    'auth.reset.submit': 'Reset Password',
    'auth.reset.resetting': 'Resetting...',
    'auth.reset.strength.weak': 'Weak',
    'auth.reset.strength.medium': 'Medium',
    'auth.reset.strength.strong': 'Strong',
    'auth.password.req.min8': 'At least 8 characters',
    'auth.password.req.lower': 'Contains lowercase letter',
    'auth.password.req.upper': 'Contains uppercase letter',
    'auth.password.req.number': 'Contains number',
    'auth.password.req.special': 'Contains special character',
    'auth.reset.fillAll': 'Please fill in all fields',
    'auth.reset.mismatch': 'Passwords do not match',
    'auth.reset.tooWeak': 'Password is too weak. Please choose a stronger password.',
    'auth.reset.successTitle': 'Success',
    'auth.reset.successMessage': 'Password successfully updated. Please log in with your new password.',
    'auth.reset.errorTitle': 'Error',
    'auth.reset.errorMessage': 'An error occurred while updating the password. Please try again.',

    'auth.confirm.verified': 'Verified',
    'auth.confirm.activated': 'Your account has been activated',
    'auth.confirm.thankYou': 'Thank you for joining us! Click the Next button below to start using our product and service.',
    'auth.confirm.next': 'Next',
    'auth.confirm.failed': 'Verification Failed',
    'auth.confirm.failedFor': 'Your verification to {{email}} has failed.',
    'auth.confirm.linkExpired': 'Your link has expired. Please click the Resend button below to request a new verification link.',
    'auth.confirm.resend': 'Resend',
    'auth.confirm.back': 'Back',

    'auth.otp.iconAlt': 'OTP Shield Icon',
    'auth.otp.title': 'Input OTP',
    'auth.otp.sentTo': 'We have sent a verification code to {{email}}',
    'auth.otp.instruction': 'Check your email and input the verification code below.',
    'auth.otp.expiresAt': 'Your code will expire at {{time}}',
    'auth.otp.verify': 'Verify',
    'auth.otp.verifying': 'Verifying...',
    'auth.otp.resend': 'Resend',
    'auth.otp.resending': 'Resending...',
    'auth.otp.resendIn': 'Resend ({{seconds}}s)',
    'auth.otp.errorTitle': 'Error',
    'auth.otp.successTitle': 'Success',
    'auth.otp.emailMissing': 'Email not found. Please go back and try again.',
    'auth.otp.invalidLength': 'Please enter a 6-digit OTP.',
    'auth.otp.verifyFailed': 'OTP verification failed. Please try again.',
    'auth.otp.resendFailed': 'Failed to resend OTP. Please try again.',
    'auth.otp.resendSuccess': 'OTP has been resent to your email.',

    'auth.category.title': 'What are you?',
    'auth.category.subtitle': 'Welcome! To give you the right tools, we need to know how you will be using {{brand}}. Please choose the role that best matches your responsibilities.',
    'auth.category.iconAlt': '{{name}} Icon',
    'auth.category.select': 'Select',
    'auth.category.loading': 'Loading...',
    'auth.category.fetchFailed': 'Failed to fetch categories. Please try again.',
    'auth.category.selectFailed': 'Failed to select category. Please try again.',
    'auth.category.emailMissing': 'User email not found. Please try signing up again.',

    'role.mediaOwners': 'Media Owners',
    'role.advertisers': 'Advertisers',
    'role.operator': 'Operator',

    'auth.signup.title': 'Sign Up',
    'auth.signup.illustrationAlt': 'Sign Up Illustration',
    'auth.signup.emailAddress': 'Email Address',
    'auth.signup.emailPlaceholder': 'you@yourcompany.com',
    'auth.signup.password': 'Password',
    'auth.signup.passwordPlaceholder': 'Password',
    'auth.signup.hint': 'Use a combination of lowercase, uppercase, number, and symbol.',
    'auth.signup.agreePrefix': 'I agree to the',
    'auth.signup.termOfService': 'Term of Service',
    'auth.signup.privacyPolicy': 'Privacy Policy',
    'auth.signup.andOtherPolicies': 'and all other policies found in the',
    'auth.signup.legalCenter': 'Legal Center',
    'auth.signup.submit': 'Sign Up',
    'auth.signup.submitting': 'Signing Up...',
    'auth.signup.or': 'or',
    'auth.signup.alreadyAccount': 'Already have an account?',
    'auth.signup.login': 'Log in',
    'auth.signup.googleFailed': 'Google sign up failed. Please try again.',
    'auth.signup.fillAll': 'Please fill in all fields',
    'auth.signup.emailInvalid': 'Please enter a valid email address',
    'auth.signup.acceptTerms': 'Please accept the terms and conditions',
    'auth.signup.tooWeak': 'Password is too weak. Please choose a stronger password.',
    'auth.signup.serverIncomplete': 'Registration failed: Incomplete data from server.',
    'auth.signup.failed': 'Registration failed. Please try again.',
    'auth.signup.errorTitle': 'Error',

    'profiling.loading': 'Loading survey data...',
    'profiling.submitting': 'Submitting...',
    'profiling.next': 'Next',
    'profiling.funFact': 'Fun Fact',
    'profiling.errorTitle': 'Error',
    'profiling.emailMissing': 'User email not found. Please try again.',
    'profiling.loadFailed': 'Failed to load survey data. Please try again.',
    'profiling.selectAnswer': 'Please select an answer.',
    'profiling.submitFailed': 'Failed to submit the survey answer. Please try again.',
    'profiling.facts.1': 'The global DOOH market is projected to reach $58.67 billion by 2030<br>Your screens can be part of this booming industry!',
    'profiling.facts.2': 'Digital billboards can increase brand awareness by up to 47%<br>Perfect for driving attention inside and outside your store.',
    'profiling.facts.3': 'Dynamic content on screens keeps viewers engaged 4x longer<br>Use motion and timing to tell stronger brand stories.',
    'profiling.facts.4': 'Programmatic DOOH lets you buy audiences, not just locations<br>Reach the right people at the right moment.',
    'profiling.facts.5': 'Retailers using in-store digital signage see sales uplifts<br>from 10% to 30% on promoted products.',
    'profiling.facts.6': 'Context matters: DOOH campaigns can adapt by time and place<br>Morning promos differ from evening vibes.',
    'profiling.facts.7': 'Bright displays improve recall in high-traffic areas<br>Visibility drives faster brand recognition.',
    'profiling.facts.8': 'Short messages work best: 6–8 words is often enough<br>Keep copy punchy and readable at a glance.',
    'profiling.facts.9': 'Weather-triggered creatives can lift performance<br>Match promos to rain, heat, or clear skies.',
    'profiling.facts.10': 'Motion grabs attention, but simplicity converts<br>Clean layouts outperform cluttered screens.',

    'legal.lastUpdated': 'Last updated:',

    'legal.tnc.title': 'Terms & Conditions (T&C)',
    'legal.tnc.s1.title': '1. Introduction',
    'legal.tnc.s1.body': 'Welcome to {{platformName}} (\"Platform\"). By accessing or using our services, you (\"User\") agree to comply with these Terms & Conditions. If you do not agree, please refrain from using our services.',
    'legal.tnc.s2.title': '2. Definitions',
    'legal.tnc.s2.platformLabel': 'Platform:',
    'legal.tnc.s2.userLabel': 'User:',
    'legal.tnc.s2.publisherLabel': 'Publisher:',
    'legal.tnc.s2.advertiserLabel': 'Advertiser:',
    'legal.tnc.s2.platform': 'The DigiMax digital advertising and screen management platform.',
    'legal.tnc.s2.user': 'Any individual or business using the Platform, including media owners (publishers) and advertisers.',
    'legal.tnc.s2.publisher': 'A media owner who registers digital screens or locations on the Platform.',
    'legal.tnc.s2.advertiser': 'A business or individual purchasing ad placements on digital screens via the Platform.',
    'legal.tnc.s3.title': '3. Account Registration & Usage',
    'legal.tnc.s3.b1': 'Users must provide accurate and complete information.',
    'legal.tnc.s3.b2': 'Publishers are responsible for managing their registered screens and ensuring content compliance.',
    'legal.tnc.s3.b3': 'Advertisers must comply with advertising regulations and avoid prohibited content (e.g., illegal, misleading, or harmful ads).',
    'legal.tnc.s3.b4': 'The Platform reserves the right to suspend or terminate accounts violating our terms.',
    'legal.tnc.s4.title': '4. Payments & Subscriptions',
    'legal.tnc.s4.b1': 'The Platform offers subscription plans with different features and screen quotas.',
    'legal.tnc.s4.b2': 'Payments must be made according to the selected plan. Failure to renew may result in account limitations.',
    'legal.tnc.s4.b3': 'Refund policies, if applicable, will be provided during the purchase process.',
    'legal.tnc.s5.title': '5. Content Guidelines',
    'legal.tnc.s5.b1': 'Publishers must ensure that screens do not display prohibited content (e.g., hate speech, false advertising, pornography).',
    'legal.tnc.s5.b2': 'The Platform reserves the right to remove content violating policies or applicable laws.',
    'legal.tnc.s6.title': '6. Third-Party Advertising & Monetization',
    'legal.tnc.s6.b1': 'Publishers may enable third-party ads on their screens and earn revenue.',
    'legal.tnc.s6.b2': 'The Platform may offer advertising agency services for publishers who do not wish to handle direct ad sales.',
    'legal.tnc.s6.b3': 'Revenue-sharing details will be provided in the monetization settings.',
    'legal.tnc.s7.title': '7. Data Protection & Compliance',
    'legal.tnc.s7.b1': 'The Platform complies with Indonesia\'s PDP Law, EIT Law, and relevant SEA regulations.',
    'legal.tnc.s7.b2': 'Users must handle customer data responsibly and comply with GDPR-like privacy laws in applicable regions.',
    'legal.tnc.s8.title': '8. Service Limitations & Liability',
    'legal.tnc.s8.b1': 'The Platform is not liable for downtime, content issues, or revenue losses caused by external factors (e.g., power outages, internet disruptions).',
    'legal.tnc.s8.b2': 'Users are responsible for managing their accounts, screens, and campaigns effectively.',
    'legal.tnc.s9.title': '9. Governing Law',
    'legal.tnc.s9.b1': 'These terms are governed by Indonesian law, with dispute resolution handled through arbitration in Jakarta, Indonesia.',
    'legal.tnc.s9.b2': 'Users in other SEA countries agree to abide by local regulations while using the Platform.',
    'legal.tnc.s10.title': '10. Changes to T&C',
    'legal.tnc.s10.p1': 'We may update these terms at any time. Continued use of the Platform implies acceptance of the latest version.',
    'legal.tnc.s10.p2': 'For questions, contact',

    'legal.privacy.title': 'Privacy Policy',
    'legal.privacy.s1.title': '1. Introduction',
    'legal.privacy.s1.body': 'DigiMax (\"Platform\") values your privacy and is committed to protecting your personal data. This Privacy Policy outlines how we collect, use, and store user data in compliance with Indonesia\'s PDP Law, SEA privacy laws, and GDPR where applicable.',
    'legal.privacy.s2.title': '2. Data We Collect',
    'legal.privacy.s2.lead': 'We collect the following types of data:',
    'legal.privacy.s2.b1.label': 'Account Information:',
    'legal.privacy.s2.b1.body': 'Name, email, phone number, payment details.',
    'legal.privacy.s2.b2.label': 'Advertising Data:',
    'legal.privacy.s2.b2.body': 'Ad content, audience analytics, and screen performance data.',
    'legal.privacy.s2.b3.label': 'Device & Usage Data:',
    'legal.privacy.s2.b3.body': 'IP address, login activity, device type, and browsing behavior.',
    'legal.privacy.s3.title': '3. How We Use Your Data',
    'legal.privacy.s3.b1': 'To provide and improve Platform services.',
    'legal.privacy.s3.b2': 'To process payments and manage subscriptions.',
    'legal.privacy.s3.b3': 'To display targeted ads (only if users enable third-party ads).',
    'legal.privacy.s3.b4': 'To comply with legal requirements and prevent fraud.',
    'legal.privacy.s4.title': '4. Data Storage & Security',
    'legal.privacy.s4.b1': 'User data is stored securely in Indonesia and regional SEA data centers.',
    'legal.privacy.s4.b2': 'We use encryption, firewalls, and secure access controls to protect user information.',
    'legal.privacy.s5.title': '5. Third-Party Sharing',
    'legal.privacy.s5.b1': 'We do not sell personal data.',
    'legal.privacy.s5.b2': 'We may share data with advertising partners (if monetization is enabled) and payment processors for transactions.',
    'legal.privacy.s5.b3': 'In compliance with GDPR-like laws, users can request data access, corrections, or deletion.',
    'legal.privacy.s6.title': '6. Cookies & Tracking',
    'legal.privacy.s6.body1': 'We use cookies for authentication, analytics, and ad targeting.',
    'legal.privacy.s6.seeOur': 'See our',
    'legal.privacy.s6.cookiePolicy': 'Cookie Policy',
    'legal.privacy.s6.body2': 'for details.',
    'legal.privacy.s7.title': '7. User Rights',
    'legal.privacy.s7.b1': 'Users can access, modify, or delete personal data via their account settings.',
    'legal.privacy.s7.b2': 'Users can opt out of targeted ads and cookie tracking.',
    'legal.privacy.s8.title': '8. Changes to Privacy Policy',
    'legal.privacy.s8.body': 'We may update this Privacy Policy. Users will be notified of significant changes.',
    'legal.privacy.footer': 'For inquiries, contact'
  },
  id: {
    'basicInfo.contact': 'Kontak',
    'basicInfo.timeZoneLanguage': 'Zona Waktu & Bahasa',
    'basicInfo.dateTime': 'Tanggal & Waktu',
    'basicInfo.fullName': 'Nama Lengkap',
    'basicInfo.fullNamePlaceholder': 'Masukkan nama lengkap',
    'basicInfo.email': 'Email',
    'basicInfo.emailPlaceholder': 'Masukkan email',
    'basicInfo.mobileNumber': 'Nomor Ponsel',
    'basicInfo.mobileNumberPlaceholder': 'Masukkan nomor ponsel',
    'basicInfo.continentOrCountry': 'Benua atau Negara',
    'basicInfo.cityOrZone': 'Kota atau Zona',
    'basicInfo.language': 'Bahasa',
    'basicInfo.dateFormat': 'Format Tanggal',
    'basicInfo.timeFormat': 'Format Waktu',
    'basicInfo.firstDayOfWeek': 'Hari Pertama dalam Minggu',
    'basicInfo.timeFormat12': '12 Jam | 5:14 PM',
    'basicInfo.timeFormat24': '24 Jam | 17:14',
    'basicInfo.sunday': 'Minggu',
    'basicInfo.monday': 'Senin',
    'basicInfo.save': 'Simpan',
    'basicInfo.saving': 'Menyimpan...',
    'basicInfo.requestDeletion': 'Ajukan penghapusan profil penuh',
    'basicInfo.validationTitle': 'Kesalahan Validasi',
    'basicInfo.validationFullName': 'Masukkan nama lengkap yang valid (min 2 karakter, hanya huruf).',
    'basicInfo.validationEmail': 'Masukkan alamat email yang valid.',
    'basicInfo.validationMobile': 'Masukkan nomor ponsel yang valid (8-15 digit).',
    'basicInfo.successTitle': 'Berhasil',
    'basicInfo.successMessage': 'Profil berhasil diperbarui!',
    'basicInfo.countryLoadFailed': 'Gagal memuat daftar negara.',
    'basicInfo.cityLoadFailed': 'Gagal memuat daftar kota.',
    'basicInfo.profileLoadFailed': 'Gagal memuat profil pengguna.',
    'basicInfo.profileUpdateFailed': 'Gagal memperbarui profil.',
    'select.placeholder.continent': 'Pilih Benua atau Negara',
    'select.placeholder.city': 'Pilih Kota atau Zona',
    'select.placeholder.code': 'Kode',
    'select.searchPlaceholder': 'Cari opsi...',
    'select.noOptions': 'Opsi tidak ditemukan',
    'select.loading': 'Memuat opsi...',
    'select.addNewInputPlaceholder': 'Masukkan nama opsi baru',
    'select.add': 'Tambah',
    'select.cancel': 'Batal',
    'select.invalidNewOption': 'Nama opsi minimal 3 karakter dan hanya boleh berisi karakter yang valid.',
    'language.en': 'Inggris',
    'language.id': 'Indonesia',
    'language.es': 'Spanyol',

    'Notifications': 'Notifikasi',
    'Clear': 'Bersihkan',
    'User': 'Pengguna',
    'Profile': 'Profil',
    'Subscription': 'Langganan',
    'Inventory': 'Inventaris',
    'Campaign': 'Kampanye',
    'Wallet': 'Dompet',
    'Logout': 'Keluar',

    'Welcome': 'Selamat Datang',
    'Manage': 'Kelola',
    'Bookings': 'Pemesanan',
    'Performance': 'Performa',
    'Availability': 'Ketersediaan',
    'Pricing': 'Harga',
    'Audience': 'Audiens',

    'Login': 'Masuk',
    'Email Address': 'Alamat Email',
    'Email': 'Email',
    'Password': 'Kata Sandi',
    'Forgot password?': 'Lupa kata sandi?',
    'Logging in...': 'Sedang masuk...',
    'or': 'atau',
    'Don\'t have an account?': 'Belum punya akun?',
    'Sign up': 'Daftar',
    'Login Illustration': 'Ilustrasi Login',

    'common.user': 'Pengguna',
    'common.thisItem': 'item ini',
    'breadcrumb.home': 'Beranda',
    'breadcrumb.accountSettings': 'Pengaturan Akun',

    'nav.welcome': 'Selamat Datang',
    'nav.inventory': 'Inventaris',
    'nav.inventory.manage': 'Kelola',
    'nav.inventory.bookings': 'Pemesanan',
    'nav.inventory.performance': 'Performa',
    'nav.inventory.availability': 'Ketersediaan',
    'nav.inventory.pricing': 'Harga',
    'nav.inventory.audience': 'Audiens',
    'nav.campaign': 'Kampanye',

    'menu.notifications.title': 'Notifikasi',
    'menu.notifications.clear': 'Bersihkan',
    'menu.notifications.empty': 'Belum ada notifikasi',
    'menu.notifications.soundOn': 'Nyalakan suara',
    'menu.notifications.soundOff': 'Matikan suara',
    'menu.profile': 'Profil',
    'menu.subscription': 'Langganan',
    'menu.inventory': 'Inventaris',
    'menu.campaign': 'Kampanye',
    'menu.video-editor': 'Editor Video',
    'menu.wallet': 'Dompet',
    'menu.docs': 'Dokumentasi',
    'menu.docs.accessDenied': 'Anda tidak memiliki akses ke dokumentasi.',
    'menu.docs.accessFailed': 'Token akses dokumentasi tidak dikembalikan.',
    'menu.logout': 'Keluar',
    'menu.users': 'Anggota',
    'menu.upload.completed.title': 'Unggahan Selesai',
    'menu.upload.completed.message': 'Semua file sudah diproses. Selesai: {{completed}}',
    'menu.upload.issues.title': 'Masalah Unggahan',
    'menu.upload.status.title': 'Status Unggahan',
    'menu.upload.status.loadFailed': 'Gagal memuat status antrean unggahan.',

    'header.logoAlt': 'Logo Perusahaan',
    'header.clientLogoAlt': 'Logo Dashboard Klien',

    'footer.rightsReserved': 'Hak cipta dilindungi undang-undang.',
    'footer.scrollTop': 'Gulir ke atas',

    'welcome.startCampaign': 'Mulai Kampanye',
    'welcome.addMediaSpot': 'Tambah Media Spot',
    'welcome.growTitle': 'Kembangkan Bisnis Anda Bersama Kami',
    'welcome.startCampaign.desc': 'Menambah kampanye akan meningkatkan visibilitas Anda kepada calon audiens.',
    'welcome.addMediaSpot.desc': 'Tambahkan media spot baru untuk meningkatkan visibilitas Anda.',
    'welcome.illustrationAlt': 'Ilustrasi Media Digital',
    'welcome.card1.title': 'Mencari Layar Digital tapi Bingung Mulai dari Mana?',
    'welcome.card1.desc': 'Kami bisa membantu menyediakan solusi yang terjangkau, mudah disiapkan, dan siap digunakan—tanpa perlu kemampuan teknis.',
    'welcome.card1.cta': 'Belanja Sekarang',
    'welcome.card2.imageAlt': 'Dokumentasi Manual',
    'welcome.card2.title': 'Butuh Bantuan? Kami Siap Membantu!',
    'welcome.card2.desc': 'Jelajahi dokumentasi atau FAQ untuk memaksimalkan penggunaan platform.',
    'welcome.card2.cta': 'Dapatkan Bantuan',
    'welcome.card3.imageAlt': 'Dukungan',
    'welcome.card3.title': 'Tonton Video Tutorial Langkah demi Langkah',
    'welcome.card3.desc': 'Cara termudah untuk mulai dan menguasai platform.',
    'welcome.card3.cta': 'Tonton Video',

    'common.yes': 'Ya',
    'common.no': 'Tidak',
    'common.edit': 'Edit',
    'common.delete': 'Hapus',
    'common.review': 'Tinjau',
    'common.cancel': 'Batal',
    'common.confirm': 'Konfirmasi',
    'common.error': 'Error',
    'common.success': 'Berhasil',
    'common.turnOn': 'Nyalakan',
    'common.save': 'Simpan',
    'common.na': 'N/A',
    'common.retry': 'Coba Lagi',
    'common.detail': 'Detail',
    'common.replace': 'Ganti',
    'common.accept': 'Terima',
    'common.decline': 'Tolak',
    'common.play': 'Putar',
    'common.pause': 'Jeda',
    'common.mute': 'Senyap',
    'common.unmute': 'Aktifkan Suara',
    'common.restart': 'Ulangi',
    'common.upload': 'Unggah',
    'common.change': 'Ubah',
    'common.back': 'Kembali',
    'common.saving': 'Menyimpan...',
    'common.validationError': 'Validasi Gagal',
    'common.confirmDelete.title': 'Konfirmasi Hapus',
    'common.confirmDelete.message': 'Hapus \"{{name}}\"?',
    'common.unauthorized': 'Tidak diizinkan: token tidak ada atau tidak valid.',
    'common.unexpectedError': 'Terjadi kesalahan yang tidak terduga.',
    'layout.layout': 'Tata Letak',
    'layout.selectTemplate': 'Pilih Template Tata Letak',
    'layout.selectTemplateHint': 'Pilih template di sebelah kiri, lalu klik Lanjutkan untuk mengonfigurasi konten.',
    'layout.setLayout': 'Atur Tata Letak',
    'layout.continue': 'Lanjutkan',
    'layout.confirm': 'Konfirmasi',
    'layout.editContent': 'Edit Konten Widget',
    'layout.editContentHint': 'Konfigurasikan konten untuk area non-kreatif di template ini.',
    'layout.widget': 'Widget',
    'layout.runningText': 'Teks Berjalan',
    'layout.widgetUrl': 'URL Widget',
    'layout.runningTextContent': 'Konten Teks Berjalan',
    'layout.runningTextPlaceholder': 'Masukkan teks yang akan ditampilkan...',
    'layout.assignedSuccess': 'Tata letak berhasil ditetapkan.',
    'layout.assignFailed': 'Gagal menetapkan tata letak.',
    'layout.backToScreens': '← Kembali ke Daftar Layar',
    'layout.setLayoutFor': 'Atur Tata Letak untuk',
    'layout.saveLayout': 'Simpan Tata Letak',
    'layout.preview': 'Pratinjau',
    'layout.confirmTitle': 'Konfirmasi Perubahan Tata Letak',
    'layout.confirmMessage': 'Anda akan menetapkan tata letak ini. Apakah Anda yakin?',
    'layout.templateDifferentWarning': 'Ini adalah template yang berbeda dari yang sedang digunakan. Setelah dikonfirmasi, perubahan akan berlaku mulai besok pukul 00:00.',
    'layout.apply': 'Terapkan',
    'layout.successTitle': 'Tata Letak Berhasil Diterapkan',
    'layout.successMessage': 'Tata letak baru telah berhasil ditetapkan ke layar.',
    'layout.selectType': 'Tipe',
    'layout.chooseType': '-- Pilih Tipe --',
    'layout.noConfigRequired': 'Tidak diperlukan konfigurasi tambahan untuk template ini.',

    'status.pending': 'Menunggu',
    'status.confirmed': 'Terkonfirmasi',
    'status.active': 'Aktif',
    'status.inactive': 'Tidak Aktif',
    'status.available': 'Tersedia',
    'status.unavailable': 'Tidak Tersedia',
    'status.unknown': 'Tidak Diketahui',

    'table.actions': 'Aksi',
    'table.loading': 'Memuat...',
    'table.selectedCount': '{{count}} item dipilih',
    'table.deleteSelected': 'Hapus yang Dipilih',
    'table.clearSelection': 'Bersihkan Pilihan',
    'table.moreActions': 'Aksi lainnya',
    'table.sort.asc': 'Urutkan naik',
    'table.sort.desc': 'Urutkan turun',
    'table.sort.remove': 'Hapus pengurutan',
    'table.filter.filter': 'Filter {{column}}',
    'table.filter.select': 'Pilih {{column}}',
    'table.filter.all': 'Semua',
    'table.filter.from': 'Dari',
    'table.filter.to': 'sampai',
    'table.filter.toField': 'Sampai',
    'table.filter.clear': 'Bersihkan filter',
    'table.operator.contains': 'Mengandung',
    'table.operator.equals': 'Sama dengan',
    'table.operator.startsWith': 'Diawali dengan',
    'table.operator.endsWith': 'Diakhiri dengan',
    'table.operator.greaterThan': 'Lebih besar dari',
    'table.operator.lessThan': 'Lebih kecil dari',
    'table.operator.between': 'Di antara',
    'table.operator.after': 'Setelah',
    'table.operator.before': 'Sebelum',
    'table.bulkDelete.noneSelected': 'Tidak ada item yang dipilih.',
    'table.bulkDelete.invalidSelection': 'Item yang dipilih tidak valid untuk dihapus.',

    'pagination.itemsPerPage': 'Item per halaman:',
    'pagination.range': '{{start}}-{{end}} dari {{total}} item',
    'pagination.first': 'Halaman pertama',
    'pagination.prev': 'Halaman sebelumnya',
    'pagination.next': 'Halaman berikutnya',
    'pagination.last': 'Halaman terakhir',
    'pagination.goToPage': 'Ke halaman {{page}}',

    'campaign.summary.total': 'Total Kampanye',
    'campaign.summary.draft': 'Draf',
    'campaign.summary.active': 'Aktif',
    'campaign.summary.pending': 'Menunggu',
    'campaign.summary.paused': 'Dijeda',
    'campaign.summary.failed': 'Gagal',
    'campaign.action.newCampaign': '+ Kampanye Baru',
    'campaign.balance.accountBalance': 'Saldo Akun',
    'campaign.balance.campaignWallet': 'Dompet Kampanye',
    'campaign.balance.allocated': 'Anggaran Dialokasikan',
    'campaign.balance.remaining': 'Sisa Anggaran',
    'campaign.balance.spent': 'Anggaran Terpakai',
    'campaign.balance.avgSpending': 'Rata-rata Pengeluaran Anggaran',
    'campaign.balance.perDay': '/hari',
    'campaign.table.title': 'Kampanye',
    'campaign.table.column.campaignName': 'Nama Kampanye',
    'campaign.table.column.spot': 'Spot',
    'campaign.table.column.venue': 'Lokasi',
    'campaign.table.column.budget': 'Anggaran',
    'campaign.table.column.period': 'Periode',
    'campaign.table.column.status': 'Status',
    'campaign.status.draft': 'Draf',
    'campaign.status.active': 'Aktif',
    'campaign.status.pending': 'Menunggu',
    'campaign.status.paused': 'Dijeda',
    'campaign.status.failed': 'Gagal',
    'campaign.spots.title': 'Katalog Spot',
    'campaign.spots.viewAll': 'Lihat Semua',
    'campaign.error.summaryLoadFailed': 'Gagal memuat ringkasan kampanye.',
    'campaign.error.listLoadFailed': 'Gagal memuat daftar kampanye.',

    'spots.retry': 'Coba Lagi',
    'spots.openDetail': 'Buka detail spot',
    'spots.imageAlt': 'Gambar Spot',
    'spots.screensCount': 'Jumlah layar',
    'spots.alreadyInCampaign': 'Sudah di Kampanye',
    'spots.addToCampaign': 'Tambah ke Kampanye',
    'spots.processing': 'Memproses...',
    'spots.cancel': 'Batal',
    'spots.empty.title': 'Tidak ada spot tersedia',
    'spots.empty.subtitle': 'Silakan coba lagi atau sesuaikan filter.',
    'spots.pagination.showing': 'Menampilkan {{start}}–{{end}} dari {{total}}',
    'spots.pagination.prev': 'Sebelumnya',
    'spots.pagination.next': 'Berikutnya',
    'spots.pagination.pageOf': 'Halaman {{page}} dari {{total}}',
    'spots.error.loadFailed': 'Gagal memuat katalog spot. Silakan coba lagi.',

    'inventory.card.mediaSpot': 'Media Spot',
    'inventory.card.screen': 'Layar',
    'inventory.card.needUnlockScreenLimit': 'Ingin membuka batas layar?',
    'inventory.card.upgradePackage': 'Upgrade Paket',
    'inventory.chart.bookedVsAvailable': 'Dipesan vs Tersedia',
    'inventory.chart.booked': 'Dipesan',
    'inventory.chart.available': 'Tersedia',
    'inventory.chart.onlineVsOffline': 'Layar Online vs Offline',
    'inventory.chart.online': 'Online',
    'inventory.chart.offline': 'Offline',
    'inventory.ads.inHouseAds': 'Iklan Internal',
    'inventory.ads.commercialAds': 'Iklan Komersial',
    'inventory.revenue.todayRevenue': 'Pendapatan Hari Ini',
    'inventory.revenue.viewReport': 'Lihat Laporan',
    'inventory.revenue.optimize': 'Optimalkan Pendapatan',
    'inventory.balance.totalBalance': 'Total Saldo',
    'inventory.balance.autoWithdrawal.active': 'Penarikan otomatis aktif.',
    'inventory.balance.autoWithdrawal.payouts': 'Payout mengikuti jadwal Anda',
    'inventory.balance.autoWithdrawal.every': 'setiap {{schedule}}',
    'inventory.balance.autoWithdrawal.basedOnSettings': 'sesuai pengaturan payout Anda.',
    'inventory.balance.changeSchedule': 'Ubah Jadwal',
    'inventory.balance.requestWithdrawal': 'Ajukan Penarikan',
    'inventory.balance.autoWithdrawal': 'Penarikan Otomatis',
    'inventory.table.title.inventoryManagement': 'Manajemen Inventaris',
    'inventory.table.title.mediaSpotManagement': 'Manajemen Media Spot',
    'inventory.action.add': 'Tambah',
    'inventory.action.addMediaSpot': 'Tambah Media Spot',
    'inventory.player.downloadTitle': 'Unduh Player',
    'inventory.player.downloadDesc': 'Unduh dan instal player kami di layar Anda untuk terhubung.',
    'inventory.player.learnMore': 'Pelajari',
    'inventory.platform.alt': 'Platform {{name}}',
    'inventory.upgrade.title': 'Upgrade Paket',
    'inventory.upgrade.message': 'Upgrade paket saat ini memerlukan bantuan tim kami. Hubungi kami (email: {{email}}) dan kami akan membantu Anda mengganti paket dengan lancar.',

    'inventory.nav.manage': 'Media Spot',
    'inventory.nav.bookings': 'Pemesanan',
    'inventory.nav.performance': 'Performa',
    'inventory.nav.pricing': 'Harga',
    'inventory.nav.audience': 'Audiens',

    'inventory.manage.title': 'Manajemen Media Spot',
    'inventory.manage.linkedHint': 'Layar pada spot ini diputar bersamaan',
    'inventory.manage.confirmedScreens': 'Layar Terkonfirmasi',
    'inventory.manage.pendingScreens': 'Layar Menunggu',
    'inventory.manage.offScreens': 'Layar Off',
    'inventory.manage.invalidSpotGroup': 'Grup spot tidak valid.',
    'inventory.manage.confirmDelete.title': 'Konfirmasi Hapus',
    'inventory.manage.confirmDelete.message': 'Hapus \"{{name}}\"?',
    'inventory.manage.deleteFailed': 'Gagal menghapus spot.',
    'inventory.manage.deleteError': 'Terjadi kesalahan saat menghapus data.',
    'inventory.manage.action.addScreen': 'Tambah Layar',
    'inventory.manage.action.toggle': 'Ubah Status',
    'inventory.manage.detail.empty': 'Tidak ada detail tersedia',
    'inventory.manage.toggle.title': 'Matikan Media Spot',
    'inventory.manage.toggle.titleOn': 'Nyalakan Media Spot',
    'inventory.manage.toggle.warning.title': 'Peringatan',
    'inventory.manage.toggle.warning.description': 'Layar saat ini sedang menayangkan kampanye aktif. Mematikan layar akan langsung menghentikan pemutaran untuk:',
    'inventory.manage.toggle.warning.checkbox': 'Saya memahami dan setuju bahwa interupsi kampanye dapat mengakibatkan denda sesuai ketentuan yang berlaku.',
    'inventory.manage.toggle.reasonLabel': 'Alasan mematikan (dibagikan ke pengiklan yang terdampak):',
    'inventory.manage.toggle.reasonPlaceholder': 'Jelaskan alasan Anda mematikan media spot ini...',
    'inventory.manage.toggle.keepScreenOn': 'Tetap Nyalakan',
    'inventory.manage.toggle.turnOffAnyway': 'Tetap Matikan',
    'inventory.manage.toggle.turnOn.title': 'Nyalakan Media Spot',
    'inventory.manage.toggle.turnOn.description': 'Semua layar di media spot ini akan dinyalakan. Layar akan beroperasi normal kembali.',
    'inventory.manage.toggle.turnOn.checkbox': 'Saya yakin ingin menyalakan media spot ini dan semua layarnya.',
    'inventory.manage.toggle.turnOnAnyway': 'Nyalakan',
    'inventory.manage.toggle.confirm.title': 'Apakah Anda yakin ingin mematikan layar berikut?',
    'inventory.manage.toggle.confirm.description': 'Layar berikut akan dimatikan dan menghentikan seluruh pemutaran kampanye.',
    'inventory.manage.toggle.confirm.table.screenName': 'Nama Layar',
    'inventory.manage.toggle.confirm.table.spot': 'Spot',
    'inventory.manage.toggle.confirm.table.group': 'Grup',
    'inventory.manage.toggle.confirm.yes': 'Ya',
    'inventory.manage.toggle.confirm.titleOn': 'Konfirmasi Nyalakan',
    'inventory.manage.toggle.confirm.messageOn': 'Apakah Anda yakin ingin menyalakan \"{{name}}\"?',
    'inventory.manage.toggle.success.title': 'Berhasil',
    'inventory.manage.toggle.success.messageOff': 'Layar berhasil dimatikan.',
    'inventory.manage.toggle.success.messageOn': 'Layar berhasil dinyalakan.',
    'inventory.manage.toggle.success.ok': 'OK',
    'inventory.manage.toggle.failed': 'Gagal mengubah status spot.',

    'inventory.detail.screenName': 'Nama Layar',
    'inventory.detail.serialNo': 'No. Seri',
    'inventory.detail.brand': 'Merek',
    'inventory.detail.model': 'Model',
    'inventory.detail.os': 'OS',
    'inventory.detail.player': 'Player',
    'inventory.detail.status': 'Status',
    'inventory.detail.screenStatus': 'Status Layar',
    'inventory.screen.column.deviceId': 'ID Perangkat',
    'inventory.screen.column.orientation': 'Orientasi',
    'inventory.orientation.landscape': 'Lanskap',
    'inventory.orientation.portrait': 'Potret',
    'inventory.screen.invalid': 'Layar tidak valid.',
    'inventory.screen.delete.success': 'Layar berhasil dihapus.',
    'inventory.screen.delete.failed': 'Gagal menghapus layar.',
    'inventory.screen.delete.httpFailed': 'Gagal menghapus layar.',
    'inventory.screen.toggle.confirm.messageOn': 'Apakah Anda yakin ingin menyalakan layar "{{name}}"?',
    'inventory.screen.action.turnOff': 'Matikan',

    'inventory.bookings.title': 'Manajemen Pemesanan',
    'inventory.bookings.column.bookingId': 'ID Pemesanan',
    'inventory.bookings.column.advertiser': 'Pengiklan',
    'inventory.bookings.column.campaign': 'Kampanye',
    'inventory.bookings.column.mediaSpot': 'Media Spot',
    'inventory.bookings.column.period': 'Periode',
    'inventory.bookings.column.autoCancel': 'Batal Otomatis',
    'inventory.bookings.periodWithStart': '{{days}} hari, mulai {{start}}',

    'inventory.availability.title': 'Manajemen Ketersediaan',
    'inventory.performance.title': 'Analitik Performa',
    'inventory.pricing.title': 'Manajemen Harga',
    'inventory.audience.title': 'Analitik Audiens',

    'inventory.column.spotName': 'Nama Spot',
    'inventory.column.id': 'ID',
    'inventory.column.category': 'Kategori',
    'inventory.column.mediaType': 'Tipe Media',
    'inventory.column.office': 'Kantor',
    'inventory.column.pairedScreen': 'Layar Terkait',
    'inventory.column.groupName': 'Nama Grup',
    'inventory.column.venueType': 'Tipe Lokasi',
    'inventory.column.group': 'Grup',
    'inventory.column.status': 'Status',
    'inventory.column.syncStatus': 'Status Sinkron',
    'inventory.column.createdTime': 'Waktu Dibuat',
    'inventory.column.updatedTime': 'Waktu Diperbarui',
    'inventory.column.deletedTime': 'Waktu Dihapus',
    'inventory.column.spotGroup': 'Grup Spot',
    'inventory.column.screenLabel': 'Label Layar',
    'inventory.column.occupancy': 'Okupansi',
    'inventory.column.revenue': 'Pendapatan',
    'inventory.column.totalScreens': 'Total Layar',
    'inventory.column.thirdPartySlot': 'Slot Pihak Ketiga',
    'inventory.column.value': 'Nilai',
    'inventory.column.promotion': 'Promosi',
    'inventory.column.specialOffer': 'Penawaran Khusus',
    'inventory.column.audienceType': 'Tipe Audiens',
    'inventory.column.approxDailyFootfall': 'Perkiraan Footfall Harian',

    'inventory.mediaType.digitalSignage': 'Digital Signage',
    'inventory.mediaType.ledDisplay': 'LED Display',
    'inventory.mediaType.lcdMonitor': 'LCD Monitor',

    'inventory.empty.availability': 'Tidak ada data ketersediaan',
    'inventory.empty.bookings': 'Tidak ada data pemesanan',
    'inventory.empty.performance': 'Belum ada data performa saat ini',
    'inventory.empty.pricing': 'Tidak ada data harga',
    'inventory.empty.audience': 'Tidak ada data audiens',

    'account.title': 'Akun',
    'account.breadcrumb.main': 'Utama',
    'account.license.title': 'Lisensi',
    'account.license.section.subscription.title': 'Langganan',
    'account.license.subscription.accountSubscription.title': 'Langganan Akun',
    'account.license.subscription.accountSubscription.subtitle': 'Upgrade langganan Anda',
    'account.license.subscription.accountSubscription.badge': 'Gratis Basic - Lisensi 1 Layar',
    'account.license.subscription.addLicenses.title': 'Tambah Lisensi',
    'account.license.subscription.addLicenses.subtitle': 'Tambahkan lebih banyak lisensi agar lebih menarik perhatian penonton Anda',
    'account.license.subscription.changePlan.title': 'Ganti Paket',
    'account.license.subscription.changePlan.subtitle': 'Upgrade ke Premium atau Enterprise untuk fitur lebih banyak.',
    'account.license.subscription.changePlan.badge': 'Upgrade ke Premium',
    'account.license.section.users.title': 'Pengguna',
    'account.license.users.usersCard.title': 'Pengguna',
    'account.license.users.usersCard.subtitle': 'Tambahkan pengguna ke akun Anda dengan tingkat akses yang berbeda.',
    'account.license.users.usersCard.badge': '1 Pengguna',
    'account.license.users.groups.title': 'Grup',
    'account.license.users.groups.subtitle': 'Atur pengguna Anda ke dalam grup dan tetapkan peran di workspace utama atau workspace lainnya.',
    'account.license.users.groups.badge': '0 Grup',
    'account.license.users.securityPolicies.title': 'Kebijakan Keamanan',
    'account.license.users.securityPolicies.subtitle': 'Terapkan kebijakan kata sandi dan sesi untuk pengguna Anda. Atur daftar putih alamat IP.',
    'account.license.users.sso.title': 'SSO (Single Sign On)',
    'account.license.users.sso.subtitle': 'Siapkan Single Sign On dengan Identity Provider SAML Anda.',
    'account.license.section.player.title': 'Player',
    'account.license.player.bootLogo.title': 'Logo Boot Player',
    'account.license.player.bootLogo.subtitle': 'Tampilkan gambar atau logo kustom saat Player menyala.',
    'account.license.section.advanced.title': 'Pengaturan Lanjutan',
    'account.license.advanced.apiTokens.title': 'Token API',
    'account.license.advanced.apiTokens.subtitle': 'Gunakan token API sebagai kunci aman untuk mengautentikasi dan mengotorisasi akses ke aplikasi dan layanan eksternal.',
    'account.license.advanced.apiTokens.badge': 'Token',
    'account.license.advanced.auditLog.title': 'Log Audit',
    'account.license.advanced.auditLog.subtitle': 'Catatan aktivitas terperinci untuk semua pengguna di akun Anda.',
    'account.license.badge.disabled': 'Nonaktif',
    'account.license.badge.default': 'Bawaan',
    'account.userManagement.title': 'Manajemen Pengguna',
    'account.userManagement.members.title': 'Anggota',
    'account.userManagement.members.inviteUser': 'Undang Pengguna',
    'account.userManagement.members.column.fullName': 'Nama Lengkap',
    'account.userManagement.members.column.email': 'Email',
    'account.userManagement.members.column.groupOrder': 'Grup',
    'account.userManagement.members.column.role': 'Peran',
    'account.userManagement.members.column.lastActive': 'Aktif Terakhir',
    'account.userManagement.members.column.invitedOn': 'Diundang Pada',
    'account.userManagement.members.loadFailed': 'Gagal memuat data anggota.',
    'account.userManagement.groups.title': 'Grup Pengguna',
    'account.userManagement.groups.addGroup': 'Tambah Grup',
    'account.userManagement.groups.column.groupName': 'Nama Grup',
    'account.userManagement.groups.column.members': 'Anggota',
    'account.userManagement.groups.column.dateCreated': 'Tanggal Dibuat',
    'account.userManagement.groups.loadFailed': 'Gagal memuat grup pengguna.',
    'account.userManagement.groups.deleteSuccess': 'Grup berhasil dihapus.',
    'account.userManagement.groups.deleteFailed': 'Gagal menghapus grup.',

    'account.menu.settings': 'Pengaturan',
    'account.menu.business': 'Bisnis',
    'account.menu.preference': 'Preferensi',
    'account.menu.favorite': 'Favorit',
    'account.menu.collaboard': 'CollaBoard',

    'account.settings.basicInfo': 'Info Dasar',
    'account.settings.security': 'Keamanan',
    'account.settings.notification': 'Notifikasi',
    'account.settings.company': 'Perusahaan',
    'account.settings.payout': 'Payout',
    'account.settings.shared': 'Dibagikan',
    'account.settings.invitation': 'Undangan',

    'account.inventoryMenu.mediaSpot.title': 'Media Spot',
    'account.inventoryMenu.spotGroup.title': 'Grup Spot',
    'account.inventoryMenu.spotGroup.addGroup': 'Tambah Grup',
    'account.inventoryMenu.spotGroup.column.groupName': 'Nama Grup',
    'account.inventoryMenu.spotGroup.column.excludeOffers': 'Kecualikan Promo',
    'account.inventoryMenu.spotGroup.invalidGroup': 'Grup spot tidak valid.',
    'account.inventoryMenu.spotGroup.deleteFailed': 'Terjadi kesalahan saat menghapus data.',
    'account.inventoryMenu.spotGroup.bulkDeleteSuccess': 'Grup spot berhasil dihapus.',
    'account.inventoryMenu.screens.title': 'Layar',

    'account.inventoryMenu.bookings.pending.title': 'Pemesanan Menunggu',
    'account.inventoryMenu.bookings.pending.empty': 'Tidak ada pemesanan menunggu',
    'account.inventoryMenu.bookings.accepted.title': 'Pemesanan Diterima',
    'account.inventoryMenu.bookings.accepted.empty': 'Tidak ada pemesanan diterima',
    'account.inventoryMenu.bookings.declined.title': 'Pemesanan Ditolak',
    'account.inventoryMenu.bookings.declined.empty': 'Tidak ada pemesanan ditolak',
    'account.inventoryMenu.bookings.canceled.title': 'Pemesanan Dibatalkan',
    'account.inventoryMenu.bookings.canceled.empty': 'Tidak ada pemesanan dibatalkan',
    'account.inventoryMenu.bookings.title': 'Pemesanan',
    'account.inventoryMenu.bookings.tab.pending': 'Menunggu',
    'account.inventoryMenu.bookings.tab.accepted': 'Diterima',
    'account.inventoryMenu.bookings.tab.declined': 'Ditolak',
    'account.inventoryMenu.bookings.tab.canceled': 'Dibatalkan',
    'account.inventoryMenu.bookings.column.date': 'Tanggal',
    'account.inventoryMenu.bookings.column.canceledBy': 'Dibatalkan Oleh',

    'account.inventoryMenu.screens.edit.title': 'Edit Layar',
    'account.inventoryMenu.screens.edit.section.screenInfo': 'Informasi Layar',
    'account.inventoryMenu.screens.edit.label.deviceId': 'ID Perangkat',
    'account.inventoryMenu.screens.edit.label.brand': 'Merek',
    'account.inventoryMenu.screens.edit.label.model': 'Model',
    'account.inventoryMenu.screens.edit.label.osVersion': 'Versi OS',
    'account.inventoryMenu.screens.edit.label.sdkVersion': 'Versi SDK',
    'account.inventoryMenu.screens.edit.label.firmwareVersion': 'Versi Firmware',
    'account.inventoryMenu.screens.edit.label.playerVersion': 'Versi Player',
    'account.inventoryMenu.screens.edit.label.screenResolution': 'Resolusi Layar',
    'account.inventoryMenu.screens.edit.label.spotName': 'Nama Spot',
    'account.inventoryMenu.screens.edit.label.screenName': 'Nama Layar',
    'account.inventoryMenu.screens.edit.label.orientation': 'Orientasi Layar',
    'account.inventoryMenu.screens.edit.screenName.placeholder': 'Masukkan nama layar',
    'account.inventoryMenu.screens.edit.select.spot.placeholder': 'Pilih spot',
    'account.inventoryMenu.screens.edit.select.spot.searchPlaceholder': 'Cari spot...',
    'account.inventoryMenu.screens.edit.select.orientation.placeholder': 'Pilih orientasi',
    'account.inventoryMenu.screens.edit.select.orientation.searchPlaceholder': 'Cari orientasi...',
    'account.inventoryMenu.screens.edit.validation.missingRequired': 'Field wajib belum lengkap.',
    'account.inventoryMenu.screens.edit.validation.screenNameInvalid': 'Nama layar minimal 3 karakter dan hanya boleh berisi karakter yang valid.',
    'account.inventoryMenu.screens.edit.updateSuccess': 'Data berhasil diperbarui.',
    'account.inventoryMenu.screens.edit.updateFailed': 'Gagal memperbarui data.',
    'account.inventoryMenu.screens.edit.unauthorized': 'Autentikasi gagal: kredensial tidak valid.',
    'account.inventoryMenu.screens.edit.invalidScreenId': 'ID layar tidak valid.',
    'account.inventoryMenu.screens.edit.serverError': 'Terjadi kesalahan saat memperbarui data.',

    'account.campaignWallet.balance.label': 'Saldo Dompet',
    'account.campaignWallet.action.addFunds': 'Tambah Dana',
    'account.campaignWallet.stats.budgetAllocationThisMonth': 'Alokasi Anggaran (Bulan Ini)',
    'account.campaignWallet.stats.mtdSpend': 'Pengeluaran Bulan Ini',
    'account.campaignWallet.stats.mtdCostPerPlay': 'Biaya per Putar (Bulan Ini)',
    'account.campaignWallet.transactions.title': 'Riwayat Transaksi Dompet',
    'account.campaignWallet.table.column.date': 'Tanggal',
    'account.campaignWallet.table.column.paymentMethod': 'Metode Bayar',
    'account.campaignWallet.table.column.amount': 'Jumlah',
    'account.campaignWallet.table.column.status': 'Status',

    'account.inventoryMenu.bookingReview.title': 'Tinjauan Pemesanan',
    'account.inventoryMenu.bookingReview.subtitle': 'Tinjau iklan yang diajukan untuk memastikan sesuai standar Anda',
    'account.inventoryMenu.bookingReview.label.advertiser': 'Pengiklan',
    'account.inventoryMenu.bookingReview.label.durationResolution': 'Durasi & Resolusi',
    'account.inventoryMenu.bookingReview.label.campaignName': 'Nama Kampanye',
    'account.inventoryMenu.bookingReview.label.campaignSchedule': 'Jadwal Kampanye',
    'account.inventoryMenu.bookingReview.label.mediaSpot': 'Media Spot',
    'account.inventoryMenu.bookingReview.viewSpot': 'Lihat Spot',
    'account.inventoryMenu.bookingReview.durationSeconds': '{{seconds}} detik',
    'account.inventoryMenu.bookingReview.resolutionPixels': '{{width}} × {{height}} piksel',
    'account.inventoryMenu.bookingReview.durationResolution': '{{duration}}, {{resolution}}',
    'account.inventoryMenu.bookingReview.spotNotFound': 'Detail spot tidak ditemukan.',
    'account.inventoryMenu.bookingReview.loadSpotFailed': 'Gagal memuat detail spot.',
    'account.inventoryMenu.bookingReview.accepted': 'Berhasil diterima.',
    'account.inventoryMenu.bookingReview.acceptFailed': 'Gagal menerima pemesanan.',
    'account.inventoryMenu.bookingReview.declined': 'Berhasil ditolak.',
    'account.inventoryMenu.bookingReview.declineFailed': 'Gagal menolak pemesanan.',

    'account.subscription.activePlan.title': 'Paket Aktif',
    'account.subscription.activePlan.loading': 'Memuat detail paket...',
    'account.subscription.activePlan.loadFailed': 'Gagal memuat paket langganan. Silakan coba lagi nanti.',
    'account.subscription.activePlan.unlimited': 'Tanpa Batas',
    'account.subscription.activePlan.noCreditCard': 'Tanpa kartu kredit, tanpa biaya tersembunyi, tanpa batas waktu, tanpa tekanan.',
    'account.subscription.activePlan.renewalDate': 'Tanggal Perpanjangan',
    'account.subscription.activePlan.billingCycle': 'Siklus Tagihan',
    'account.subscription.activePlan.activeSince': 'Aktif Sejak',
    'account.subscription.activePlan.features': 'Fitur dan Manfaat',
    'account.subscription.activePlan.noFeatures': 'Tidak ada fitur tersedia',

    'account.subscription.upgradePlan.title': 'Upgrade Paket',
    'account.subscription.upgradePlan.month': 'Bulan',
    'account.subscription.upgradePlan.orderSummary': 'Ringkasan Pesanan',
    'account.subscription.upgradePlan.tax': 'Pajak',
    'account.subscription.upgradePlan.total': 'Total',
    'account.subscription.upgradePlan.voucherCode': 'Kode Voucher',
    'account.subscription.upgradePlan.voucherPlaceholder': 'Masukkan kode voucher',
    'account.subscription.upgradePlan.applyVoucher': 'Terapkan',
    'account.subscription.upgradePlan.checkout': 'Checkout',
    'account.subscription.upgradePlan.loadFailed': 'Gagal memuat paket upgrade',
    'account.subscription.upgradePlan.cartEmpty.title': 'Keranjang Kosong',
    'account.subscription.upgradePlan.cartEmpty.message': 'Belum ada fitur dipilih. Silakan pilih fitur dan atur kuantitas/durasi sebelum checkout.',
    'account.subscription.upgradePlan.paymentInitiated.title': 'Pembayaran Dimulai',
    'account.subscription.upgradePlan.paymentInitiated.message': 'Pembayaran langganan Anda berhasil dibuat. Silakan selesaikan pembayaran menggunakan Virtual Account yang tersedia.',
    'account.subscription.upgradePlan.paymentInitiated.button': 'Lihat Pesanan',
    'account.subscription.upgradePlan.checkoutFailed': 'Checkout gagal dibuat',
    'account.subscription.upgradePlan.previewFailed': 'Gagal menghitung pratinjau',

    'account.subscription.orders.title': 'Pesanan Saya',
    'account.subscription.orders.subtitle': 'Kelola riwayat dan status pesanan Anda',
    'account.subscription.orders.items.title': 'Item Pesanan',
    'account.subscription.orders.column.date': 'Tanggal',
    'account.subscription.orders.column.description': 'Deskripsi',
    'account.subscription.orders.column.price': 'Harga',
    'account.subscription.orders.moreItems': ' +{{count}} lainnya',
    'account.subscription.orders.orderId': 'Pesanan {{id}}',
    'account.subscription.orders.loadFailed': 'Gagal memuat riwayat langganan.',
    'account.subscription.orders.paymentDetailFailed': 'Gagal memuat detail pembayaran.',
    'account.subscription.orders.items.column.item': 'Item',
    'account.subscription.orders.items.column.unit': 'Satuan',
    'account.subscription.orders.items.column.qty': 'Qty',
    'account.subscription.orders.items.column.duration': 'Durasi',
    'account.subscription.orders.items.column.pricePerUnit': 'Harga/Satuan',
    'account.subscription.orders.items.column.subtotal': 'Subtotal',

    'account.campaignWallet.title': 'Dompet Kampanye',
    'account.campaign.menu.create': 'Buat',
    'account.campaign.menu.drafts': 'Draf',
    'account.campaign.menu.pending': 'Menunggu',
    'account.campaign.menu.running': 'Berjalan',
    'account.campaign.menu.paused': 'Dijeda',
    'account.campaign.menu.failed': 'Gagal',
    'account.campaign.menu.completed': 'Selesai',
    'account.campaign.menu.edit': 'Edit',
    'account.campaign.menu.drafts.summary': '{{ready}} siap \u2022 {{incomplete}} belum lengkap',
    'account.campaign.menu.summary.campaignsSpots': '{{campaigns}} kampanye \u2022 {{spots}} spot',
    'account.campaign.menu.confirmSwitch.message': 'Pindah menu dan reset data edit?',
    'account.campaign.menu.confirmSwitch.confirm': 'Pindah',

    'account.campaign.create.campaignName': 'Nama Kampanye',
    'account.campaign.create.campaignName.placeholder': 'Tulis di sini',
    'account.campaign.create.dateStart': 'Tanggal Mulai',
    'account.campaign.create.dateEnd': 'Tanggal Selesai',
    'account.campaign.create.timeRange': 'Rentang Waktu',
    'account.campaign.create.fullDay': 'Seharian',
    'account.campaign.create.customTime': 'Waktu Kustom',
    'account.campaign.create.customTime.item': 'Waktu Kustom {{index}}',
    'account.campaign.create.customTime.add': 'Tambah Waktu Kustom',
    'account.campaign.create.customTime.cancel': 'Batal Waktu Kustom',
    'account.campaign.create.saveDraft': 'Simpan sebagai Draf',
    'account.campaign.create.timeRange.earlyMorning': 'Dini Hari',
    'account.campaign.create.timeRange.morning': 'Pagi',
    'account.campaign.create.timeRange.midday': 'Siang',
    'account.campaign.create.timeRange.afternoon': 'Sore',
    'account.campaign.create.timeRange.evening': 'Malam',
    'account.campaign.create.timeRange.lateNight': 'Larut Malam',
    'account.campaign.create.mediaSpot.column.badges': 'Tag',
    'account.campaign.create.mediaSpot.column.availability': 'Ketersediaan',
    'account.campaign.create.mediaSpot.empty': 'Belum ada media spot dipilih',
    'account.campaign.edit.backToDrafts': 'Kembali ke Draft',
    'account.campaign.edit.validation.startDateBeforeToday': 'Tanggal mulai tidak boleh sebelum hari ini.',
    'account.campaign.edit.validation.endDateBeforeStart': 'Tanggal selesai tidak boleh sebelum tanggal mulai.',
    'account.campaign.edit.validation.customTimeRequired': 'Silakan tambahkan minimal satu waktu kustom.',
    'account.campaign.edit.validation.timeRangeRequired': 'Silakan pilih minimal satu rentang waktu.',
    'account.campaign.edit.estimatedAllocation': 'Perkiraan Alokasi',
    'account.campaign.edit.budgetAllocation': 'Alokasi Anggaran',
    'account.campaign.edit.noFixedBudgetHint': 'Belum ada anggaran tetap. Biarkan Mataloka menghitung anggaran berdasarkan lokasi dan tanggal tayang yang dipilih.',
    'account.campaign.edit.availabilityCalculated': 'Ketersediaan dihitung berdasarkan tanggal {{start}} sampai {{end}}.',
    'account.campaign.edit.unavailableSpots.title': 'Beberapa Media Spot tidak dapat dipesan',
    'account.campaign.edit.unavailableSpots.body': 'Satu atau lebih Media Spot yang dipilih tidak tersedia (nonaktif atau sudah penuh) pada tanggal yang dipilih. Silakan hapus atau ganti Media Spot yang tidak tersedia sebelum mengajukan permintaan pemesanan.',
    'account.campaign.edit.addMoreSpot': 'Tambah Spot Lagi',
    'account.campaign.edit.mediaSpotSelected': 'Media Spot sudah dipilih',
    'account.campaign.edit.mediaSpotNotSelected': 'Media Spot belum dipilih',
    'account.campaign.edit.mediaSpotNotSelected.desc': 'Anda belum memilih media spot. Memilih media spot memastikan konten Anda sampai ke tujuan yang tepat.',
    'account.campaign.edit.selectMediaSpot': 'Pilih Media Spot',
    'account.campaign.edit.creativeAsset': 'Aset Kreatif',
    'account.campaign.edit.groupHeader.oneScreen': 'Satu layar',
    'account.campaign.edit.groupHeader.twoSyncedScreens': 'Dua Layar Tersinkron',
    'account.campaign.edit.groupHeader.syncedScreens': '{{count}} Layar Tersinkron',
    'account.campaign.edit.groupHeader.mediaSpot.single': '{{count}} Media Spot',
    'account.campaign.edit.groupHeader.mediaSpot.plural': '{{count}} Media Spot',
    'account.campaign.edit.assetPreviewAlt': 'Pratinjau aset',
    'account.campaign.edit.video': 'Video',
    'account.campaign.edit.groupMeta.totalResolution': 'Total resolusi {{resolution}} - maks. {{size}} per file',
    'account.campaign.edit.groupMeta.master': 'Master: Panel {{panel}}, durasi {{duration}}',
    'account.campaign.edit.groupMeta.status': 'Status',
    'account.campaign.edit.action.saveChanges': 'Simpan Perubahan',
    'account.campaign.edit.action.requestBooking': 'Ajukan Pemesanan',
    'account.campaign.create.validation.invalidFormat': 'Format tidak valid. Silakan lengkapi semua field yang wajib.',
    'account.campaign.create.validation.nameTooShort': 'Nama kampanye minimal 3 karakter.',
    'account.campaign.create.validation.startBeforeToday': 'Tanggal mulai tidak boleh sebelum hari ini.',
    'account.campaign.create.validation.endBeforeStart': 'Tanggal selesai tidak boleh sebelum tanggal mulai.',
    'account.campaign.create.validation.timeRangeRequired': 'Pilih minimal satu rentang waktu.',
    'account.campaign.create.validation.customTimeRequired': 'Tambahkan minimal satu waktu kustom.',
    'account.campaign.create.validation.zeroScreens': 'Ada Media Spot terpilih yang jumlah layarnya 0. Silakan hapus.',
    'account.campaign.create.createFailed': 'Gagal membuat kampanye.',
    'account.campaign.create.upload.invalidFile': 'Hanya file video MP4 yang diizinkan.',
    'account.campaign.create.upload.durationInconsistent': 'Durasi iklan yang diizinkan tidak konsisten untuk spot pada grup ini.',
    'account.campaign.create.upload.durationExceededDetailed': 'Durasi video harus \u2264 {{allowed}} detik. Durasi video terunggah: {{actual}} detik.',

    'account.campaign.completedDetail.loadFailed': 'Gagal memuat detail kampanye selesai.',
    'account.campaign.completedDetail.deliveryRate': '{{rate}}% Terkirim',
    'account.campaign.completedDetail.spotsCount': '{{count}} Spot',
    'account.campaign.completedDetail.screensCount': '{{count}} Layar',
    'account.campaign.completedDetail.hoursCount': '{{hours}} Jam',
    'account.campaign.completedDetail.creativeGroup': 'Grup Kreatif',
    'account.campaign.completedDetail.asset': 'Aset',
    'account.campaign.completedDetail.status.completed': 'Selesai',
    'account.campaign.completedDetail.section.creativeAsset': 'Aset Kreatif',
    'account.campaign.completedDetail.summary.booking': 'Booking',
    'account.campaign.completedDetail.summary.bookingId': 'ID: {{id}}',
    'account.campaign.completedDetail.summary.totalSpent': 'Total Biaya',
    'account.campaign.completedDetail.summary.totalPlays': 'Total Tayang',
    'account.campaign.completedDetail.summary.flightDates': 'Tanggal Tayang',
    'account.campaign.completedDetail.summary.totalMedia': 'Total Media',
    'account.campaign.completedDetail.summary.totalExposure': 'Total Eksposur',
    'account.campaign.completedDetail.table.totalSpent': 'Total Biaya',
    'account.campaign.completedDetail.table.playCount': 'Jumlah Tayang',
    'account.campaign.completedDetail.table.footfall': 'Perkiraan Footfall',

    'account.campaign.edit.upload.processing': 'Memproses unggahan...',
    'account.campaign.edit.upload.placeholder': 'Seret ke sini atau klik untuk unggah',
    'account.campaign.edit.panel': 'Panel {{index}}',
    'account.campaign.edit.upload.timeout.title': 'Unggahan Timeout',
    'account.campaign.edit.upload.timeout.message': 'Status unggahan melebihi batas waktu.',
    'account.campaign.edit.upload.failed.title': 'Unggahan Gagal',
    'account.campaign.edit.upload.failed.message': 'Unggahan gagal.',
    'account.campaign.edit.upload.statusCheckFailed': 'Gagal memeriksa status unggahan.',

    'account.campaign.completed.title': 'Kampanye Selesai',
    'account.campaign.completed.column.spots': 'Spot',
    'account.campaign.completed.column.flightDates': 'Tanggal Tayang',
    'account.campaign.completed.action.playLog': 'Play Log',
    'account.campaign.completed.action.duplicate': 'Duplikasi',
    'account.campaign.completed.empty': 'Tidak ada kampanye selesai',
    'account.campaign.completed.loadFailed': 'Gagal memuat kampanye selesai.',
    'account.campaign.completed.playLog.title': 'Play Log',
    'account.campaign.completed.playLog.invalidId': 'ID kampanye tidak valid untuk diunduh.',
    'account.campaign.completed.playLog.downloadFailed': 'Gagal mengunduh Play Log. Silakan coba lagi.',
    'account.campaign.completed.playLog.downloadError': 'Gagal mengunduh Play Log kampanye.',
    'account.campaign.completed.duplicate.title': 'Duplikasi Kampanye',
    'account.campaign.completed.duplicate.invalidId': 'ID kampanye tidak valid untuk duplikasi.',
    'account.campaign.completed.spot.single': '{{count}} Spot',
    'account.campaign.completed.spot.plural': '{{count}} Spots',

    'account.settings.company.section.companyInfo': 'Informasi Perusahaan',
    'account.settings.company.companyName': 'Nama Perusahaan',
    'account.settings.company.companyName.placeholder': 'Masukkan nama perusahaan',
    'account.settings.company.businessCategory': 'Kategori Bisnis',
    'account.settings.company.businessCategory.placeholder': 'Pilih Kategori Bisnis',
    'account.settings.company.mobileWhatsapp': 'No. HP (untuk WhatsApp)',
    'account.settings.company.mobile.placeholder': 'Masukkan nomor HP',
    'account.settings.company.businessEmail': 'Email Bisnis',
    'account.settings.company.businessEmail.placeholder': 'Masukkan email bisnis',
    'account.settings.company.contactPerson': 'Nama Kontak',
    'account.settings.company.contactPerson.placeholder': 'Masukkan nama kontak',
    'account.settings.company.dashboardLogo': 'Logo Dashboard',
    'account.settings.company.chooseFile': 'Pilih file',
    'account.settings.company.logoHelp': 'Format yang didukung: PNG, JPG, GIF, WEBP. Jika tidak diunggah, logo akan kosong.',
    'account.settings.company.uploadLogo': 'Unggah Logo',
    'account.settings.company.removeLogo': 'Hapus Logo',
    'account.settings.company.businessCategory.loadFailed': 'Gagal memuat kategori bisnis.',
    'account.settings.company.validation.companyNameInvalid': 'Nama perusahaan minimal 3 karakter.',
    'account.settings.company.validation.phoneInvalid': 'Format nomor telepon tidak valid (8-15 digit).',
    'account.settings.company.validation.emailInvalid': 'Format email tidak valid.',
    'account.settings.company.validation.contactPersonInvalid': 'Nama contact person minimal 3 karakter.',
    'account.settings.company.validation.businessCategoryRequired': 'Silakan pilih kategori bisnis.',
    'account.settings.company.validation.imageOnly': 'Silakan pilih file gambar.',
    'account.settings.company.validation.dashboardLogoFormatInvalid': 'Format logo dashboard harus PNG/JPG/GIF/WEBP.',
    'account.settings.company.validation.dashboardLogoRequired': 'Silakan pilih file logo terlebih dahulu.',
    'account.settings.company.updateSuccess': 'Data perusahaan berhasil diperbarui.',
    'account.settings.company.updateFailed': 'Gagal memperbarui data perusahaan.',
    'account.settings.company.dashboardLogo.uploadSuccess': 'Logo dashboard berhasil diunggah.',
    'account.settings.company.dashboardLogo.uploadFailed': 'Gagal mengunggah logo dashboard.',
    'account.settings.company.dashboardLogo.deleteSuccess': 'Logo dashboard berhasil dihapus.',
    'account.settings.company.dashboardLogo.deleteFailed': 'Gagal menghapus logo dashboard.',

    'account.settings.payout.section.withdrawal': 'Penarikan',
    'account.settings.payout.section.currency': 'Mata Uang',
    'account.settings.payout.section.bankAccount': 'Rekening Bank Payout',
    'account.settings.payout.autoWithdrawal': 'Penarikan Otomatis',
    'account.settings.payout.minimumThreshold': 'Batas Minimum Penarikan',
    'account.settings.payout.schedule': 'Jadwal',
    'account.settings.payout.preferredCurrency': 'Mata Uang Pilihan',
    'account.settings.payout.bankName': 'Nama Bank',
    'account.settings.payout.accountHolderName': 'Nama Pemilik Rekening',
    'account.settings.payout.accountHolderName.placeholder': 'contoh: John Smith',
    'account.settings.payout.accountNumber': 'Nomor Rekening',
    'account.settings.payout.accountNumber.placeholder': 'contoh: 122230918756',
    'account.settings.payout.currency.placeholder': 'Pilih Mata Uang',
    'account.settings.payout.bank.placeholder': 'Pilih Bank',
    'account.settings.payout.schedule.placeholder': 'Pilih Jadwal',
    'account.settings.payout.loadFailed': 'Gagal memuat pengaturan payout.',
    'account.settings.payout.updateSuccess': 'Pengaturan payout berhasil diperbarui.',
    'account.settings.payout.updateFailed': 'Gagal memperbarui pengaturan payout.',
    'account.settings.payout.bank.loadFailed': 'Gagal memuat data bank.',
    'account.settings.payout.schedule.loadFailed': 'Gagal memuat jadwal pembayaran.',
    'account.settings.payout.currency.loadFailed': 'Gagal memuat mata uang.',
    'account.settings.payout.validation.bankRequired': 'Silakan pilih bank.',
    'account.settings.payout.validation.accountNumberInvalid': 'Nomor rekening tidak valid (5–20 digit).',
    'account.settings.payout.validation.accountHolderInvalid': 'Nama pemilik rekening minimal 3 karakter.',
    'account.settings.payout.validation.scheduleRequired': 'Silakan pilih jadwal pembayaran untuk penarikan otomatis.',
    'account.settings.payout.validation.currencyRequired': 'Silakan pilih mata uang untuk penarikan otomatis.',

    'account.settings.notification.section.screen': 'Layar',
    'account.settings.notification.section.bookings': 'Pemesanan',
    'account.settings.notification.screen.offline': 'Kirim email saat layar offline',
    'account.settings.notification.screen.online': 'Kirim email saat layar kembali online',
    'account.settings.notification.bookings.slotBooked': 'Kirim email saat slot dipesan',
    'account.settings.notification.bookings.expires': 'Kirim email saat pemesanan kedaluwarsa',
    'account.settings.notification.section.invitations': 'Undangan',
    'account.settings.notification.invitations.guest': 'Kirim email saat saya menerima undangan tamu',
    'account.settings.notification.invitations.response': 'Kirim email saat undangan tamu ditanggapi',
    'account.settings.notification.loadFailed': 'Gagal memuat pengaturan notifikasi.',
    'account.settings.notification.updateSuccess': 'Pengaturan notifikasi berhasil diperbarui.',
    'account.settings.notification.updateFailed': 'Gagal memperbarui pengaturan notifikasi.',

    'account.settings.security.section.password': 'Kata Sandi',
    'account.settings.security.section.alert': 'Peringatan',
    'account.settings.security.newPassword': 'Kata Sandi Baru',
    'account.settings.security.newPassword.placeholder': 'Masukkan kata sandi baru',
    'account.settings.security.verifyPassword': 'Verifikasi Kata Sandi Baru',
    'account.settings.security.verifyPassword.placeholder': 'Konfirmasi kata sandi baru',
    'account.settings.security.password.hint.match': 'Kedua kata sandi harus sama',
    'account.settings.security.alert.newLocation': 'Kirim email saat ada yang login dari lokasi baru',
    'account.settings.security.password.strength.weak': 'Lemah',
    'account.settings.security.password.strength.medium': 'Sedang',
    'account.settings.security.password.strength.strong': 'Kuat',
    'account.settings.security.password.requirement.min8': 'Minimal 8 karakter',
    'account.settings.security.password.requirement.lowercase': 'Mengandung huruf kecil',
    'account.settings.security.password.requirement.uppercase': 'Mengandung huruf besar',
    'account.settings.security.password.requirement.number': 'Mengandung angka',
    'account.settings.security.password.requirement.special': 'Mengandung karakter spesial',
    'account.settings.security.password.error.fillAll': 'Silakan isi semua kolom',
    'account.settings.security.password.error.notMatch': 'Kata sandi tidak sama',
    'account.settings.security.password.error.tooWeak': 'Kata sandi terlalu lemah. Silakan pilih kata sandi yang lebih kuat.',
    'account.settings.security.password.updated': 'Kata sandi berhasil diperbarui.',
    'account.settings.security.password.updateFailed': 'Gagal memperbarui kata sandi.',

    'account.settings.shared.title': 'Dashboard Dibagikan',
    'account.settings.shared.subtitle': 'Kelola akses dan izin dashboard yang dibagikan',
    'account.settings.shared.column.dashboard': 'Dashboard',
    'account.settings.shared.column.invited': 'Diundang',
    'account.settings.shared.column.invitedOn': 'Tanggal Undangan',
    'account.settings.shared.column.invitedBy': 'Diundang Oleh',
    'account.settings.shared.column.lastActive': 'Terakhir Aktif',

    'account.settings.invitation.title': 'Manajemen Undangan',
    'account.settings.invitation.subtitle': 'Kelola undangan dashboard yang dikirim ke pengguna',

    'account.settings.favorite.title': 'Pengiklan Favorit',
    'account.settings.favorite.subtitle': 'Kelola pengiklan favorit dan pantau performanya',
    'account.settings.favorite.column.approvedBooking': 'Pemesanan Disetujui',
    'account.settings.favorite.column.lastBooking': 'Pemesanan Terakhir',
    'account.settings.favorite.column.totalRevenue': 'Total Pendapatan',
    'account.settings.favorite.column.since': 'Sejak',

    'account.settings.preference.section.content': 'Konten',
    'account.settings.preference.section.advertiser': 'Pengiklan',
    'account.settings.preference.section.player': 'Player',
    'account.settings.preference.section.advanced': 'Lanjutan',
    'account.settings.preference.content.title': 'Preferensi Konten',
    'account.settings.preference.advertiser.title': 'Preferensi Pengiklan',
    'account.settings.preference.playerBootLogo.title': 'Logo Boot Player',
    'account.settings.preference.feature.apiTokens': 'Token API',
    'account.settings.preference.feature.playLog': 'Play Log',
    'account.settings.preference.feature.auditLog': 'Audit Log',
    'account.settings.preference.action.setPreference': 'Atur Preferensi',
    'account.settings.preference.action.changeBootLogo': 'Ubah Logo Boot',
    'account.settings.preference.action.enabled': 'Aktif',
    'account.settings.preference.value.preferredContent': 'Konten Pilihan Anda',
    'account.settings.preference.value.preferredAdvertiser': 'Pengiklan Pilihan Anda',
    'account.settings.preference.value.default': 'Default',
    'account.settings.preference.status.disabled': 'Nonaktif',

    'inventory.needAttention.title': 'Perlu Perhatian',
    'inventory.needAttention.column.screens': 'Layar',
    'inventory.needAttention.column.needsAttention': 'Perlu Perhatian',
    'inventory.needAttention.column.firstDetected': 'Pertama Terdeteksi',
    'inventory.needAttention.empty': 'Tidak ada spot yang perlu perhatian saat ini',
    'inventory.needAttention.detail.column.property': 'Properti',
    'inventory.needAttention.detail.column.value': 'Nilai',
    'inventory.needAttention.detail.spotName': 'Nama Spot',
    'inventory.needAttention.detail.detectedAt': 'Terdeteksi Pada',
    'inventory.needAttention.detail.status': 'Status',
    'inventory.needAttention.detail.lastHeartbeat': 'Heartbeat Terakhir',
    'inventory.needAttention.detail.recommendation': 'Rekomendasi',
    'inventory.needAttention.detail.storageLeft': 'Sisa Penyimpanan',
    'inventory.needAttention.detail.failedAttempts': 'Percobaan Gagal',
    'inventory.needAttention.detail.errorCode': 'Kode Error',
    'inventory.needAttention.detail.lastMaintenance': 'Perawatan Terakhir',
    'inventory.needAttention.detail.currentVersion': 'Versi Saat Ini',
    'inventory.needAttention.detail.newVersion': 'Versi Baru',
    'inventory.needAttention.type.offline': 'Offline',
    'inventory.needAttention.type.low-storage': 'Penyimpanan Rendah',
    'inventory.needAttention.type.connection-issue': 'Masalah Koneksi',
    'inventory.needAttention.type.maintenance': 'Perlu Perawatan',
    'inventory.needAttention.type.update-needed': 'Perlu Pembaruan',
    'inventory.needAttention.value.minutesAgo': '{{minutes}} menit yang lalu',
    'inventory.needAttention.value.hoursAgo': '{{hours}} jam yang lalu',
    'inventory.needAttention.value.daysAgo': '{{days}} hari yang lalu',
    'inventory.needAttention.value.weeksAgo': '{{weeks}} minggu yang lalu',
    'inventory.needAttention.group.shoppingMalls': 'Pusat Perbelanjaan',
    'inventory.needAttention.group.transportation': 'Transportasi',
    'inventory.needAttention.group.hospitality': 'Perhotelan',
    'inventory.needAttention.group.corporate': 'Korporat',
    'inventory.needAttention.group.foodAndBeverage': 'Makanan & Minuman',
    'inventory.needAttention.group.retail': 'Ritel',
    'inventory.needAttention.group.education': 'Pendidikan',
    'inventory.needAttention.group.healthcare': 'Kesehatan',
    'inventory.needAttention.group.entertainment': 'Hiburan',
    'inventory.needAttention.group.financial': 'Keuangan',
    'inventory.needAttention.recommendation.offline': 'Periksa daya dan koneksi jaringan.',
    'inventory.needAttention.recommendation.lowStorage': 'Hapus file yang tidak perlu.',
    'inventory.needAttention.recommendation.connectionIssue': 'Mulai ulang layanan sinkronisasi atau periksa log.',
    'inventory.needAttention.recommendation.maintenanceRequired': 'Jadwalkan perawatan secepatnya.',
    'inventory.needAttention.recommendation.updateNeeded': 'Jadwalkan pembaruan perangkat lunak.',

    'auth.login.title': 'Masuk',
    'auth.login.emailAddress': 'Alamat Email',
    'auth.login.emailPlaceholder': 'Email',
    'auth.login.password': 'Kata Sandi',
    'auth.login.passwordPlaceholder': 'Kata Sandi',
    'auth.login.forgotPassword': 'Lupa kata sandi?',
    'auth.login.submit': 'Masuk',
    'auth.login.loggingIn': 'Sedang masuk...',
    'auth.login.or': 'atau',
    'auth.login.noAccount': 'Belum punya akun?',
    'auth.login.signUp': 'Daftar',
    'auth.login.illustrationAlt': 'Ilustrasi Login',
    'auth.login.sessionExpired': 'Sesi Anda telah berakhir. Silakan masuk kembali.',
    'auth.login.loggedOut': 'Anda telah keluar. Silakan masuk kembali.',
    'auth.login.googleFailed': 'Login Google gagal. Silakan coba lagi.',

    'auth.shell.logoAlt': 'Logo {{appName}}',

    'auth.forgot.title': 'Lupa Kata Sandi?',
    'auth.forgot.subtitle': 'Masukkan email Anda untuk menerima instruksi reset kata sandi.',
    'auth.forgot.illustrationAlt': 'Ilustrasi Lupa Kata Sandi',
    'auth.forgot.emailAddress': 'Alamat Email',
    'auth.forgot.emailPlaceholder': 'Email',
    'auth.forgot.submit': 'Kirim',
    'auth.forgot.sending': 'Mengirim...',
    'auth.forgot.remember': 'Ingat kata sandi?',
    'auth.forgot.login': 'Masuk',
    'auth.forgot.errorTitle': 'Error',
    'auth.forgot.successTitle': 'Berhasil',
    'auth.forgot.emailRequired': 'Silakan masukkan alamat email yang valid.',
    'auth.forgot.emailInvalid': 'Format email tidak valid.',
    'auth.forgot.successMessage': 'Link reset kata sandi telah dikirim ke email Anda.',
    'auth.forgot.errorMessage': 'Terjadi kesalahan saat mengirim email reset kata sandi. Silakan coba lagi.',

    'auth.reset.title': 'Reset Kata Sandi',
    'auth.reset.subtitle': 'Kata sandi baru harus berbeda dari kata sandi yang pernah digunakan sebelumnya.',
    'auth.reset.illustrationAlt': 'Ilustrasi Reset Kata Sandi',
    'auth.reset.newPassword': 'Kata Sandi Baru',
    'auth.reset.confirmPassword': 'Konfirmasi Kata Sandi Baru',
    'auth.reset.passwordPlaceholder': 'Kata Sandi',
    'auth.reset.hint': 'Gunakan kombinasi huruf kecil, huruf besar, angka, dan simbol.',
    'auth.reset.combination': 'Kombinasi saat ini: {{combo}}',
    'auth.reset.matchHint': 'Kedua kata sandi harus sama',
    'auth.reset.submit': 'Reset Kata Sandi',
    'auth.reset.resetting': 'Mereset...',
    'auth.reset.strength.weak': 'Lemah',
    'auth.reset.strength.medium': 'Sedang',
    'auth.reset.strength.strong': 'Kuat',
    'auth.password.req.min8': 'Minimal 8 karakter',
    'auth.password.req.lower': 'Mengandung huruf kecil',
    'auth.password.req.upper': 'Mengandung huruf besar',
    'auth.password.req.number': 'Mengandung angka',
    'auth.password.req.special': 'Mengandung karakter khusus',
    'auth.reset.fillAll': 'Silakan lengkapi semua kolom',
    'auth.reset.mismatch': 'Kata sandi tidak sama',
    'auth.reset.tooWeak': 'Kata sandi terlalu lemah. Silakan gunakan kata sandi yang lebih kuat.',
    'auth.reset.successTitle': 'Berhasil',
    'auth.reset.successMessage': 'Kata sandi berhasil diperbarui. Silakan masuk menggunakan kata sandi baru Anda.',
    'auth.reset.errorTitle': 'Error',
    'auth.reset.errorMessage': 'Terjadi kesalahan saat memperbarui kata sandi. Silakan coba lagi.',

    'auth.confirm.verified': 'Terverifikasi',
    'auth.confirm.activated': 'Akun Anda telah aktif',
    'auth.confirm.thankYou': 'Terima kasih telah bergabung! Klik tombol Berikutnya di bawah untuk mulai menggunakan produk dan layanan kami.',
    'auth.confirm.next': 'Berikutnya',
    'auth.confirm.failed': 'Verifikasi Gagal',
    'auth.confirm.failedFor': 'Verifikasi untuk {{email}} gagal.',
    'auth.confirm.linkExpired': 'Link Anda sudah kedaluwarsa. Klik tombol Kirim Ulang di bawah untuk meminta link verifikasi baru.',
    'auth.confirm.resend': 'Kirim Ulang',
    'auth.confirm.back': 'Kembali',

    'auth.otp.iconAlt': 'Ikon OTP',
    'auth.otp.title': 'Masukkan OTP',
    'auth.otp.sentTo': 'Kami telah mengirim kode verifikasi ke {{email}}',
    'auth.otp.instruction': 'Periksa email Anda dan masukkan kode verifikasi di bawah ini.',
    'auth.otp.expiresAt': 'Kode Anda akan kedaluwarsa pada {{time}}',
    'auth.otp.verify': 'Verifikasi',
    'auth.otp.verifying': 'Memverifikasi...',
    'auth.otp.resend': 'Kirim Ulang',
    'auth.otp.resending': 'Mengirim ulang...',
    'auth.otp.resendIn': 'Kirim Ulang ({{seconds}}s)',
    'auth.otp.errorTitle': 'Error',
    'auth.otp.successTitle': 'Berhasil',
    'auth.otp.emailMissing': 'Email tidak ditemukan. Silakan kembali dan coba lagi.',
    'auth.otp.invalidLength': 'Silakan masukkan OTP 6 digit.',
    'auth.otp.verifyFailed': 'Verifikasi OTP gagal. Silakan coba lagi.',
    'auth.otp.resendFailed': 'Gagal mengirim ulang OTP. Silakan coba lagi.',
    'auth.otp.resendSuccess': 'OTP telah dikirim ulang ke email Anda.',

    'auth.category.title': 'Anda sebagai apa?',
    'auth.category.subtitle': 'Selamat datang! Agar kami bisa memberikan fitur yang tepat, kami perlu tahu bagaimana Anda akan menggunakan {{brand}}. Pilih peran yang paling sesuai dengan tanggung jawab Anda.',
    'auth.category.iconAlt': 'Ikon {{name}}',
    'auth.category.select': 'Pilih',
    'auth.category.loading': 'Memuat...',
    'auth.category.fetchFailed': 'Gagal memuat kategori. Silakan coba lagi.',
    'auth.category.selectFailed': 'Gagal memilih kategori. Silakan coba lagi.',
    'auth.category.emailMissing': 'Email pengguna tidak ditemukan. Silakan daftar ulang.',

    'role.mediaOwners': 'Pemilik Media',
    'role.advertisers': 'Pengiklan',
    'role.operator': 'Operator',

    'auth.signup.title': 'Daftar',
    'auth.signup.illustrationAlt': 'Ilustrasi Daftar',
    'auth.signup.emailAddress': 'Alamat Email',
    'auth.signup.emailPlaceholder': 'you@yourcompany.com',
    'auth.signup.password': 'Kata Sandi',
    'auth.signup.passwordPlaceholder': 'Kata Sandi',
    'auth.signup.hint': 'Gunakan kombinasi huruf kecil, huruf besar, angka, dan simbol.',
    'auth.signup.agreePrefix': 'Saya setuju dengan',
    'auth.signup.termOfService': 'Ketentuan Layanan',
    'auth.signup.privacyPolicy': 'Kebijakan Privasi',
    'auth.signup.andOtherPolicies': 'dan kebijakan lainnya yang terdapat di',
    'auth.signup.legalCenter': 'Pusat Legal',
    'auth.signup.submit': 'Daftar',
    'auth.signup.submitting': 'Mendaftar...',
    'auth.signup.or': 'atau',
    'auth.signup.alreadyAccount': 'Sudah punya akun?',
    'auth.signup.login': 'Masuk',
    'auth.signup.googleFailed': 'Daftar dengan Google gagal. Silakan coba lagi.',
    'auth.signup.fillAll': 'Silakan lengkapi semua kolom',
    'auth.signup.emailInvalid': 'Silakan masukkan alamat email yang valid',
    'auth.signup.acceptTerms': 'Silakan setujui syarat dan ketentuan',
    'auth.signup.tooWeak': 'Kata sandi terlalu lemah. Silakan gunakan kata sandi yang lebih kuat.',
    'auth.signup.serverIncomplete': 'Pendaftaran gagal: Data dari server tidak lengkap.',
    'auth.signup.failed': 'Pendaftaran gagal. Silakan coba lagi.',
    'auth.signup.errorTitle': 'Error',

    'profiling.loading': 'Memuat data survei...',
    'profiling.submitting': 'Mengirim...',
    'profiling.next': 'Berikutnya',
    'profiling.funFact': 'Fakta Menarik',
    'profiling.errorTitle': 'Error',
    'profiling.emailMissing': 'Email pengguna tidak ditemukan. Silakan coba lagi.',
    'profiling.loadFailed': 'Gagal memuat data survei. Silakan coba lagi.',
    'profiling.selectAnswer': 'Silakan pilih salah satu jawaban.',
    'profiling.submitFailed': 'Gagal mengirim jawaban survei. Silakan coba lagi.',
    'profiling.facts.1': 'Pasar DOOH global diproyeksikan mencapai $58,67 miliar pada 2030<br>Layar Anda bisa menjadi bagian dari industri yang terus tumbuh ini!',
    'profiling.facts.2': 'Billboard digital dapat meningkatkan brand awareness hingga 47%<br>Sangat efektif menarik perhatian di dalam maupun di luar toko Anda.',
    'profiling.facts.3': 'Konten dinamis membuat penonton bertahan 4x lebih lama<br>Manfaatkan gerak dan timing untuk cerita brand yang lebih kuat.',
    'profiling.facts.4': 'Programmatic DOOH memungkinkan Anda membeli audiens, bukan hanya lokasi<br>Jangkau orang yang tepat di momen yang tepat.',
    'profiling.facts.5': 'Retail yang memakai signage digital di dalam toko sering melihat peningkatan penjualan<br>sekitar 10% hingga 30% untuk produk yang dipromosikan.',
    'profiling.facts.6': 'Konteks itu penting: kampanye DOOH bisa menyesuaikan waktu dan lokasi<br>Promo pagi bisa berbeda dengan suasana malam.',
    'profiling.facts.7': 'Layar yang terang meningkatkan daya ingat di area ramai<br>Visibilitas mendorong pengenalan brand lebih cepat.',
    'profiling.facts.8': 'Pesan singkat paling efektif: sering kali 6–8 kata sudah cukup<br>Buat copy ringkas dan mudah dibaca sekilas.',
    'profiling.facts.9': 'Kreatif yang dipicu cuaca bisa meningkatkan performa<br>Sesuaikan promo saat hujan, panas, atau cerah.',
    'profiling.facts.10': 'Gerak menarik perhatian, tapi kesederhanaan yang mengonversi<br>Layout bersih sering mengalahkan tampilan yang terlalu ramai.',

    'legal.lastUpdated': 'Terakhir diperbarui:',

    'legal.tnc.title': 'Syarat & Ketentuan (T&C)',
    'legal.tnc.s1.title': '1. Pendahuluan',
    'legal.tnc.s1.body': 'Selamat datang di {{platformName}} (\"Platform\"). Dengan mengakses atau menggunakan layanan kami, Anda (\"Pengguna\") setuju untuk mematuhi Syarat & Ketentuan ini. Jika Anda tidak setuju, mohon untuk tidak menggunakan layanan kami.',
    'legal.tnc.s2.title': '2. Definisi',
    'legal.tnc.s2.platformLabel': 'Platform:',
    'legal.tnc.s2.userLabel': 'Pengguna:',
    'legal.tnc.s2.publisherLabel': 'Publisher:',
    'legal.tnc.s2.advertiserLabel': 'Advertiser:',
    'legal.tnc.s2.platform': 'Platform DigiMax untuk periklanan digital dan manajemen layar.',
    'legal.tnc.s2.user': 'Individu atau bisnis yang menggunakan Platform, termasuk pemilik media (publisher) dan pengiklan (advertiser).',
    'legal.tnc.s2.publisher': 'Pemilik media yang mendaftarkan layar digital atau lokasi pada Platform.',
    'legal.tnc.s2.advertiser': 'Bisnis atau individu yang membeli penempatan iklan pada layar digital melalui Platform.',
    'legal.tnc.s3.title': '3. Registrasi & Penggunaan Akun',
    'legal.tnc.s3.b1': 'Pengguna wajib memberikan informasi yang akurat dan lengkap.',
    'legal.tnc.s3.b2': 'Publisher bertanggung jawab mengelola layar yang didaftarkan dan memastikan kepatuhan konten.',
    'legal.tnc.s3.b3': 'Advertiser wajib mematuhi regulasi periklanan dan menghindari konten terlarang (mis. ilegal, menyesatkan, atau berbahaya).',
    'legal.tnc.s3.b4': 'Platform berhak menangguhkan atau menghentikan akun yang melanggar ketentuan.',
    'legal.tnc.s4.title': '4. Pembayaran & Langganan',
    'legal.tnc.s4.b1': 'Platform menyediakan paket langganan dengan fitur dan kuota layar yang berbeda.',
    'legal.tnc.s4.b2': 'Pembayaran harus dilakukan sesuai paket yang dipilih. Keterlambatan perpanjangan dapat menyebabkan pembatasan akun.',
    'legal.tnc.s4.b3': 'Kebijakan pengembalian dana, jika berlaku, akan diinformasikan pada proses pembelian.',
    'legal.tnc.s5.title': '5. Pedoman Konten',
    'legal.tnc.s5.b1': 'Publisher wajib memastikan layar tidak menampilkan konten terlarang (mis. ujaran kebencian, iklan palsu, pornografi).',
    'legal.tnc.s5.b2': 'Platform berhak menghapus konten yang melanggar kebijakan atau peraturan yang berlaku.',
    'legal.tnc.s6.title': '6. Iklan Pihak Ketiga & Monetisasi',
    'legal.tnc.s6.b1': 'Publisher dapat mengaktifkan iklan pihak ketiga di layar dan memperoleh pendapatan.',
    'legal.tnc.s6.b2': 'Platform dapat menyediakan layanan agensi iklan bagi publisher yang tidak ingin menangani penjualan iklan langsung.',
    'legal.tnc.s6.b3': 'Rincian bagi hasil pendapatan akan tersedia pada pengaturan monetisasi.',
    'legal.tnc.s7.title': '7. Perlindungan Data & Kepatuhan',
    'legal.tnc.s7.b1': 'Platform mematuhi UU PDP, UU ITE, dan regulasi terkait di kawasan SEA.',
    'legal.tnc.s7.b2': 'Pengguna wajib mengelola data pelanggan secara bertanggung jawab dan mematuhi aturan privasi setara GDPR pada wilayah yang berlaku.',
    'legal.tnc.s8.title': '8. Batasan Layanan & Tanggung Jawab',
    'legal.tnc.s8.b1': 'Platform tidak bertanggung jawab atas downtime, masalah konten, atau kerugian pendapatan akibat faktor eksternal (mis. pemadaman listrik, gangguan internet).',
    'legal.tnc.s8.b2': 'Pengguna bertanggung jawab mengelola akun, layar, dan kampanye secara efektif.',
    'legal.tnc.s9.title': '9. Hukum yang Berlaku',
    'legal.tnc.s9.b1': 'Ketentuan ini diatur oleh hukum Indonesia, dengan penyelesaian sengketa melalui arbitrase di Jakarta, Indonesia.',
    'legal.tnc.s9.b2': 'Pengguna di negara SEA lainnya setuju untuk mematuhi peraturan lokal saat menggunakan Platform.',
    'legal.tnc.s10.title': '10. Perubahan T&C',
    'legal.tnc.s10.p1': 'Kami dapat memperbarui ketentuan ini kapan saja. Penggunaan Platform secara berkelanjutan berarti Anda menerima versi terbaru.',
    'legal.tnc.s10.p2': 'Untuk pertanyaan, hubungi',

    'legal.privacy.title': 'Kebijakan Privasi',
    'legal.privacy.s1.title': '1. Pendahuluan',
    'legal.privacy.s1.body': 'DigiMax (\"Platform\") menghargai privasi Anda dan berkomitmen melindungi data pribadi. Kebijakan Privasi ini menjelaskan bagaimana kami mengumpulkan, menggunakan, dan menyimpan data pengguna sesuai UU PDP Indonesia, regulasi privasi SEA, serta GDPR jika berlaku.',
    'legal.privacy.s2.title': '2. Data yang Kami Kumpulkan',
    'legal.privacy.s2.lead': 'Kami mengumpulkan jenis data berikut:',
    'legal.privacy.s2.b1.label': 'Informasi Akun:',
    'legal.privacy.s2.b1.body': 'Nama, email, nomor telepon, detail pembayaran.',
    'legal.privacy.s2.b2.label': 'Data Periklanan:',
    'legal.privacy.s2.b2.body': 'Konten iklan, analitik audiens, dan data performa layar.',
    'legal.privacy.s2.b3.label': 'Data Perangkat & Penggunaan:',
    'legal.privacy.s2.b3.body': 'Alamat IP, aktivitas login, jenis perangkat, dan perilaku penelusuran.',
    'legal.privacy.s3.title': '3. Cara Kami Menggunakan Data Anda',
    'legal.privacy.s3.b1': 'Untuk menyediakan dan meningkatkan layanan Platform.',
    'legal.privacy.s3.b2': 'Untuk memproses pembayaran dan mengelola langganan.',
    'legal.privacy.s3.b3': 'Untuk menampilkan iklan tertarget (hanya jika pengguna mengaktifkan iklan pihak ketiga).',
    'legal.privacy.s3.b4': 'Untuk mematuhi kewajiban hukum dan mencegah penipuan.',
    'legal.privacy.s4.title': '4. Penyimpanan Data & Keamanan',
    'legal.privacy.s4.b1': 'Data pengguna disimpan secara aman di Indonesia dan pusat data regional SEA.',
    'legal.privacy.s4.b2': 'Kami menggunakan enkripsi, firewall, dan kontrol akses aman untuk melindungi informasi pengguna.',
    'legal.privacy.s5.title': '5. Berbagi dengan Pihak Ketiga',
    'legal.privacy.s5.b1': 'Kami tidak menjual data pribadi.',
    'legal.privacy.s5.b2': 'Kami dapat membagikan data kepada mitra iklan (jika monetisasi diaktifkan) dan pemroses pembayaran untuk transaksi.',
    'legal.privacy.s5.b3': 'Sesuai aturan setara GDPR, pengguna dapat meminta akses data, perbaikan, atau penghapusan.',
    'legal.privacy.s6.title': '6. Cookie & Pelacakan',
    'legal.privacy.s6.body1': 'Kami menggunakan cookie untuk autentikasi, analitik, dan penargetan iklan.',
    'legal.privacy.s6.seeOur': 'Lihat',
    'legal.privacy.s6.cookiePolicy': 'Kebijakan Cookie',
    'legal.privacy.s6.body2': 'untuk detail.',
    'legal.privacy.s7.title': '7. Hak Pengguna',
    'legal.privacy.s7.b1': 'Pengguna dapat mengakses, mengubah, atau menghapus data pribadi melalui pengaturan akun.',
    'legal.privacy.s7.b2': 'Pengguna dapat memilih keluar dari iklan tertarget dan pelacakan cookie.',
    'legal.privacy.s8.title': '8. Perubahan Kebijakan Privasi',
    'legal.privacy.s8.body': 'Kami dapat memperbarui Kebijakan Privasi ini. Pengguna akan diberi tahu jika ada perubahan signifikan.',
    'legal.privacy.footer': 'Untuk pertanyaan, hubungi'
  },
  es: {
    'basicInfo.contact': 'Contacto',
    'basicInfo.timeZoneLanguage': 'Zona horaria y idioma',
    'basicInfo.dateTime': 'Fecha y hora',
    'basicInfo.fullName': 'Nombre completo',
    'basicInfo.fullNamePlaceholder': 'Ingresa tu nombre completo',
    'basicInfo.email': 'Correo electrónico',
    'basicInfo.emailPlaceholder': 'Ingresa tu correo electrónico',
    'basicInfo.mobileNumber': 'Número de móvil',
    'basicInfo.mobileNumberPlaceholder': 'Ingresa tu número de móvil',
    'basicInfo.continentOrCountry': 'Continente o país',
    'basicInfo.cityOrZone': 'Ciudad o zona',
    'basicInfo.language': 'Idioma',
    'basicInfo.dateFormat': 'Formato de fecha',
    'basicInfo.timeFormat': 'Formato de hora',
    'basicInfo.firstDayOfWeek': 'Primer día de la semana',
    'basicInfo.timeFormat12': '12 horas | 5:14 p. m.',
    'basicInfo.timeFormat24': '24 horas | 17:14',
    'basicInfo.sunday': 'Domingo',
    'basicInfo.monday': 'Lunes',
    'basicInfo.save': 'Guardar',
    'basicInfo.saving': 'Guardando...',
    'basicInfo.requestDeletion': 'Solicitar eliminación completa del perfil',
    'basicInfo.validationTitle': 'Error de validación',
    'basicInfo.validationFullName': 'Ingresa un nombre completo válido (mín. 2 caracteres, solo letras).',
    'basicInfo.validationEmail': 'Ingresa una dirección de correo válida.',
    'basicInfo.validationMobile': 'Ingresa un número de móvil válido (8-15 dígitos).',
    'basicInfo.successTitle': 'Éxito',
    'basicInfo.successMessage': '¡Perfil actualizado correctamente!',
    'basicInfo.countryLoadFailed': 'Error al cargar la lista de países.',
    'basicInfo.cityLoadFailed': 'Error al cargar la lista de ciudades.',
    'basicInfo.profileLoadFailed': 'Error al cargar el perfil del usuario.',
    'basicInfo.profileUpdateFailed': 'Error al actualizar el perfil.',
    'select.placeholder.continent': 'Selecciona continente o país',
    'select.placeholder.city': 'Selecciona ciudad o zona',
    'select.placeholder.code': 'Código',
    'select.searchPlaceholder': 'Buscar opciones...',
    'select.noOptions': 'No se encontraron opciones',
    'select.loading': 'Cargando opciones...',
    'select.addNewInputPlaceholder': 'Ingresa el nombre de la nueva opción',
    'select.add': 'Agregar',
    'select.cancel': 'Cancelar',
    'select.invalidNewOption': 'El nombre de la opción debe tener al menos 3 caracteres y solo contener caracteres válidos.',
    'language.en': 'Inglés',
    'language.id': 'Indonesio',
    'language.es': 'Español',

    'Notifications': 'Notificaciones',
    'Clear': 'Borrar',
    'User': 'Usuario',
    'Profile': 'Perfil',
    'Subscription': 'Suscripción',
    'Inventory': 'Inventario',
    'Campaign': 'Campaña',
    'Wallet': 'Billetera',
    'Logout': 'Cerrar sesión',

    'Welcome': 'Bienvenido',
    'Manage': 'Administrar',
    'Bookings': 'Reservas',
    'Performance': 'Rendimiento',
    'Availability': 'Disponibilidad',
    'Pricing': 'Precios',
    'Audience': 'Audiencia',

    'Login': 'Iniciar sesión',
    'Email Address': 'Dirección de correo',
    'Email': 'Correo',
    'Password': 'Contraseña',
    'Forgot password?': '¿Olvidaste tu contraseña?',
    'Logging in...': 'Iniciando sesión...',
    'or': 'o',
    'Don\'t have an account?': '¿No tienes una cuenta?',
    'Sign up': 'Regístrate',
    'Login Illustration': 'Ilustración de inicio de sesión',

    'common.user': 'Usuario',
    'common.thisItem': 'este elemento',
    'breadcrumb.home': 'Inicio',
    'breadcrumb.accountSettings': 'Configuración de cuenta',

    'nav.welcome': 'Bienvenido',
    'nav.inventory': 'Inventario',
    'nav.inventory.manage': 'Administrar',
    'nav.inventory.bookings': 'Reservas',
    'nav.inventory.performance': 'Rendimiento',
    'nav.inventory.availability': 'Disponibilidad',
    'nav.inventory.pricing': 'Precios',
    'nav.inventory.audience': 'Audiencia',
    'nav.campaign': 'Campaña',

    'menu.notifications.title': 'Notificaciones',
    'menu.notifications.clear': 'Borrar',
    'menu.notifications.empty': 'No hay notificaciones aún',
    'menu.notifications.soundOn': 'Encender sonido',
    'menu.notifications.soundOff': 'Apagar sonido',
    'menu.profile': 'Perfil',
    'menu.subscription': 'Suscripción',
    'menu.inventory': 'Inventario',
    'menu.campaign': 'Campaña',
    'menu.video-editor': 'Editor Video',
    'menu.wallet': 'Billetera',
    'menu.docs': 'Documentación',
    'menu.docs.accessDenied': 'No tienes acceso a la documentación.',
    'menu.docs.accessFailed': 'No se devolvió el token de acceso a la documentación.',
    'menu.logout': 'Cerrar sesión',
    'menu.users': 'Usuarios',
    'menu.upload.completed.title': 'Carga completada',
    'menu.upload.completed.message': 'Se procesaron todos los archivos. Completados: {{completed}}',
    'menu.upload.issues.title': 'Problemas de carga',
    'menu.upload.status.title': 'Estado de carga',
    'menu.upload.status.loadFailed': 'No se pudo cargar el estado de la cola de carga.',

    'header.logoAlt': 'Logo de la empresa',
    'header.clientLogoAlt': 'Logo del panel del cliente',

    'footer.rightsReserved': 'Todos los derechos reservados.',
    'footer.scrollTop': 'Ir arriba',

    'welcome.startCampaign': 'Iniciar campaña',
    'welcome.addMediaSpot': 'Agregar punto de medios',
    'welcome.growTitle': 'Haz crecer tu negocio con nosotros',
    'welcome.startCampaign.desc': 'Agregar más campañas aumenta tu visibilidad ante audiencias potenciales.',
    'welcome.addMediaSpot.desc': 'Agrega un nuevo punto de medios para aumentar tu visibilidad.',
    'welcome.illustrationAlt': 'Ilustración de medios digitales',
    'welcome.card1.title': '¿Buscas pantallas digitales y no sabes por dónde empezar?',
    'welcome.card1.desc': 'Podemos ayudarte con soluciones accesibles, fáciles de configurar y listas para usar—sin necesidad de habilidades técnicas.',
    'welcome.card1.cta': 'Comprar ahora',
    'welcome.card2.imageAlt': 'Documentación manual',
    'welcome.card2.title': '¿Necesitas ayuda? ¡Te cubrimos!',
    'welcome.card2.desc': 'Explora nuestra documentación o preguntas frecuentes para aprovechar la plataforma.',
    'welcome.card2.cta': 'Obtener ayuda',
    'welcome.card3.imageAlt': 'Soporte',
    'welcome.card3.title': 'Mira nuestros tutoriales en video paso a paso',
    'welcome.card3.desc': 'La forma más fácil de comenzar y dominar la plataforma.',
    'welcome.card3.cta': 'Ver video',

    'common.yes': 'Sí',
    'common.no': 'No',
    'common.edit': 'Editar',
    'common.delete': 'Eliminar',
    'common.review': 'Revisar',
    'common.cancel': 'Cancelar',
    'common.confirm': 'Confirmar',
    'common.error': 'Error',
    'common.success': 'Éxito',
    'common.turnOn': 'Encender',
    'common.save': 'Guardar',
    'common.na': 'N/A',
    'common.retry': 'Reintentar',
    'common.detail': 'Detalle',
    'common.replace': 'Reemplazar',
    'common.accept': 'Aceptar',
    'common.decline': 'Rechazar',
    'common.play': 'Reproducir',
    'common.pause': 'Pausar',
    'common.mute': 'Silenciar',
    'common.unmute': 'Activar sonido',
    'common.restart': 'Reiniciar',
    'common.upload': 'Subir',
    'common.change': 'Cambiar',
    'common.back': 'Volver',
    'common.saving': 'Guardando...',
    'common.validationError': 'Error de validación',
    'common.confirmDelete.title': 'Confirmar eliminación',
    'common.confirmDelete.message': '\u00bfEliminar \"{{name}}\"?',
    'common.unauthorized': 'No autorizado: falta el token o no es válido.',
    'common.unexpectedError': 'Ocurrió un error inesperado.',
    'layout.layout': 'Diseño',
    'layout.selectTemplate': 'Seleccionar Plantilla de Diseño',
    'layout.selectTemplateHint': 'Seleccione una plantilla a la izquierda, luego haga clic en Continuar para configurar el contenido.',
    'layout.setLayout': 'Establecer Diseño',
    'layout.continue': 'Continuar',
    'layout.confirm': 'Confirmar',
    'layout.editContent': 'Editar Contenido del Widget',
    'layout.editContentHint': 'Configure el contenido para áreas no creativas en esta plantilla.',
    'layout.widget': 'Widget',
    'layout.runningText': 'Texto Corriente',
    'layout.widgetUrl': 'URL del Widget',
    'layout.runningTextContent': 'Contenido de Texto Corriente',
    'layout.runningTextPlaceholder': 'Ingrese el texto a mostrar...',
    'layout.assignedSuccess': 'Diseño asignado exitosamente.',
    'layout.assignFailed': 'Error al asignar diseño.',
    'layout.backToScreens': '← Volver a Pantallas',
    'layout.setLayoutFor': 'Establecer Diseño para',
    'layout.saveLayout': 'Guardar Diseño',
    'layout.preview': 'Vista Previa',
    'layout.confirmTitle': 'Confirmar Cambio de Diseño',
    'layout.confirmMessage': '¿Establecer este diseño? ¿Está seguro?',
    'layout.templateDifferentWarning': 'Esta es una plantilla diferente a la que se encuentra en uso actualmente. Una vez confirmado, el cambio entrará en vigencia a partir de mañana a las 00:00.',
    'layout.apply': 'Aplicar',
    'layout.successTitle': 'Diseño Aplicado Exitosamente',
    'layout.successMessage': 'El nuevo diseño se ha establecido correctamente en las pantallas.',
    'layout.selectType': 'Tipo',
    'layout.chooseType': '-- Seleccionar Tipo --',
    'layout.noConfigRequired': 'No se requiere configuración adicional para esta plantilla.',

    'status.pending': 'Pendiente',
    'status.confirmed': 'Confirmado',
    'status.active': 'Activo',
    'status.inactive': 'Inactivo',
    'status.available': 'Disponible',
    'status.unavailable': 'No disponible',
    'status.unknown': 'Desconocido',

    'table.actions': 'Acciones',
    'table.loading': 'Cargando...',
    'table.selectedCount': '{{count}} elemento(s) seleccionados',
    'table.deleteSelected': 'Eliminar seleccionados',
    'table.clearSelection': 'Borrar selección',
    'table.moreActions': 'Más acciones',
    'table.sort.asc': 'Orden ascendente',
    'table.sort.desc': 'Orden descendente',
    'table.sort.remove': 'Quitar orden',
    'table.filter.filter': 'Filtrar {{column}}',
    'table.filter.select': 'Seleccionar {{column}}',
    'table.filter.all': 'Todos',
    'table.filter.from': 'Desde',
    'table.filter.to': 'hasta',
    'table.filter.toField': 'Hasta',
    'table.filter.clear': 'Borrar filtro',
    'table.operator.contains': 'Contiene',
    'table.operator.equals': 'Igual a',
    'table.operator.startsWith': 'Empieza con',
    'table.operator.endsWith': 'Termina con',
    'table.operator.greaterThan': 'Mayor que',
    'table.operator.lessThan': 'Menor que',
    'table.operator.between': 'Entre',
    'table.operator.after': 'Después de',
    'table.operator.before': 'Antes de',
    'table.bulkDelete.noneSelected': 'No hay elementos seleccionados.',
    'table.bulkDelete.invalidSelection': 'Los elementos seleccionados no son válidos para eliminar.',

    'pagination.itemsPerPage': 'Elementos por página:',
    'pagination.range': '{{start}}-{{end}} de {{total}} elementos',
    'pagination.first': 'Primera página',
    'pagination.prev': 'Página anterior',
    'pagination.next': 'Página siguiente',
    'pagination.last': 'Última página',
    'pagination.goToPage': 'Ir a la página {{page}}',

    'campaign.summary.total': 'Total de campañas',
    'campaign.summary.draft': 'Borrador',
    'campaign.summary.active': 'Activa',
    'campaign.summary.pending': 'Pendiente',
    'campaign.summary.paused': 'En pausa',
    'campaign.summary.failed': 'Fallida',
    'campaign.action.newCampaign': '+ Nueva campaña',
    'campaign.balance.accountBalance': 'Saldo de la cuenta',
    'campaign.balance.campaignWallet': 'Billetera de campaña',
    'campaign.balance.allocated': 'Presupuesto asignado',
    'campaign.balance.remaining': 'Presupuesto restante',
    'campaign.balance.spent': 'Presupuesto gastado',
    'campaign.balance.avgSpending': 'Prom. de gasto del presupuesto',
    'campaign.balance.perDay': '/día',
    'campaign.table.title': 'Campañas',
    'campaign.table.column.campaignName': 'Nombre de campaña',
    'campaign.table.column.spot': 'Punto',
    'campaign.table.column.venue': 'Lugar',
    'campaign.table.column.budget': 'Presupuesto',
    'campaign.table.column.period': 'Periodo',
    'campaign.table.column.status': 'Estado',
    'campaign.status.draft': 'Borrador',
    'campaign.status.active': 'Activa',
    'campaign.status.pending': 'Pendiente',
    'campaign.status.paused': 'En pausa',
    'campaign.status.failed': 'Fallida',
    'campaign.spots.title': 'Catálogo de puntos',
    'campaign.spots.viewAll': 'Ver todo',
    'campaign.error.summaryLoadFailed': 'No se pudo cargar el resumen de campañas.',
    'campaign.error.listLoadFailed': 'No se pudo cargar la lista de campañas.',

    'spots.retry': 'Intentar de nuevo',
    'spots.openDetail': 'Abrir detalle del punto',
    'spots.imageAlt': 'Imagen del punto',
    'spots.screensCount': 'Cantidad de pantallas',
    'spots.alreadyInCampaign': 'Ya está en la campaña',
    'spots.addToCampaign': 'Agregar a la campaña',
    'spots.processing': 'Procesando...',
    'spots.cancel': 'Cancelar',
    'spots.empty.title': 'No hay puntos disponibles',
    'spots.empty.subtitle': 'Inténtalo de nuevo o ajusta los filtros.',
    'spots.pagination.showing': 'Mostrando {{start}}–{{end}} de {{total}}',
    'spots.pagination.prev': 'Anterior',
    'spots.pagination.next': 'Siguiente',
    'spots.pagination.pageOf': 'Página {{page}} de {{total}}',
    'spots.error.loadFailed': 'No se pudo cargar el cat\u00e1logo de puntos. Int\u00e9ntalo de nuevo.',

    'inventory.card.mediaSpot': 'Punto de medios',
    'inventory.card.screen': 'Pantalla',
    'inventory.card.needUnlockScreenLimit': '¿Necesitas desbloquear el límite de pantallas?',
    'inventory.card.upgradePackage': 'Mejorar paquete',
    'inventory.chart.bookedVsAvailable': 'Reservado vs disponible',
    'inventory.chart.booked': 'Reservado',
    'inventory.chart.available': 'Disponible',
    'inventory.chart.onlineVsOffline': 'Pantallas en línea vs sin conexión',
    'inventory.chart.online': 'En línea',
    'inventory.chart.offline': 'Sin conexión',
    'inventory.ads.inHouseAds': 'Anuncios internos',
    'inventory.ads.commercialAds': 'Anuncios comerciales',
    'inventory.revenue.todayRevenue': 'Ingresos de hoy',
    'inventory.revenue.viewReport': 'Ver informe',
    'inventory.revenue.optimize': 'Optimizar ingresos',
    'inventory.balance.totalBalance': 'Saldo total',
    'inventory.balance.autoWithdrawal.active': 'El retiro autom\u00e1tico est\u00e1 activo.',
    'inventory.balance.autoWithdrawal.payouts': 'Los pagos siguen tu horario',
    'inventory.balance.autoWithdrawal.every': 'cada {{schedule}}',
    'inventory.balance.autoWithdrawal.basedOnSettings': 'seg\u00fan tu configuraci\u00f3n de pagos.',
    'inventory.balance.changeSchedule': 'Cambiar horario',
    'inventory.balance.requestWithdrawal': 'Solicitar retiro',
    'inventory.balance.autoWithdrawal': 'Retiro autom\u00e1tico',
    'inventory.table.title.inventoryManagement': 'Gesti\u00f3n de inventario',
    'inventory.table.title.mediaSpotManagement': 'Gesti\u00f3n de puntos de medios',
    'inventory.action.add': 'Agregar',
    'inventory.action.addMediaSpot': 'Agregar punto de medios',
    'inventory.player.downloadTitle': 'Descargar reproductor',
    'inventory.player.downloadDesc': 'Descarga e instala nuestro reproductor en tu pantalla para conectarte.',
    'inventory.player.learnMore': 'Saber m\u00e1s',
    'inventory.platform.alt': 'Plataforma {{name}}',
    'inventory.upgrade.title': 'Mejorar paquete',
    'inventory.upgrade.message': 'Actualizar tu paquete actualmente requiere asistencia de nuestro equipo. Cont\u00e1ctanos (correo: {{email}}) y te ayudaremos a cambiar de plan sin problemas.',

    'inventory.nav.manage': 'Puntos de medios',
    'inventory.nav.bookings': 'Reservas',
    'inventory.nav.performance': 'Rendimiento',
    'inventory.nav.pricing': 'Precios',
    'inventory.nav.audience': 'Audiencia',

    'inventory.manage.title': 'Gesti\u00f3n de puntos de medios',
    'inventory.manage.linkedHint': 'Las pantallas de este punto se reproducen juntas',
    'inventory.manage.confirmedScreens': 'Pantallas confirmadas',
    'inventory.manage.pendingScreens': 'Pantallas pendientes',
    'inventory.manage.offScreens': 'Pantallas apagadas',
    'inventory.manage.invalidSpotGroup': 'Grupo de puntos no v\u00e1lido.',
    'inventory.manage.confirmDelete.title': 'Confirmar eliminaci\u00f3n',
    'inventory.manage.confirmDelete.message': '\u00bfEliminar \"{{name}}\"?',
    'inventory.manage.deleteFailed': 'No se pudo eliminar el punto.',
    'inventory.manage.deleteError': 'Ocurri\u00f3 un error al eliminar los datos.',
    'inventory.manage.action.addScreen': 'Agregar pantalla',
    'inventory.manage.action.toggle': 'Cambiar estado',
    'inventory.manage.detail.empty': 'No hay detalles disponibles',
    'inventory.manage.toggle.title': 'Apagar punto de medios',
    'inventory.manage.toggle.titleOn': 'Encender punto de medios',
    'inventory.manage.toggle.warning.title': 'Advertencia',
    'inventory.manage.toggle.warning.description': 'La pantalla est\u00e1 reproduciendo actualmente una campa\u00f1a activa. Apagar la pantalla detendr\u00e1 inmediatamente la reproducci\u00f3n para:',
    'inventory.manage.toggle.warning.checkbox': 'Entiendo y acepto que la interrupci\u00f3n de la campa\u00f1a puede generar penalizaciones seg\u00fan los t\u00e9rminos aplicables.',
    'inventory.manage.toggle.reasonLabel': 'Raz\u00f3n para apagar (compartida con anunciantes afectados):',
    'inventory.manage.toggle.reasonPlaceholder': 'Por favor describa por qu\u00e9 est\u00e1 apagando este punto de medios...',
    'inventory.manage.toggle.keepScreenOn': 'Mantener encendida',
    'inventory.manage.toggle.turnOffAnyway': 'Apagar de todos modos',
    'inventory.manage.toggle.turnOn.title': 'Encender Punto de Medios',
    'inventory.manage.toggle.turnOn.description': 'Se encenderán todas las pantallas de este punto de medios. Las pantallas volverán a funcionar normalmente.',
    'inventory.manage.toggle.turnOn.checkbox': 'Confirmo que deseo encender este punto de medios y todas sus pantallas.',
    'inventory.manage.toggle.turnOnAnyway': 'Encender',
    'inventory.manage.toggle.confirm.title': '\u00bfEst\u00e1 seguro de que desea apagar la(s) siguiente(s) pantalla(s)?',
    'inventory.manage.toggle.confirm.description': 'La(s) siguiente(s) pantalla(s) ser\u00e1(n) apagada(s) y detendr\u00e1(n) toda la reproducci\u00f3n de campa\u00f1as.',
    'inventory.manage.toggle.confirm.table.screenName': 'Nombre de pantalla',
    'inventory.manage.toggle.confirm.table.spot': 'Punto',
    'inventory.manage.toggle.confirm.table.group': 'Grupo',
    'inventory.manage.toggle.confirm.yes': 'S\u00ed',
    'inventory.manage.toggle.confirm.titleOn': 'Confirmar encendido',
    'inventory.manage.toggle.confirm.messageOn': '\u00bfEst\u00e1 seguro de que desea encender \"{{name}}\"?',
    'inventory.manage.toggle.success.title': ' \u00c9xito',
    'inventory.manage.toggle.success.messageOff': 'Pantalla(s) apagada(s) exitosamente.',
    'inventory.manage.toggle.success.messageOn': 'Pantalla(s) encendida(s) exitosamente.',
    'inventory.manage.toggle.success.ok': 'OK',
    'inventory.manage.toggle.failed': 'Error al cambiar el estado del punto.',

    'inventory.detail.screenName': 'Nombre de pantalla',
    'inventory.detail.serialNo': 'N.\u00ba de serie',
    'inventory.detail.brand': 'Marca',
    'inventory.detail.model': 'Modelo',
    'inventory.detail.os': 'SO',
    'inventory.detail.player': 'Reproductor',
    'inventory.detail.status': 'Estado',
    'inventory.detail.screenStatus': 'Estado de pantalla',
    'inventory.screen.column.deviceId': 'ID de dispositivo',
    'inventory.screen.column.orientation': 'Orientaci\u00f3n',
    'inventory.orientation.landscape': 'Horizontal',
    'inventory.orientation.portrait': 'Vertical',
    'inventory.screen.invalid': 'Pantalla no v\u00e1lida.',
    'inventory.screen.delete.success': 'La pantalla se elimin\u00f3 correctamente.',
    'inventory.screen.delete.failed': 'No se pudo eliminar la pantalla.',
    'inventory.screen.delete.httpFailed': 'No se pudo eliminar la pantalla.',
    'inventory.screen.toggle.confirm.messageOn': '\u00bfEst\u00e1 seguro de que desea encender la pantalla "{{name}}"?',
    'inventory.screen.action.turnOff': 'Apagar',

    'inventory.bookings.title': 'Gesti\u00f3n de reservas',
    'inventory.bookings.column.bookingId': 'ID de reserva',
    'inventory.bookings.column.advertiser': 'Anunciante',
    'inventory.bookings.column.campaign': 'Campa\u00f1a',
    'inventory.bookings.column.mediaSpot': 'Punto de medios',
    'inventory.bookings.column.period': 'Periodo',
    'inventory.bookings.column.autoCancel': 'Cancelaci\u00f3n autom\u00e1tica',
    'inventory.bookings.periodWithStart': '{{days}} d\u00edas, inicia {{start}}',

    'inventory.availability.title': 'Gesti\u00f3n de disponibilidad',
    'inventory.performance.title': 'Anal\u00edtica de rendimiento',
    'inventory.pricing.title': 'Gesti\u00f3n de precios',
    'inventory.audience.title': 'Anal\u00edtica de audiencia',

    'inventory.column.spotName': 'Nombre del punto',
    'inventory.column.id': 'ID',
    'inventory.column.category': 'Categor\u00eda',
    'inventory.column.mediaType': 'Tipo de medio',
    'inventory.column.office': 'Oficina',
    'inventory.column.pairedScreen': 'Pantalla emparejada',
    'inventory.column.groupName': 'Nombre del grupo',
    'inventory.column.venueType': 'Tipo de lugar',
    'inventory.column.group': 'Grupo',
    'inventory.column.status': 'Estado',
    'inventory.column.syncStatus': 'Estado de sincronizaci\u00f3n',
    'inventory.column.createdTime': 'Fecha de creaci\u00f3n',
    'inventory.column.updatedTime': 'Fecha de actualizaci\u00f3n',
    'inventory.column.deletedTime': 'Fecha de eliminaci\u00f3n',
    'inventory.column.spotGroup': 'Grupo de puntos',
    'inventory.column.screenLabel': 'Etiqueta de pantalla',
    'inventory.column.occupancy': 'Ocupaci\u00f3n',
    'inventory.column.revenue': 'Ingresos',
    'inventory.column.totalScreens': 'Pantallas totales',
    'inventory.column.thirdPartySlot': 'Slot de terceros',
    'inventory.column.value': 'Valor',
    'inventory.column.promotion': 'Promoci\u00f3n',
    'inventory.column.specialOffer': 'Oferta especial',
    'inventory.column.audienceType': 'Tipo de audiencia',
    'inventory.column.approxDailyFootfall': 'Tr\u00e1fico diario aproximado',

    'inventory.mediaType.digitalSignage': 'Se\u00f1alizaci\u00f3n digital',
    'inventory.mediaType.ledDisplay': 'Pantalla LED',
    'inventory.mediaType.lcdMonitor': 'Monitor LCD',

    'inventory.empty.availability': 'No hay datos de disponibilidad',
    'inventory.empty.bookings': 'No hay datos de reservas',
    'inventory.empty.performance': 'No hay datos de rendimiento por ahora',
    'inventory.empty.pricing': 'No hay datos de precios disponibles',
    'inventory.empty.audience': 'No se encontraron datos de audiencia',

    'account.title': 'Cuenta',
    'account.breadcrumb.main': 'Principal',
    'account.license.title': 'Licencia',
    'account.license.section.subscription.title': 'Suscripción',
    'account.license.subscription.accountSubscription.title': 'Suscripción de la cuenta',
    'account.license.subscription.accountSubscription.subtitle': 'Mejora tu suscripción',
    'account.license.subscription.accountSubscription.badge': 'Gratis Básico - licencia de 1 pantalla',
    'account.license.subscription.addLicenses.title': 'Agregar licencias',
    'account.license.subscription.addLicenses.subtitle': 'Agrega más licencias para captar mejor la imaginación de tus espectadores',
    'account.license.subscription.changePlan.title': 'Cambiar plan',
    'account.license.subscription.changePlan.subtitle': 'Mejora a Premium o Enterprise para más funciones.',
    'account.license.subscription.changePlan.badge': 'Mejorar a Premium',
    'account.license.section.users.title': 'Usuarios',
    'account.license.users.usersCard.title': 'Usuarios',
    'account.license.users.usersCard.subtitle': 'Agrega usuarios a tu cuenta con diferentes niveles de acceso.',
    'account.license.users.usersCard.badge': '1 usuario',
    'account.license.users.groups.title': 'Grupos',
    'account.license.users.groups.subtitle': 'Organiza a tus usuarios en grupos y asigna roles en su espacio de trabajo principal o en cualquier otro.',
    'account.license.users.groups.badge': '0 grupos',
    'account.license.users.securityPolicies.title': 'Políticas de seguridad',
    'account.license.users.securityPolicies.subtitle': 'Aplica políticas de contraseña y sesión a tus usuarios. Configura una lista blanca de direcciones IP.',
    'account.license.users.sso.title': 'SSO (Inicio de sesión único)',
    'account.license.users.sso.subtitle': 'Configura el inicio de sesión único con tu proveedor de identidad SAML.',
    'account.license.section.player.title': 'Reproductor',
    'account.license.player.bootLogo.title': 'Logo de arranque del reproductor',
    'account.license.player.bootLogo.subtitle': 'Muestra tu imagen o logo personalizado cuando tus reproductores inicien.',
    'account.license.section.advanced.title': 'Configuración avanzada',
    'account.license.advanced.apiTokens.title': 'Tokens de API',
    'account.license.advanced.apiTokens.subtitle': 'Usa tokens de API como claves seguras para autenticar y autorizar el acceso a aplicaciones y servicios externos.',
    'account.license.advanced.apiTokens.badge': 'Tokens',
    'account.license.advanced.auditLog.title': 'Registro de auditoría',
    'account.license.advanced.auditLog.subtitle': 'Registros detallados de actividad para todos los usuarios de tu cuenta.',
    'account.license.badge.disabled': 'Deshabilitado',
    'account.license.badge.default': 'Predeterminado',
    'account.userManagement.title': 'Gestión de usuarios',
    'account.userManagement.members.title': 'Miembros',
    'account.userManagement.members.inviteUser': 'Invitar usuario',
    'account.userManagement.members.column.fullName': 'Nombre completo',
    'account.userManagement.members.column.email': 'Correo',
    'account.userManagement.members.column.groupOrder': 'Grupo',
    'account.userManagement.members.column.role': 'Rol',
    'account.userManagement.members.column.lastActive': 'Último activo',
    'account.userManagement.members.column.invitedOn': 'Invitado en',
    'account.userManagement.members.loadFailed': 'No se pudieron cargar los miembros.',
    'account.userManagement.groups.title': 'Grupos de usuarios',
    'account.userManagement.groups.addGroup': 'Agregar grupo',
    'account.userManagement.groups.column.groupName': 'Nombre del grupo',
    'account.userManagement.groups.column.members': 'Miembros',
    'account.userManagement.groups.column.dateCreated': 'Fecha de creación',
    'account.userManagement.groups.loadFailed': 'No se pudieron cargar los grupos de usuarios.',
    'account.userManagement.groups.deleteSuccess': 'Grupo eliminado.',
    'account.userManagement.groups.deleteFailed': 'No se pudo eliminar el grupo.',

    'account.menu.settings': 'Configuración',
    'account.menu.business': 'Negocio',
    'account.menu.preference': 'Preferencias',
    'account.menu.favorite': 'Favoritos',
    'account.menu.collaboard': 'CollaBoard',

    'account.settings.basicInfo': 'Información básica',
    'account.settings.security': 'Seguridad',
    'account.settings.notification': 'Notificaciones',
    'account.settings.company': 'Empresa',
    'account.settings.payout': 'Pagos',
    'account.settings.shared': 'Compartido',
    'account.settings.invitation': 'Invitación',

    'account.inventoryMenu.mediaSpot.title': 'Punto de medios',
    'account.inventoryMenu.spotGroup.title': 'Grupo de puntos',
    'account.inventoryMenu.spotGroup.addGroup': 'Agregar grupo',
    'account.inventoryMenu.spotGroup.column.groupName': 'Nombre del grupo',
    'account.inventoryMenu.spotGroup.column.excludeOffers': 'Excluir ofertas',
    'account.inventoryMenu.spotGroup.invalidGroup': 'Grupo de puntos no válido.',
    'account.inventoryMenu.spotGroup.deleteFailed': 'Ocurrió un error al eliminar los datos.',
    'account.inventoryMenu.spotGroup.bulkDeleteSuccess': 'Grupo de puntos eliminado correctamente.',
    'account.inventoryMenu.screens.title': 'Pantallas',

    'account.inventoryMenu.bookings.pending.title': 'Reservas pendientes',
    'account.inventoryMenu.bookings.pending.empty': 'No hay reservas pendientes',
    'account.inventoryMenu.bookings.accepted.title': 'Reservas aceptadas',
    'account.inventoryMenu.bookings.accepted.empty': 'No hay reservas aceptadas',
    'account.inventoryMenu.bookings.declined.title': 'Reservas rechazadas',
    'account.inventoryMenu.bookings.declined.empty': 'No hay reservas rechazadas',
    'account.inventoryMenu.bookings.canceled.title': 'Reservas canceladas',
    'account.inventoryMenu.bookings.canceled.empty': 'No hay reservas canceladas',
    'account.inventoryMenu.bookings.title': 'Reservas',
    'account.inventoryMenu.bookings.tab.pending': 'Pendiente',
    'account.inventoryMenu.bookings.tab.accepted': 'Aceptadas',
    'account.inventoryMenu.bookings.tab.declined': 'Rechazadas',
    'account.inventoryMenu.bookings.tab.canceled': 'Canceladas',
    'account.inventoryMenu.bookings.column.date': 'Fecha',
    'account.inventoryMenu.bookings.column.canceledBy': 'Cancelado por',

    'account.inventoryMenu.screens.edit.title': 'Editar pantalla',
    'account.inventoryMenu.screens.edit.section.screenInfo': 'Información de la pantalla',
    'account.inventoryMenu.screens.edit.label.deviceId': 'ID de dispositivo',
    'account.inventoryMenu.screens.edit.label.brand': 'Marca',
    'account.inventoryMenu.screens.edit.label.model': 'Modelo',
    'account.inventoryMenu.screens.edit.label.osVersion': 'Versión del SO',
    'account.inventoryMenu.screens.edit.label.sdkVersion': 'Versión del SDK',
    'account.inventoryMenu.screens.edit.label.firmwareVersion': 'Versión del firmware',
    'account.inventoryMenu.screens.edit.label.playerVersion': 'Versión del reproductor',
    'account.inventoryMenu.screens.edit.label.screenResolution': 'Resolución de pantalla',
    'account.inventoryMenu.screens.edit.label.spotName': 'Nombre del punto',
    'account.inventoryMenu.screens.edit.label.screenName': 'Nombre de pantalla',
    'account.inventoryMenu.screens.edit.label.orientation': 'Orientación de pantalla',
    'account.inventoryMenu.screens.edit.screenName.placeholder': 'Ingresa el nombre de la pantalla',
    'account.inventoryMenu.screens.edit.select.spot.placeholder': 'Selecciona punto',
    'account.inventoryMenu.screens.edit.select.spot.searchPlaceholder': 'Buscar punto...',
    'account.inventoryMenu.screens.edit.select.orientation.placeholder': 'Selecciona orientación',
    'account.inventoryMenu.screens.edit.select.orientation.searchPlaceholder': 'Buscar orientación...',
    'account.inventoryMenu.screens.edit.validation.missingRequired': 'Faltan campos obligatorios.',
    'account.inventoryMenu.screens.edit.validation.screenNameInvalid': 'El nombre de la pantalla debe tener al menos 3 caracteres y solo contener caracteres válidos.',
    'account.inventoryMenu.screens.edit.updateSuccess': 'Datos actualizados correctamente.',
    'account.inventoryMenu.screens.edit.updateFailed': 'No se pudo actualizar.',
    'account.inventoryMenu.screens.edit.unauthorized': 'Falló la autenticación: no se proporcionaron credenciales válidas.',
    'account.inventoryMenu.screens.edit.invalidScreenId': 'ID de pantalla no válido.',
    'account.inventoryMenu.screens.edit.serverError': 'Ocurrió un error al actualizar los datos.',

    'account.campaignWallet.balance.label': 'Saldo de la billetera',
    'account.campaignWallet.action.addFunds': 'Agregar fondos',
    'account.campaignWallet.stats.budgetAllocationThisMonth': 'Asignación de presupuesto (este mes)',
    'account.campaignWallet.stats.mtdSpend': 'Gasto acumulado del mes',
    'account.campaignWallet.stats.mtdCostPerPlay': 'Costo por reproducción (mes a la fecha)',
    'account.campaignWallet.transactions.title': 'Historial de transacciones de la billetera',
    'account.campaignWallet.table.column.date': 'Fecha',
    'account.campaignWallet.table.column.paymentMethod': 'Método de pago',
    'account.campaignWallet.table.column.amount': 'Monto',
    'account.campaignWallet.table.column.status': 'Estado',

    'account.inventoryMenu.bookingReview.title': 'Revisión de reserva',
    'account.inventoryMenu.bookingReview.subtitle': 'Revisa el anuncio enviado para asegurar que cumple tu estándar',
    'account.inventoryMenu.bookingReview.label.advertiser': 'Anunciante',
    'account.inventoryMenu.bookingReview.label.durationResolution': 'Duración y resolución',
    'account.inventoryMenu.bookingReview.label.campaignName': 'Nombre de campaña',
    'account.inventoryMenu.bookingReview.label.campaignSchedule': 'Horario de campaña',
    'account.inventoryMenu.bookingReview.label.mediaSpot': 'Punto de medios',
    'account.inventoryMenu.bookingReview.viewSpot': 'Ver punto',
    'account.inventoryMenu.bookingReview.durationSeconds': '{{seconds}} segundos',
    'account.inventoryMenu.bookingReview.resolutionPixels': '{{width}} × {{height}} píxeles',
    'account.inventoryMenu.bookingReview.durationResolution': '{{duration}}, {{resolution}}',
    'account.inventoryMenu.bookingReview.spotNotFound': 'No se encontraron detalles del punto.',
    'account.inventoryMenu.bookingReview.loadSpotFailed': 'No se pudieron cargar los detalles del punto.',
    'account.inventoryMenu.bookingReview.accepted': 'Aceptado correctamente.',
    'account.inventoryMenu.bookingReview.acceptFailed': 'No se pudo aceptar la reserva.',
    'account.inventoryMenu.bookingReview.declined': 'Rechazado correctamente.',
    'account.inventoryMenu.bookingReview.declineFailed': 'No se pudo rechazar la reserva.',

    'account.subscription.activePlan.title': 'Plan activo',
    'account.subscription.activePlan.loading': 'Cargando detalles del plan...',
    'account.subscription.activePlan.loadFailed': 'No se pudo cargar el plan de suscripción. Inténtalo más tarde.',
    'account.subscription.activePlan.unlimited': 'Ilimitado',
    'account.subscription.activePlan.noCreditCard': 'Sin tarjeta de crédito, sin costos ocultos, sin límite de tiempo, sin presión.',
    'account.subscription.activePlan.renewalDate': 'Fecha de renovación',
    'account.subscription.activePlan.billingCycle': 'Ciclo de facturación',
    'account.subscription.activePlan.activeSince': 'Activo desde',
    'account.subscription.activePlan.features': 'Características y beneficios',
    'account.subscription.activePlan.noFeatures': 'No hay características disponibles',

    'account.subscription.upgradePlan.title': 'Mejorar plan',
    'account.subscription.upgradePlan.month': 'Mes',
    'account.subscription.upgradePlan.orderSummary': 'Resumen del pedido',
    'account.subscription.upgradePlan.tax': 'Impuesto',
    'account.subscription.upgradePlan.total': 'Total',
    'account.subscription.upgradePlan.voucherCode': 'Código de cupón',
    'account.subscription.upgradePlan.voucherPlaceholder': 'Ingresa el código de cupón',
    'account.subscription.upgradePlan.applyVoucher': 'Aplicar',
    'account.subscription.upgradePlan.checkout': 'Pagar',
    'account.subscription.upgradePlan.loadFailed': 'No se pudieron cargar los planes de mejora',
    'account.subscription.upgradePlan.cartEmpty.title': 'Carrito vacío',
    'account.subscription.upgradePlan.cartEmpty.message': 'No hay características seleccionadas. Selecciona características y ajusta cantidad/duración antes de pagar.',
    'account.subscription.upgradePlan.paymentInitiated.title': 'Pago iniciado',
    'account.subscription.upgradePlan.paymentInitiated.message': 'Tu pago de suscripción se ha iniciado correctamente. Completa el pago usando la Cuenta Virtual proporcionada.',
    'account.subscription.upgradePlan.paymentInitiated.button': 'Ver pedidos',
    'account.subscription.upgradePlan.checkoutFailed': 'No se pudo crear el checkout',
    'account.subscription.upgradePlan.previewFailed': 'No se pudo calcular la vista previa',

    'account.subscription.orders.title': 'Mis pedidos',
    'account.subscription.orders.subtitle': 'Administra tu historial de pedidos y estado',
    'account.subscription.orders.items.title': 'Artículos del pedido',
    'account.subscription.orders.column.date': 'Fecha',
    'account.subscription.orders.column.description': 'Descripción',
    'account.subscription.orders.column.price': 'Precio',
    'account.subscription.orders.moreItems': ' +{{count}} más',
    'account.subscription.orders.orderId': 'Pedido {{id}}',
    'account.subscription.orders.loadFailed': 'No se pudo cargar el historial de suscripción.',
    'account.subscription.orders.paymentDetailFailed': 'No se pudieron cargar los detalles de pago.',
    'account.subscription.orders.items.column.item': 'Artículo',
    'account.subscription.orders.items.column.unit': 'Unidad',
    'account.subscription.orders.items.column.qty': 'Cant.',
    'account.subscription.orders.items.column.duration': 'Duración',
    'account.subscription.orders.items.column.pricePerUnit': 'Precio/Unidad',
    'account.subscription.orders.items.column.subtotal': 'Subtotal',

    'account.campaignWallet.title': 'Billetera de campaña',
    'account.campaign.menu.create': 'Crear',
    'account.campaign.menu.drafts': 'Borradores',
    'account.campaign.menu.pending': 'Pendiente',
    'account.campaign.menu.running': 'En curso',
    'account.campaign.menu.paused': 'Pausado',
    'account.campaign.menu.failed': 'Fallido',
    'account.campaign.menu.completed': 'Completado',
    'account.campaign.menu.edit': 'Editar',
    'account.campaign.menu.drafts.summary': '{{ready}} listo \u2022 {{incomplete}} incompleto',
    'account.campaign.menu.summary.campaignsSpots': '{{campaigns}} campa\u00f1as \u2022 {{spots}} puntos',
    'account.campaign.menu.confirmSwitch.message': '\u00bfCambiar de men\u00fa y reiniciar los datos de edici\u00f3n?',
    'account.campaign.menu.confirmSwitch.confirm': 'Cambiar',

    'account.campaign.create.campaignName': 'Nombre de la campaña',
    'account.campaign.create.campaignName.placeholder': 'Escribe aquí',
    'account.campaign.create.dateStart': 'Fecha de inicio',
    'account.campaign.create.dateEnd': 'Fecha de finalización',
    'account.campaign.create.timeRange': 'Rango de tiempo',
    'account.campaign.create.fullDay': 'Todo el día',
    'account.campaign.create.customTime': 'Horario personalizado',
    'account.campaign.create.customTime.item': 'Horario personalizado {{index}}',
    'account.campaign.create.customTime.add': 'Agregar horario personalizado',
    'account.campaign.create.customTime.cancel': 'Cancelar horario personalizado',
    'account.campaign.create.saveDraft': 'Guardar como borrador',
    'account.campaign.create.timeRange.earlyMorning': 'Madrugada',
    'account.campaign.create.timeRange.morning': 'Mañana',
    'account.campaign.create.timeRange.midday': 'Mediodía',
    'account.campaign.create.timeRange.afternoon': 'Tarde',
    'account.campaign.create.timeRange.evening': 'Noche',
    'account.campaign.create.timeRange.lateNight': 'Noche tarde',
    'account.campaign.create.mediaSpot.column.badges': 'Etiquetas',
    'account.campaign.create.mediaSpot.column.availability': 'Disponibilidad',
    'account.campaign.create.mediaSpot.empty': 'No hay puntos de medios seleccionados',
    'account.campaign.edit.backToDrafts': 'Volver a borradores',
    'account.campaign.edit.validation.startDateBeforeToday': 'La fecha de inicio no puede ser anterior a hoy.',
    'account.campaign.edit.validation.endDateBeforeStart': 'La fecha de finalización no puede ser anterior a la fecha de inicio.',
    'account.campaign.edit.validation.customTimeRequired': 'Agrega al menos un horario personalizado.',
    'account.campaign.edit.validation.timeRangeRequired': 'Selecciona al menos un rango de tiempo.',
    'account.campaign.edit.estimatedAllocation': 'Asignación estimada',
    'account.campaign.edit.budgetAllocation': 'Asignación de presupuesto',
    'account.campaign.edit.noFixedBudgetHint': 'Sin presupuesto fijo por ahora. Deja que Mataloka calcule el presupuesto según la ubicación elegida y las fechas de la campaña.',
    'account.campaign.edit.availabilityCalculated': 'La disponibilidad se calcula desde {{start}} hasta {{end}}.',
    'account.campaign.edit.unavailableSpots.title': 'Algunos puntos de medios no se pueden reservar',
    'account.campaign.edit.unavailableSpots.body': 'Uno o más puntos de medios seleccionados no están disponibles (inactivos o completamente reservados) para las fechas seleccionadas. Elimina o reemplaza los puntos no disponibles antes de solicitar una reserva.',
    'account.campaign.edit.addMoreSpot': 'Agregar más puntos',
    'account.campaign.edit.mediaSpotSelected': 'Punto de medios seleccionado',
    'account.campaign.edit.mediaSpotNotSelected': 'Aún no se seleccionó un punto de medios',
    'account.campaign.edit.mediaSpotNotSelected.desc': 'Aún no has seleccionado un punto de medios. Elegir uno garantiza que tu contenido llegue al destino correcto.',
    'account.campaign.edit.selectMediaSpot': 'Seleccionar punto de medios',
    'account.campaign.edit.creativeAsset': 'Recurso creativo',
    'account.campaign.edit.groupHeader.oneScreen': 'Una pantalla',
    'account.campaign.edit.groupHeader.twoSyncedScreens': 'Dos pantallas sincronizadas',
    'account.campaign.edit.groupHeader.syncedScreens': '{{count}} pantallas sincronizadas',
    'account.campaign.edit.groupHeader.mediaSpot.single': '{{count}} punto de medios',
    'account.campaign.edit.groupHeader.mediaSpot.plural': '{{count}} puntos de medios',
    'account.campaign.edit.assetPreviewAlt': 'Vista previa del recurso',
    'account.campaign.edit.video': 'Video',
    'account.campaign.edit.groupMeta.totalResolution': 'Resolución total {{resolution}} - máx. {{size}} por archivo',
    'account.campaign.edit.groupMeta.master': 'Maestro: Panel {{panel}}, duración {{duration}}',
    'account.campaign.edit.groupMeta.status': 'Estado',
    'account.campaign.edit.action.saveChanges': 'Guardar cambios',
    'account.campaign.edit.action.requestBooking': 'Solicitar reserva',
    'account.campaign.create.validation.invalidFormat': 'Formato no válido. Completa todos los campos obligatorios.',
    'account.campaign.create.validation.nameTooShort': 'El nombre de la campaña debe tener al menos 3 caracteres.',
    'account.campaign.create.validation.startBeforeToday': 'La fecha de inicio no puede ser anterior a hoy.',
    'account.campaign.create.validation.endBeforeStart': 'La fecha de finalización no puede ser anterior a la fecha de inicio.',
    'account.campaign.create.validation.timeRangeRequired': 'Selecciona al menos un rango de tiempo.',
    'account.campaign.create.validation.customTimeRequired': 'Agrega al menos un horario personalizado.',
    'account.campaign.create.validation.zeroScreens': 'Un punto de medios seleccionado tiene 0 pantallas. Elimínalo.',
    'account.campaign.create.createFailed': 'No se pudo crear la campaña.',
    'account.campaign.create.upload.invalidFile': 'Solo se permiten videos MP4.',
    'account.campaign.create.upload.durationInconsistent': 'La duración del anuncio permitida es inconsistente para los puntos de este grupo.',
    'account.campaign.create.upload.durationExceededDetailed': 'La duración del video debe ser \u2264 {{allowed}} segundos. Duración subida: {{actual}} segundos.',

    'account.campaign.completedDetail.loadFailed': 'No se pudieron cargar los detalles de la campaña completada.',
    'account.campaign.completedDetail.deliveryRate': '{{rate}}% Entregado',
    'account.campaign.completedDetail.spotsCount': '{{count}} Puntos',
    'account.campaign.completedDetail.screensCount': '{{count}} Pantallas',
    'account.campaign.completedDetail.hoursCount': '{{hours}} Horas',
    'account.campaign.completedDetail.creativeGroup': 'Grupo creativo',
    'account.campaign.completedDetail.asset': 'Recurso',
    'account.campaign.completedDetail.status.completed': 'Completado',
    'account.campaign.completedDetail.section.creativeAsset': 'Recurso creativo',
    'account.campaign.completedDetail.summary.booking': 'Reserva',
    'account.campaign.completedDetail.summary.bookingId': 'ID: {{id}}',
    'account.campaign.completedDetail.summary.totalSpent': 'Total gastado',
    'account.campaign.completedDetail.summary.totalPlays': 'Reproducciones totales',
    'account.campaign.completedDetail.summary.flightDates': 'Fechas de emisión',
    'account.campaign.completedDetail.summary.totalMedia': 'Total de medios',
    'account.campaign.completedDetail.summary.totalExposure': 'Exposición total',
    'account.campaign.completedDetail.table.totalSpent': 'Total gastado',
    'account.campaign.completedDetail.table.playCount': 'Recuento de reproducción',
    'account.campaign.completedDetail.table.footfall': 'Tráfico aprox.',

    'account.campaign.edit.upload.processing': 'Procesando carga...',
    'account.campaign.edit.upload.placeholder': 'Arrastra aquí o haz clic para subir',
    'account.campaign.edit.panel': 'Panel {{index}}',
    'account.campaign.edit.upload.timeout.title': 'Tiempo de carga agotado',
    'account.campaign.edit.upload.timeout.message': 'El estado de la carga excedió el tiempo de espera.',
    'account.campaign.edit.upload.failed.title': 'Carga fallida',
    'account.campaign.edit.upload.failed.message': 'La carga falló.',
    'account.campaign.edit.upload.statusCheckFailed': 'No se pudo verificar el estado de la carga.',

    'account.campaign.completed.title': 'Campañas completadas',
    'account.campaign.completed.column.spots': 'Puntos',
    'account.campaign.completed.column.flightDates': 'Fechas de emisión',
    'account.campaign.completed.action.playLog': 'Registro de reproducción',
    'account.campaign.completed.action.duplicate': 'Duplicar',
    'account.campaign.completed.empty': 'No se encontraron campañas completadas',
    'account.campaign.completed.loadFailed': 'No se pudo cargar la campaña completada.',
    'account.campaign.completed.playLog.title': 'Registro de reproducción',
    'account.campaign.completed.playLog.invalidId': 'ID de campaña no válido para descargar.',
    'account.campaign.completed.playLog.downloadFailed': 'No se pudo descargar el registro. Inténtalo de nuevo.',
    'account.campaign.completed.playLog.downloadError': 'No se pudo descargar el registro de reproducción de la campaña.',
    'account.campaign.completed.duplicate.title': 'Duplicar campaña',
    'account.campaign.completed.duplicate.invalidId': 'ID de campaña no válido para duplicar.',
    'account.campaign.completed.spot.single': '{{count}} Punto',
    'account.campaign.completed.spot.plural': '{{count}} Puntos',

    'account.settings.company.section.companyInfo': 'Información de la empresa',
    'account.settings.company.companyName': 'Nombre de la empresa',
    'account.settings.company.companyName.placeholder': 'Ingresa el nombre de la empresa',
    'account.settings.company.businessCategory': 'Categoría de negocio',
    'account.settings.company.businessCategory.placeholder': 'Seleccionar categoría de negocio',
    'account.settings.company.mobileWhatsapp': 'Móvil (para WhatsApp)',
    'account.settings.company.mobile.placeholder': 'Ingresa el número móvil',
    'account.settings.company.businessEmail': 'Correo empresarial',
    'account.settings.company.businessEmail.placeholder': 'Ingresa el correo empresarial',
    'account.settings.company.contactPerson': 'Persona de contacto',
    'account.settings.company.contactPerson.placeholder': 'Ingresa el nombre de contacto',
    'account.settings.company.dashboardLogo': 'Logo del panel',
    'account.settings.company.chooseFile': 'Elegir archivo',
    'account.settings.company.logoHelp': 'Formatos permitidos: PNG, JPG, GIF, WEBP. Si no se sube, el logo quedará vacío.',
    'account.settings.company.uploadLogo': 'Subir logo',
    'account.settings.company.removeLogo': 'Quitar logo',
    'account.settings.company.businessCategory.loadFailed': 'No se pudieron cargar las categorías de negocio.',
    'account.settings.company.validation.companyNameInvalid': 'El nombre de la empresa debe tener al menos 3 caracteres.',
    'account.settings.company.validation.phoneInvalid': 'Formato de número de teléfono no válido (8-15 dígitos).',
    'account.settings.company.validation.emailInvalid': 'Formato de correo no válido.',
    'account.settings.company.validation.contactPersonInvalid': 'El nombre del contacto debe tener al menos 3 caracteres.',
    'account.settings.company.validation.businessCategoryRequired': 'Selecciona una categoría de negocio.',
    'account.settings.company.validation.imageOnly': 'Selecciona un archivo de imagen.',
    'account.settings.company.validation.dashboardLogoFormatInvalid': 'El formato del logo del dashboard debe ser PNG/JPG/GIF/WEBP.',
    'account.settings.company.validation.dashboardLogoRequired': 'Selecciona primero un archivo de logo.',
    'account.settings.company.updateSuccess': 'Los datos de la empresa se actualizaron correctamente.',
    'account.settings.company.updateFailed': 'No se pudieron actualizar los datos de la empresa.',
    'account.settings.company.dashboardLogo.uploadSuccess': 'El logo del dashboard se subió correctamente.',
    'account.settings.company.dashboardLogo.uploadFailed': 'No se pudo subir el logo del dashboard.',
    'account.settings.company.dashboardLogo.deleteSuccess': 'El logo del dashboard se eliminó correctamente.',
    'account.settings.company.dashboardLogo.deleteFailed': 'No se pudo eliminar el logo del dashboard.',

    'account.settings.payout.section.withdrawal': 'Retiro',
    'account.settings.payout.section.currency': 'Moneda',
    'account.settings.payout.section.bankAccount': 'Cuenta bancaria de pago',
    'account.settings.payout.autoWithdrawal': 'Retiro automático',
    'account.settings.payout.minimumThreshold': 'Umbral mínimo de retiro',
    'account.settings.payout.schedule': 'Horario',
    'account.settings.payout.preferredCurrency': 'Moneda preferida',
    'account.settings.payout.bankName': 'Nombre del banco',
    'account.settings.payout.accountHolderName': 'Titular de la cuenta',
    'account.settings.payout.accountHolderName.placeholder': 'p. ej., John Smith',
    'account.settings.payout.accountNumber': 'Número de cuenta',
    'account.settings.payout.accountNumber.placeholder': 'p. ej., 122230918756',
    'account.settings.payout.currency.placeholder': 'Seleccionar moneda preferida',
    'account.settings.payout.bank.placeholder': 'Seleccionar banco',
    'account.settings.payout.schedule.placeholder': 'Seleccionar horario',
    'account.settings.payout.loadFailed': 'No se pudieron cargar los ajustes de pago.',
    'account.settings.payout.updateSuccess': 'Los ajustes de pago se actualizaron correctamente.',
    'account.settings.payout.updateFailed': 'No se pudieron actualizar los ajustes de pago.',
    'account.settings.payout.bank.loadFailed': 'No se pudieron cargar los datos del banco.',
    'account.settings.payout.schedule.loadFailed': 'No se pudieron cargar los horarios de pago.',
    'account.settings.payout.currency.loadFailed': 'No se pudieron cargar las monedas.',
    'account.settings.payout.validation.bankRequired': 'Selecciona un banco.',
    'account.settings.payout.validation.accountNumberInvalid': 'Número de cuenta no válido (5–20 dígitos).',
    'account.settings.payout.validation.accountHolderInvalid': 'El titular debe tener al menos 3 caracteres.',
    'account.settings.payout.validation.scheduleRequired': 'Selecciona un horario para el retiro automático.',
    'account.settings.payout.validation.currencyRequired': 'Selecciona una moneda para el retiro automático.',

    'account.settings.notification.section.screen': 'Pantalla',
    'account.settings.notification.section.bookings': 'Reservas',
    'account.settings.notification.screen.offline': 'Envíame un correo cuando una pantalla se desconecte',
    'account.settings.notification.screen.online': 'Envíame un correo cuando una pantalla vuelva a estar en línea',
    'account.settings.notification.bookings.slotBooked': 'Envíame un correo cuando se reserve un espacio',
    'account.settings.notification.bookings.expires': 'Envíame un correo cuando una reserva caduque',
    'account.settings.notification.section.invitations': 'Invitaciones',
    'account.settings.notification.invitations.guest': 'Envíame un correo cuando reciba una invitación de invitado',
    'account.settings.notification.invitations.response': 'Envíame un correo cuando se responda una invitación de invitado',
    'account.settings.notification.loadFailed': 'No se pudieron cargar los ajustes de notificación.',
    'account.settings.notification.updateSuccess': 'Los ajustes de notificación se actualizaron correctamente.',
    'account.settings.notification.updateFailed': 'No se pudieron actualizar los ajustes de notificación.',

    'account.settings.security.section.password': 'Contraseña',
    'account.settings.security.section.alert': 'Alerta',
    'account.settings.security.newPassword': 'Nueva contraseña',
    'account.settings.security.newPassword.placeholder': 'Ingresa la nueva contraseña',
    'account.settings.security.verifyPassword': 'Verificar nueva contraseña',
    'account.settings.security.verifyPassword.placeholder': 'Confirma la nueva contraseña',
    'account.settings.security.password.hint.match': 'Ambas contraseñas deben coincidir',
    'account.settings.security.alert.newLocation': 'Envíame un correo cuando alguien inicie sesión desde una nueva ubicación',
    'account.settings.security.password.strength.weak': 'Débil',
    'account.settings.security.password.strength.medium': 'Media',
    'account.settings.security.password.strength.strong': 'Fuerte',
    'account.settings.security.password.requirement.min8': 'Al menos 8 caracteres',
    'account.settings.security.password.requirement.lowercase': 'Contiene una letra minúscula',
    'account.settings.security.password.requirement.uppercase': 'Contiene una letra mayúscula',
    'account.settings.security.password.requirement.number': 'Contiene un número',
    'account.settings.security.password.requirement.special': 'Contiene un carácter especial',
    'account.settings.security.password.error.fillAll': 'Completa todos los campos',
    'account.settings.security.password.error.notMatch': 'Las contraseñas no coinciden',
    'account.settings.security.password.error.tooWeak': 'La contraseña es demasiado débil. Elige una contraseña más fuerte.',
    'account.settings.security.password.updated': 'Contraseña actualizada correctamente.',
    'account.settings.security.password.updateFailed': 'No se pudo actualizar la contraseña.',

    'account.settings.shared.title': 'Paneles compartidos',
    'account.settings.shared.subtitle': 'Administra el acceso y permisos de paneles compartidos',
    'account.settings.shared.column.dashboard': 'Panel',
    'account.settings.shared.column.invited': 'Invitado',
    'account.settings.shared.column.invitedOn': 'Invitado el',
    'account.settings.shared.column.invitedBy': 'Invitado por',
    'account.settings.shared.column.lastActive': 'Última actividad',

    'account.settings.invitation.title': 'Gestión de invitaciones',
    'account.settings.invitation.subtitle': 'Administra las invitaciones de panel enviadas a usuarios',

    'account.settings.favorite.title': 'Anunciantes favoritos',
    'account.settings.favorite.subtitle': 'Administra tus anunciantes favoritos y sigue su rendimiento',
    'account.settings.favorite.column.approvedBooking': 'Reservas aprobadas',
    'account.settings.favorite.column.lastBooking': 'Última reserva',
    'account.settings.favorite.column.totalRevenue': 'Ingresos totales',
    'account.settings.favorite.column.since': 'Desde',

    'account.settings.preference.section.content': 'Contenido',
    'account.settings.preference.section.advertiser': 'Anunciante',
    'account.settings.preference.section.player': 'Reproductor',
    'account.settings.preference.section.advanced': 'Avanzado',
    'account.settings.preference.content.title': 'Preferencia de contenido',
    'account.settings.preference.advertiser.title': 'Preferencia de anunciante',
    'account.settings.preference.playerBootLogo.title': 'Logo de arranque del reproductor',
    'account.settings.preference.feature.apiTokens': 'Tokens de API',
    'account.settings.preference.feature.playLog': 'Registro de reproducción',
    'account.settings.preference.feature.auditLog': 'Registro de auditoría',
    'account.settings.preference.action.setPreference': 'Configurar preferencia',
    'account.settings.preference.action.changeBootLogo': 'Cambiar logo de arranque',
    'account.settings.preference.action.enabled': 'Habilitado',
    'account.settings.preference.value.preferredContent': 'Tu contenido preferido',
    'account.settings.preference.value.preferredAdvertiser': 'Tu anunciante preferido',
    'account.settings.preference.value.default': 'Predeterminado',
    'account.settings.preference.status.disabled': 'Deshabilitado',

    'inventory.needAttention.title': 'Requiere atenci\u00f3n',
    'inventory.needAttention.column.screens': 'Pantallas',
    'inventory.needAttention.column.needsAttention': 'Requiere atenci\u00f3n',
    'inventory.needAttention.column.firstDetected': 'Detectado por primera vez',
    'inventory.needAttention.empty': 'No hay puntos que requieran atenci\u00f3n en este momento',
    'inventory.needAttention.detail.column.property': 'Propiedad',
    'inventory.needAttention.detail.column.value': 'Valor',
    'inventory.needAttention.detail.spotName': 'Nombre del punto',
    'inventory.needAttention.detail.detectedAt': 'Detectado el',
    'inventory.needAttention.detail.status': 'Estado',
    'inventory.needAttention.detail.lastHeartbeat': '\u00daltimo latido',
    'inventory.needAttention.detail.recommendation': 'Recomendaci\u00f3n',
    'inventory.needAttention.detail.storageLeft': 'Almacenamiento disponible',
    'inventory.needAttention.detail.failedAttempts': 'Intentos fallidos',
    'inventory.needAttention.detail.errorCode': 'C\u00f3digo de error',
    'inventory.needAttention.detail.lastMaintenance': '\u00daltimo mantenimiento',
    'inventory.needAttention.detail.currentVersion': 'Versi\u00f3n actual',
    'inventory.needAttention.detail.newVersion': 'Nueva versi\u00f3n',
    'inventory.needAttention.type.offline': 'Sin conexi\u00f3n',
    'inventory.needAttention.type.low-storage': 'Bajo almacenamiento',
    'inventory.needAttention.type.connection-issue': 'Problema de conexi\u00f3n',
    'inventory.needAttention.type.maintenance': 'Mantenimiento requerido',
    'inventory.needAttention.type.update-needed': 'Actualizaci\u00f3n necesaria',
    'inventory.needAttention.value.minutesAgo': 'hace {{minutes}} minutos',
    'inventory.needAttention.value.hoursAgo': 'hace {{hours}} horas',
    'inventory.needAttention.value.daysAgo': 'hace {{days}} d\u00edas',
    'inventory.needAttention.value.weeksAgo': 'hace {{weeks}} semanas',
    'inventory.needAttention.group.shoppingMalls': 'Centros comerciales',
    'inventory.needAttention.group.transportation': 'Transporte',
    'inventory.needAttention.group.hospitality': 'Hoteler\u00eda',
    'inventory.needAttention.group.corporate': 'Corporativo',
    'inventory.needAttention.group.foodAndBeverage': 'Alimentos y bebidas',
    'inventory.needAttention.group.retail': 'Comercio minorista',
    'inventory.needAttention.group.education': 'Educaci\u00f3n',
    'inventory.needAttention.group.healthcare': 'Salud',
    'inventory.needAttention.group.entertainment': 'Entretenimiento',
    'inventory.needAttention.group.financial': 'Financiero',
    'inventory.needAttention.recommendation.offline': 'Verifica la energ\u00eda y la conexi\u00f3n de red.',
    'inventory.needAttention.recommendation.lowStorage': 'Elimina archivos innecesarios.',
    'inventory.needAttention.recommendation.connectionIssue': 'Reinicia el servicio de sincronizaci\u00f3n o revisa los registros.',
    'inventory.needAttention.recommendation.maintenanceRequired': 'Programa el mantenimiento pronto.',
    'inventory.needAttention.recommendation.updateNeeded': 'Programa la actualizaci\u00f3n de software.',

    'auth.login.title': 'Iniciar sesión',
    'auth.login.emailAddress': 'Dirección de correo',
    'auth.login.emailPlaceholder': 'Correo',
    'auth.login.password': 'Contraseña',
    'auth.login.passwordPlaceholder': 'Contraseña',
    'auth.login.forgotPassword': '¿Olvidaste tu contraseña?',
    'auth.login.submit': 'Iniciar sesión',
    'auth.login.loggingIn': 'Iniciando sesión...',
    'auth.login.or': 'o',
    'auth.login.noAccount': '¿No tienes una cuenta?',
    'auth.login.signUp': 'Regístrate',
    'auth.login.illustrationAlt': 'Ilustración de inicio de sesión',
    'auth.login.sessionExpired': 'Tu sesión ha expirado. Por favor, inicia sesión de nuevo.',
    'auth.login.loggedOut': 'Has cerrado sesión. Por favor, inicia sesión de nuevo.',
    'auth.login.googleFailed': 'El inicio de sesión con Google falló. Inténtalo de nuevo.',

    'auth.shell.logoAlt': 'Logo de {{appName}}',

    'auth.forgot.title': '¿Olvidaste tu contraseña?',
    'auth.forgot.subtitle': 'Ingresa tu correo para recibir instrucciones de restablecimiento.',
    'auth.forgot.illustrationAlt': 'Ilustración de contraseña olvidada',
    'auth.forgot.emailAddress': 'Dirección de correo',
    'auth.forgot.emailPlaceholder': 'Correo',
    'auth.forgot.submit': 'Enviar',
    'auth.forgot.sending': 'Enviando...',
    'auth.forgot.remember': '¿Recuerdas tu contraseña?',
    'auth.forgot.login': 'Iniciar sesión',
    'auth.forgot.errorTitle': 'Error',
    'auth.forgot.successTitle': 'Éxito',
    'auth.forgot.emailRequired': 'Ingresa una dirección de correo válida.',
    'auth.forgot.emailInvalid': 'Formato de correo inválido.',
    'auth.forgot.successMessage': 'Se envió el enlace de restablecimiento a tu correo.',
    'auth.forgot.errorMessage': 'Ocurrió un error al enviar el correo de restablecimiento. Inténtalo de nuevo.',

    'auth.reset.title': 'Restablecer contraseña',
    'auth.reset.subtitle': 'Tu nueva contraseña debe ser diferente a las usadas anteriormente.',
    'auth.reset.illustrationAlt': 'Ilustración de restablecimiento de contraseña',
    'auth.reset.newPassword': 'Nueva contraseña',
    'auth.reset.confirmPassword': 'Confirmación de nueva contraseña',
    'auth.reset.passwordPlaceholder': 'Contraseña',
    'auth.reset.hint': 'Usa una combinación de minúsculas, mayúsculas, números y símbolos.',
    'auth.reset.combination': 'Combinación actual: {{combo}}',
    'auth.reset.matchHint': 'Ambas contraseñas deben coincidir',
    'auth.reset.submit': 'Restablecer contraseña',
    'auth.reset.resetting': 'Restableciendo...',
    'auth.reset.strength.weak': 'Débil',
    'auth.reset.strength.medium': 'Media',
    'auth.reset.strength.strong': 'Fuerte',
    'auth.password.req.min8': 'Al menos 8 caracteres',
    'auth.password.req.lower': 'Incluye una letra minúscula',
    'auth.password.req.upper': 'Incluye una letra mayúscula',
    'auth.password.req.number': 'Incluye un número',
    'auth.password.req.special': 'Incluye un carácter especial',
    'auth.reset.fillAll': 'Completa todos los campos',
    'auth.reset.mismatch': 'Las contraseñas no coinciden',
    'auth.reset.tooWeak': 'La contraseña es demasiado débil. Elige una más segura.',
    'auth.reset.successTitle': 'Éxito',
    'auth.reset.successMessage': 'Contraseña actualizada. Inicia sesión con tu nueva contraseña.',
    'auth.reset.errorTitle': 'Error',
    'auth.reset.errorMessage': 'Ocurrió un error al actualizar la contraseña. Inténtalo de nuevo.',

    'auth.confirm.verified': 'Verificado',
    'auth.confirm.activated': 'Tu cuenta ha sido activada',
    'auth.confirm.thankYou': '¡Gracias por unirte! Haz clic en Siguiente para empezar a usar nuestro producto y servicio.',
    'auth.confirm.next': 'Siguiente',
    'auth.confirm.failed': 'Verificación fallida',
    'auth.confirm.failedFor': 'La verificación de {{email}} falló.',
    'auth.confirm.linkExpired': 'Tu enlace ha expirado. Haz clic en Reenviar para solicitar un nuevo enlace de verificación.',
    'auth.confirm.resend': 'Reenviar',
    'auth.confirm.back': 'Volver',

    'auth.otp.iconAlt': 'Icono de OTP',
    'auth.otp.title': 'Ingresar OTP',
    'auth.otp.sentTo': 'Hemos enviado un código de verificación a {{email}}',
    'auth.otp.instruction': 'Revisa tu correo e ingresa el código de verificación a continuación.',
    'auth.otp.expiresAt': 'Tu código expirará a las {{time}}',
    'auth.otp.verify': 'Verificar',
    'auth.otp.verifying': 'Verificando...',
    'auth.otp.resend': 'Reenviar',
    'auth.otp.resending': 'Reenviando...',
    'auth.otp.resendIn': 'Reenviar ({{seconds}} s)',
    'auth.otp.errorTitle': 'Error',
    'auth.otp.successTitle': 'Éxito',
    'auth.otp.emailMissing': 'No se encontró el correo. Vuelve e inténtalo de nuevo.',
    'auth.otp.invalidLength': 'Ingresa un OTP de 6 dígitos.',
    'auth.otp.verifyFailed': 'La verificación del OTP falló. Inténtalo de nuevo.',
    'auth.otp.resendFailed': 'No se pudo reenviar el OTP. Inténtalo de nuevo.',
    'auth.otp.resendSuccess': 'El OTP se reenvi\u00f3 a tu correo.',

    'auth.category.title': '¿Qué eres?',
    'auth.category.subtitle': '¡Bienvenido! Para darte las herramientas adecuadas, necesitamos saber cómo usarás {{brand}}. Elige el rol que mejor se adapte a tus responsabilidades.',
    'auth.category.iconAlt': 'Icono de {{name}}',
    'auth.category.select': 'Seleccionar',
    'auth.category.loading': 'Cargando...',
    'auth.category.fetchFailed': 'No se pudieron cargar las categorías. Inténtalo de nuevo.',
    'auth.category.selectFailed': 'No se pudo seleccionar la categoría. Inténtalo de nuevo.',
    'auth.category.emailMissing': 'No se encontró el correo del usuario. Regístrate de nuevo.',

    'role.mediaOwners': 'Propietarios de medios',
    'role.advertisers': 'Anunciantes',
    'role.operator': 'Operador',

    'auth.signup.title': 'Regístrate',
    'auth.signup.illustrationAlt': 'Ilustración de registro',
    'auth.signup.emailAddress': 'Dirección de correo',
    'auth.signup.emailPlaceholder': 'you@yourcompany.com',
    'auth.signup.password': 'Contraseña',
    'auth.signup.passwordPlaceholder': 'Contraseña',
    'auth.signup.hint': 'Usa una combinación de minúsculas, mayúsculas, números y símbolos.',
    'auth.signup.agreePrefix': 'Acepto los',
    'auth.signup.termOfService': 'Términos del servicio',
    'auth.signup.privacyPolicy': 'Política de privacidad',
    'auth.signup.andOtherPolicies': 'y otras políticas disponibles en el',
    'auth.signup.legalCenter': 'Centro legal',
    'auth.signup.submit': 'Regístrate',
    'auth.signup.submitting': 'Registrando...',
    'auth.signup.or': 'o',
    'auth.signup.alreadyAccount': '¿Ya tienes una cuenta?',
    'auth.signup.login': 'Iniciar sesión',
    'auth.signup.googleFailed': 'El registro con Google falló. Inténtalo de nuevo.',
    'auth.signup.fillAll': 'Completa todos los campos',
    'auth.signup.emailInvalid': 'Ingresa una dirección de correo válida',
    'auth.signup.acceptTerms': 'Acepta los términos y condiciones',
    'auth.signup.tooWeak': 'La contraseña es demasiado débil. Elige una más segura.',
    'auth.signup.serverIncomplete': 'El registro falló: datos incompletos del servidor.',
    'auth.signup.failed': 'El registro falló. Inténtalo de nuevo.',
    'auth.signup.errorTitle': 'Error',

    'profiling.loading': 'Cargando datos de la encuesta...',
    'profiling.submitting': 'Enviando...',
    'profiling.next': 'Siguiente',
    'profiling.funFact': 'Dato curioso',
    'profiling.errorTitle': 'Error',
    'profiling.emailMissing': 'No se encontró el correo del usuario. Inténtalo de nuevo.',
    'profiling.loadFailed': 'No se pudieron cargar los datos de la encuesta. Inténtalo de nuevo.',
    'profiling.selectAnswer': 'Selecciona una respuesta.',
    'profiling.submitFailed': 'No se pudo enviar la respuesta de la encuesta. Inténtalo de nuevo.',
    'profiling.facts.1': 'Se proyecta que el mercado global de DOOH alcance $58,67 mil millones para 2030<br>¡Tus pantallas pueden ser parte de esta industria en auge!',
    'profiling.facts.2': 'Las vallas digitales pueden aumentar el reconocimiento de marca hasta un 47%<br>Perfecto para atraer atención dentro y fuera de tu tienda.',
    'profiling.facts.3': 'El contenido dinámico mantiene a los espectadores 4 veces más tiempo<br>Usa movimiento y timing para historias de marca más fuertes.',
    'profiling.facts.4': 'El DOOH programático te permite comprar audiencias, no solo ubicaciones<br>Llega a las personas adecuadas en el momento adecuado.',
    'profiling.facts.5': 'Los minoristas con señalización digital en tienda ven aumentos en ventas<br>del 10% al 30% en productos promocionados.',
    'profiling.facts.6': 'El contexto importa: las campañas DOOH pueden adaptarse por tiempo y lugar<br>Las promos de la mañana difieren del ambiente nocturno.',
    'profiling.facts.7': 'Pantallas brillantes mejoran el recuerdo en zonas de alto tráfico<br>La visibilidad impulsa un reconocimiento más rápido.',
    'profiling.facts.8': 'Los mensajes cortos funcionan mejor: a menudo 6–8 palabras bastan<br>Mantén el texto directo y legible de un vistazo.',
    'profiling.facts.9': 'Creatividades activadas por el clima pueden mejorar el rendimiento<br>Alinea promos con lluvia, calor o cielos despejados.',
    'profiling.facts.10': 'El movimiento llama la atención, pero la simplicidad convierte<br>Diseños limpios superan pantallas recargadas.',

    'legal.lastUpdated': 'Última actualización:',

    'legal.tnc.title': 'Términos y condiciones (T&C)',
    'legal.tnc.s1.title': '1. Introducción',
    'legal.tnc.s1.body': 'Bienvenido a {{platformName}} (\"Plataforma\"). Al acceder o usar nuestros servicios, usted (\"Usuario\") acepta cumplir estos Términos y condiciones. Si no está de acuerdo, por favor absténgase de utilizar nuestros servicios.',
    'legal.tnc.s2.title': '2. Definiciones',
    'legal.tnc.s2.platformLabel': 'Plataforma:',
    'legal.tnc.s2.userLabel': 'Usuario:',
    'legal.tnc.s2.publisherLabel': 'Publisher:',
    'legal.tnc.s2.advertiserLabel': 'Advertiser:',
    'legal.tnc.s2.platform': 'La plataforma DigiMax de publicidad digital y gestión de pantallas.',
    'legal.tnc.s2.user': 'Cualquier persona o empresa que use la Plataforma, incluidos propietarios de medios (publishers) y anunciantes (advertisers).',
    'legal.tnc.s2.publisher': 'Un propietario de medios que registra pantallas digitales o ubicaciones en la Plataforma.',
    'legal.tnc.s2.advertiser': 'Una empresa o persona que compra espacios publicitarios en pantallas digitales a través de la Plataforma.',
    'legal.tnc.s3.title': '3. Registro y uso de la cuenta',
    'legal.tnc.s3.b1': 'Los usuarios deben proporcionar información precisa y completa.',
    'legal.tnc.s3.b2': 'Los publishers son responsables de gestionar sus pantallas registradas y garantizar el cumplimiento del contenido.',
    'legal.tnc.s3.b3': 'Los advertisers deben cumplir las regulaciones publicitarias y evitar contenido prohibido (p. ej., ilegal, engañoso o dañino).',
    'legal.tnc.s3.b4': 'La Plataforma se reserva el derecho de suspender o cancelar cuentas que infrinjan estos términos.',
    'legal.tnc.s4.title': '4. Pagos y suscripciones',
    'legal.tnc.s4.b1': 'La Plataforma ofrece planes de suscripción con distintas funciones y cuotas de pantallas.',
    'legal.tnc.s4.b2': 'Los pagos deben realizarse según el plan seleccionado. No renovar puede generar limitaciones en la cuenta.',
    'legal.tnc.s4.b3': 'Las políticas de reembolso, si aplican, se informarán durante el proceso de compra.',
    'legal.tnc.s5.title': '5. Directrices de contenido',
    'legal.tnc.s5.b1': 'Los publishers deben asegurar que las pantallas no muestren contenido prohibido (p. ej., discurso de odio, publicidad falsa, pornografía).',
    'legal.tnc.s5.b2': 'La Plataforma puede eliminar contenido que infrinja políticas o leyes aplicables.',
    'legal.tnc.s6.title': '6. Publicidad de terceros y monetización',
    'legal.tnc.s6.b1': 'Los publishers pueden habilitar anuncios de terceros en sus pantallas y obtener ingresos.',
    'legal.tnc.s6.b2': 'La Plataforma puede ofrecer servicios de agencia publicitaria a publishers que no deseen gestionar ventas directas.',
    'legal.tnc.s6.b3': 'Los detalles de reparto de ingresos se proporcionarán en la configuración de monetización.',
    'legal.tnc.s7.title': '7. Protección de datos y cumplimiento',
    'legal.tnc.s7.b1': 'La Plataforma cumple con la ley PDP de Indonesia, la ley EIT y regulaciones relevantes en SEA.',
    'legal.tnc.s7.b2': 'Los usuarios deben gestionar los datos de clientes de forma responsable y cumplir leyes de privacidad tipo GDPR donde aplique.',
    'legal.tnc.s8.title': '8. Limitaciones del servicio y responsabilidad',
    'legal.tnc.s8.b1': 'La Plataforma no es responsable por caídas, problemas de contenido o pérdidas de ingresos por factores externos (p. ej., cortes de energía, fallas de internet).',
    'legal.tnc.s8.b2': 'Los usuarios son responsables de gestionar sus cuentas, pantallas y campañas de manera efectiva.',
    'legal.tnc.s9.title': '9. Ley aplicable',
    'legal.tnc.s9.b1': 'Estos términos se rigen por la ley de Indonesia, con resolución de disputas mediante arbitraje en Yakarta, Indonesia.',
    'legal.tnc.s9.b2': 'Los usuarios en otros países SEA aceptan cumplir las regulaciones locales al usar la Plataforma.',
    'legal.tnc.s10.title': '10. Cambios en los T&C',
    'legal.tnc.s10.p1': 'Podemos actualizar estos términos en cualquier momento. El uso continuado de la Plataforma implica la aceptación de la versión más reciente.',
    'legal.tnc.s10.p2': 'Si tiene preguntas, contacte a',

    'legal.privacy.title': 'Política de privacidad',
    'legal.privacy.s1.title': '1. Introducción',
    'legal.privacy.s1.body': 'DigiMax (\"Plataforma\") valora su privacidad y se compromete a proteger sus datos personales. Esta Política de privacidad describe cómo recopilamos, usamos y almacenamos datos en cumplimiento de la ley PDP de Indonesia, leyes de privacidad SEA y GDPR cuando corresponda.',
    'legal.privacy.s2.title': '2. Datos que recopilamos',
    'legal.privacy.s2.lead': 'Recopilamos los siguientes tipos de datos:',
    'legal.privacy.s2.b1.label': 'Información de la cuenta:',
    'legal.privacy.s2.b1.body': 'Nombre, correo, número de teléfono, detalles de pago.',
    'legal.privacy.s2.b2.label': 'Datos publicitarios:',
    'legal.privacy.s2.b2.body': 'Contenido del anuncio, analítica de audiencia y datos de rendimiento de pantallas.',
    'legal.privacy.s2.b3.label': 'Datos del dispositivo y uso:',
    'legal.privacy.s2.b3.body': 'Dirección IP, actividad de inicio de sesión, tipo de dispositivo y comportamiento de navegación.',
    'legal.privacy.s3.title': '3. Cómo usamos sus datos',
    'legal.privacy.s3.b1': 'Para proporcionar y mejorar los servicios de la Plataforma.',
    'legal.privacy.s3.b2': 'Para procesar pagos y gestionar suscripciones.',
    'legal.privacy.s3.b3': 'Para mostrar anuncios dirigidos (solo si el usuario habilita anuncios de terceros).',
    'legal.privacy.s3.b4': 'Para cumplir requisitos legales y prevenir fraude.',
    'legal.privacy.s4.title': '4. Almacenamiento y seguridad de datos',
    'legal.privacy.s4.b1': 'Los datos se almacenan de forma segura en Indonesia y centros de datos regionales SEA.',
    'legal.privacy.s4.b2': 'Usamos cifrado, firewalls y controles de acceso seguros para proteger la información.',
    'legal.privacy.s5.title': '5. Compartir con terceros',
    'legal.privacy.s5.b1': 'No vendemos datos personales.',
    'legal.privacy.s5.b2': 'Podemos compartir datos con socios publicitarios (si la monetización está habilitada) y procesadores de pago para transacciones.',
    'legal.privacy.s5.b3': 'Según leyes tipo GDPR, los usuarios pueden solicitar acceso, correcciones o eliminación de datos.',
    'legal.privacy.s6.title': '6. Cookies y seguimiento',
    'legal.privacy.s6.body1': 'Usamos cookies para autenticación, analítica y segmentación publicitaria.',
    'legal.privacy.s6.seeOur': 'Consulta nuestra',
    'legal.privacy.s6.cookiePolicy': 'Política de cookies',
    'legal.privacy.s6.body2': 'para más detalles.',
    'legal.privacy.s7.title': '7. Derechos del usuario',
    'legal.privacy.s7.b1': 'Los usuarios pueden acceder, modificar o eliminar datos personales desde la configuración de su cuenta.',
    'legal.privacy.s7.b2': 'Los usuarios pueden optar por no recibir anuncios dirigidos y seguimiento de cookies.',
    'legal.privacy.s8.title': '8. Cambios en la Política de privacidad',
    'legal.privacy.s8.body': 'Podemos actualizar esta Política de privacidad. Los usuarios serán notificados de cambios significativos.',
    'legal.privacy.footer': 'Para consultas, contacte a'
  }
};
